import _, { omit, cloneDeep } from 'lodash';
import React, { useState, useEffect, useMemo, Fragment, forwardRef, useImperativeHandle, useRef, useCallback, createContext, useContext } from 'react';
import Color from 'color';
import { Tooltip as Tooltip$1, Switch, makeStyles as makeStyles$1, SvgIcon, Breadcrumbs, Typography as Typography$1, useTheme, createStyles as createStyles$1, List, ListSubheader, ListItem, ListItemText, Checkbox as Checkbox$1, useMediaQuery, FormControl, Select, MenuItem, TextField, InputAdornment, Dialog, Snackbar, SnackbarContent, Drawer, Collapse, Divider, ListItemIcon, Badge, FormControlLabel, Radio, InputLabel, Menu } from '@material-ui/core';
import MUIButton from '@material-ui/core/Button/Button';
import { makeStyles, createStyles } from '@material-ui/styles';
import clsx from 'clsx';
import SvgIcon$1 from '@material-ui/core/SvgIcon';
import Link from '@material-ui/core/Link';
import { InfiniteLoader as InfiniteLoader$1, WindowScroller, AutoSizer, List as List$1 } from 'react-virtualized';
import Popover from '@material-ui/core/Popover';
import qs from 'query-string';
import { InfoOutlined } from '@material-ui/icons';
import { useLocation, Link as Link$1 } from 'react-router-dom';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}

function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
} // green


var green = '#48D2A0';
var greenHover = '#44BF93';
var green25 = Color(green).alpha(0.25).toString();
var green10 = Color(green).alpha(0.1).toString(); // red

var red = '#CE505E';
var red25 = Color(red).alpha(0.25).toString();
var red10 = Color(red).alpha(0.1).toString(); // yellow

var yellow = '#F8C51C';
var yellow25 = Color(yellow).alpha(0.25).toString();
var yellow10 = Color(yellow).alpha(0.1).toString(); // dark

var dark = '#293833';
var darkHover = '#3E4C47';
var darkBorder = '#CCCFCE';
var dark75 = Color(dark).alpha(0.75).toString();
var dark72 = 'rgba(101, 112, 108, 1)';
var dark50 = Color(dark).alpha(0.5).toString();
var dark25 = Color(dark).alpha(0.25).toString();
var dark24 = 'rgba(204, 207, 206, 1)';
var dark12 = 'rgba(229, 231, 230, 1)';
var dark10 = Color(dark).alpha(0.1).toString();
var dark5 = Color(dark).alpha(0.05).toString();
var dark4 = 'rgba(246, 247, 247, 1)'; // blue

var blue = '#2AA7DC';
var blueHover = '#2A9AC8';
var blue25 = Color(blue).alpha(0.25).toString();
var blue10 = Color(blue).alpha(0.1).toString(); // other

var purple = '#ba5bb7';

var Button = function Button(props) {
  var buttonStyle = props.buttonStyle,
      className = props.className,
      loading = props.loading,
      text = props.text,
      loadingText = props.loadingText,
      hoverText = props.hoverText,
      disabled = props.disabled,
      children = props.children,
      tooltipText = props.tooltipText,
      _onClick = props.onClick,
      other = __rest(props, ["buttonStyle", "className", "loading", "text", "loadingText", "hoverText", "disabled", "children", "tooltipText", "onClick"]);

  var classes = makeButtonStyle(buttonStyle);

  var _a = useState(false),
      hover = _a[0],
      setHover = _a[1];

  return React.createElement(Tooltip$1, {
    title: tooltipText !== null && tooltipText !== void 0 ? tooltipText : ''
  }, React.createElement(MUIButton, _assign({
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    variant: 'contained',
    className: clsx(classes.root, loading && classes.loading, disabled && classes.disable + " nohover", className),
    disableTouchRipple: true,
    onClick: function onClick(e) {
      return !disabled && !loading && _onClick && _onClick(e);
    }
  }, other), loading ? loadingText : hover && hoverText ? hoverText : text, renderChildren(children)));
};

var renderChildren = function renderChildren(children) {
  if (!children) return React.createElement(React.Fragment, null);
  return React.createElement(React.Fragment, null, Array.isArray(children) ? children.map(function (child, index) {
    return React.cloneElement(child, {
      key: index
    });
  }) : React.cloneElement(children));
};

var disabledCSS = {
  backgroundColor: dark5,
  color: dark25,
  border: "1px solid " + dark10,
  cursor: 'default'
};

var makeButtonCSS = function makeButtonCSS(textColor, defaultBackgroundColor, actionBackgroundColor, borderColor, injectButtonStyle) {
  var generalCSS = {
    color: textColor,
    border: 'unset'
  };

  var hoverPressedAndLoadingCSS = _assign(_assign({}, generalCSS), {
    backgroundColor: actionBackgroundColor
  });

  var defaultCSS = _assign(_assign({}, generalCSS), {
    backgroundColor: defaultBackgroundColor
  });

  return {
    defaultCSS: _assign(_assign({
      minWidth: 'unset',
      backgroundColor: defaultBackgroundColor
    }, generalCSS), injectButtonStyle === null || injectButtonStyle === void 0 ? void 0 : injectButtonStyle.defaultCSS),
    hoverCSS: _assign(_assign({}, hoverPressedAndLoadingCSS), injectButtonStyle === null || injectButtonStyle === void 0 ? void 0 : injectButtonStyle.hoverCSS),
    pressedCSS: _assign(_assign({}, hoverPressedAndLoadingCSS), injectButtonStyle === null || injectButtonStyle === void 0 ? void 0 : injectButtonStyle.pressedCSS),
    focusedCSS: _assign(_assign(_assign({}, defaultCSS), {
      border: "2px solid " + borderColor
    }), injectButtonStyle === null || injectButtonStyle === void 0 ? void 0 : injectButtonStyle.focusedCSS),
    loadingCSS: _assign(_assign({
      cursor: 'default'
    }, hoverPressedAndLoadingCSS), injectButtonStyle === null || injectButtonStyle === void 0 ? void 0 : injectButtonStyle.loadingCSS),
    disabledCSS: _assign(_assign({}, disabledCSS), injectButtonStyle === null || injectButtonStyle === void 0 ? void 0 : injectButtonStyle.disabledCSS)
  };
};

var makeButtonStyle = function makeButtonStyle(props) {
  return makeStyles(function () {
    return {
      root: _assign(_assign({}, props.defaultCSS), {
        '&:hover:not(.nohover)': _assign({}, props.hoverCSS),
        '&:active': _assign({}, props.pressedCSS),
        '&.Mui-focusVisible': _assign({}, props.focusedCSS)
      }),
      disable: _assign(_assign({}, props.disabledCSS), {
        '&:hover': _assign({}, props.disabledCSS)
      }),
      loading: _assign({}, props.loadingCSS)
    };
  })();
};

var getLocalButtonStyle = function getLocalButtonStyle() {
  return makeButtonCSS('white', green, greenHover, dark12);
};

var localButtonStyle = getLocalButtonStyle();

var PrimaryButton = function PrimaryButton(_a) {
  var externalButtonStyle = _a.buttonStyle,
      props = __rest(_a, ["buttonStyle"]);

  return React.createElement(Button, _assign({
    buttonStyle: _.merge(getLocalButtonStyle(), externalButtonStyle)
  }, props));
};

var getLocalButtonStyle$1 = function getLocalButtonStyle$1() {
  return makeButtonCSS(green, green10, green25, green25);
};

var localButtonStyle$1 = getLocalButtonStyle$1();

var PrimaryOffsetButton = function PrimaryOffsetButton(_a) {
  var externalButtonStyle = _a.buttonStyle,
      props = __rest(_a, ["buttonStyle"]);

  return React.createElement(Button, _assign({
    buttonStyle: _.merge(getLocalButtonStyle$1(), externalButtonStyle)
  }, props));
};

var useStyles = makeStyles(function (theme) {
  return {
    root: {
      width: 44,
      height: 22,
      padding: 0,
      display: 'flex',
      borderRadius: 12,
      border: "1px solid " + dark10,
      marginLeft: 12
    },
    switchBase: {
      padding: theme.spacing(0.5),
      color: dark50
    },
    thumb: {
      width: 12,
      height: 12,
      boxShadow: 'none'
    },
    track: {
      opacity: 1,
      background: dark5
    },
    checked: {
      '&$switchBase': {
        color: 'white'
      },
      '& + $track': {
        backgroundColor: green + "!important",
        opacity: '1!important'
      }
    }
  };
});

var ToggleButton = function ToggleButton(props) {
  var classes = useStyles();

  var className = props.className,
      other = __rest(props, ["className"]);

  return React.createElement(Switch, _assign({
    classes: {
      root: classes.root,
      switchBase: classes.switchBase,
      thumb: classes.thumb,
      track: classes.track,
      checked: classes.checked
    },
    className: className
  }, other));
};

var getLocalButtonStyle$2 = function getLocalButtonStyle$2() {
  return makeButtonCSS(dark72, dark12, dark24, dark24);
};

var localButtonStyle$2 = getLocalButtonStyle$2();

var SecondaryButton = function SecondaryButton(_a) {
  var externalButtonStyle = _a.buttonStyle,
      props = __rest(_a, ["buttonStyle"]);

  return React.createElement(Button, _assign({
    buttonStyle: _.merge(getLocalButtonStyle$2(), externalButtonStyle)
  }, props));
};

var getLocalButtonStyle$3 = function getLocalButtonStyle$3() {
  return makeButtonCSS(red, red10, red25, red25);
};

var localButtonStyle$3 = getLocalButtonStyle$3();

var DangerButton = function DangerButton(_a) {
  var externalButtonStyle = _a.buttonStyle,
      props = __rest(_a, ["buttonStyle"]);

  return React.createElement(Button, _assign({
    buttonStyle: _.merge(getLocalButtonStyle$3(), externalButtonStyle)
  }, props));
};

var getLocalButtonStyle$4 = function getLocalButtonStyle$4() {
  return makeButtonCSS('white', dark, darkHover, darkBorder, {
    defaultCSS: {
      minWidth: 150,
      minHeight: 50
    }
  });
};

var localButtonStyle$4 = getLocalButtonStyle$4();

var SubmitButton = function SubmitButton(_a) {
  var externalButtonStyle = _a.buttonStyle,
      props = __rest(_a, ["buttonStyle"]);

  return React.createElement(Button, _assign({
    buttonStyle: _.merge(getLocalButtonStyle$4(), externalButtonStyle)
  }, props));
};

var getLocalButtonStyle$5 = function getLocalButtonStyle$5() {
  return makeButtonCSS('white', blue, blueHover, dark12);
};

var localButtonStyle$5 = getLocalButtonStyle$5();

var ExtraActionButton = function ExtraActionButton(_a) {
  var externalButtonStyle = _a.buttonStyle,
      props = __rest(_a, ["buttonStyle"]);

  return React.createElement(Button, _assign({
    buttonStyle: _.merge(getLocalButtonStyle$5(), externalButtonStyle)
  }, props));
};

var getLocalButtonStyle$6 = function getLocalButtonStyle$6() {
  return makeButtonCSS('unset', 'unset', dark5, 'unset');
};

var localButtonStyle$6 = getLocalButtonStyle$6();

var InvisibleButton = function InvisibleButton(_a) {
  var externalButtonStyle = _a.buttonStyle,
      props = __rest(_a, ["buttonStyle"]);

  return React.createElement(Button, _assign({
    buttonStyle: _.merge(getLocalButtonStyle$6(), externalButtonStyle)
  }, props));
};

var getLocalButtonStyle$7 = function getLocalButtonStyle$7() {
  return makeButtonCSS(blue, blue10, blue25, blue25);
};

var localButtonStyle$7 = getLocalButtonStyle$7();

var ExtraActionOffsetButton = function ExtraActionOffsetButton(_a) {
  var externalButtonStyle = _a.buttonStyle,
      props = __rest(_a, ["buttonStyle"]);

  return React.createElement(Button, _assign({
    buttonStyle: _.merge(getLocalButtonStyle$7(), externalButtonStyle)
  }, props));
};

var useIconStyles = makeStyles$1(function () {
  return {
    icon: {
      fontSize: function fontSize(_a) {
        var size = _a.size;
        return size === 'medium' ? 24 : 16;
      }
    }
  };
}, {
  index: 1
}); // a little wrapper that abstracts away clsx logic and passing size into makeStyles

var useIconClassname = function useIconClassname(size) {
  var classes = useIconStyles({
    size: size
  });

  var mergeClasses = function mergeClasses(className) {
    return clsx(className, classes.icon);
  };

  return {
    mergeClasses: mergeClasses
  };
};

function ArchiveIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 6C4.25 5.58579 4.58579 5.25 5 5.25H19C19.4142 5.25 19.75 5.58579 19.75 6V10C19.75 10.4142 19.4142 10.75 19 10.75H18.75V18C18.75 18.4142 18.4142 18.75 18 18.75H6C5.58579 18.75 5.25 18.4142 5.25 18V10.75H5C4.58579 10.75 4.25 10.4142 4.25 10V6ZM17.25 17.25V10.75H6.75V17.25H17.25ZM18.25 9.25H18H6H5.75V6.75H18.25V9.25ZM9.75 12.25C9.33579 12.25 9 12.5858 9 13C9 13.4142 9.33579 13.75 9.75 13.75H14.25C14.6642 13.75 15 13.4142 15 13C15 12.5858 14.6642 12.25 14.25 12.25H9.75Z",
    fill: color
  }));
}

function ArrowIcon(props) {
  var _a = props.direction,
      direction = _a === void 0 ? 'right' : _a,
      _b = props.color,
      color = _b === void 0 ? '#fff' : _b,
      _c = props.size,
      size = _c === void 0 ? 'medium' : _c,
      className = props.className,
      otherProps = __rest(props, ["direction", "color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  var down = React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 5C12.75 4.58579 12.4142 4.25 12 4.25C11.5858 4.25 11.25 4.58579 11.25 5V17.1893L5.53033 11.4697C5.23744 11.1768 4.76256 11.1768 4.46967 11.4697C4.17678 11.7626 4.17678 12.2374 4.46967 12.5303L11.4697 19.5303C11.5416 19.6022 11.6245 19.6565 11.7129 19.6931C11.8013 19.7298 11.8983 19.75 12 19.75C12.1017 19.75 12.1987 19.7298 12.2871 19.6931C12.3755 19.6565 12.4584 19.6022 12.5303 19.5303L19.5303 12.5303C19.8232 12.2374 19.8232 11.7626 19.5303 11.4697C19.2374 11.1768 18.7626 11.1768 18.4697 11.4697L12.75 17.1893V5Z",
    fill: color
  });
  var left = React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5303 5.53033C12.8232 5.23744 12.8232 4.76256 12.5303 4.46967C12.2374 4.17678 11.7626 4.17678 11.4697 4.46967L4.46967 11.4697C4.39776 11.5416 4.34351 11.6245 4.30691 11.7129C4.27024 11.8013 4.25 11.8983 4.25 12C4.25 12.1017 4.27024 12.1987 4.30691 12.2871C4.34351 12.3755 4.39776 12.4584 4.46967 12.5303L11.4697 19.5303C11.7626 19.8232 12.2374 19.8232 12.5303 19.5303C12.8232 19.2374 12.8232 18.7626 12.5303 18.4697L6.81066 12.75H19C19.4142 12.75 19.75 12.4142 19.75 12C19.75 11.5858 19.4142 11.25 19 11.25H6.81066L12.5303 5.53033Z",
    fill: color
  });
  var right = React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5303 4.46967C12.2374 4.17678 11.7626 4.17678 11.4697 4.46967C11.1768 4.76256 11.1768 5.23744 11.4697 5.53033L17.1893 11.25H5C4.58579 11.25 4.25 11.5858 4.25 12C4.25 12.4142 4.58579 12.75 5 12.75H17.1893L11.4697 18.4697C11.1768 18.7626 11.1768 19.2374 11.4697 19.5303C11.7626 19.8232 12.2374 19.8232 12.5303 19.5303L19.5303 12.5303C19.6768 12.3839 19.75 12.1919 19.75 12C19.75 11.8983 19.7298 11.8013 19.6931 11.7129C19.6565 11.6245 19.6022 11.5416 19.5303 11.4697L12.5303 4.46967Z",
    fill: color
  });
  var up = React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7129 4.30691C11.6245 4.34351 11.5416 4.39776 11.4697 4.46967L4.46967 11.4697C4.17678 11.7626 4.17678 12.2374 4.46967 12.5303C4.76256 12.8232 5.23744 12.8232 5.53033 12.5303L11.25 6.81066V19C11.25 19.4142 11.5858 19.75 12 19.75C12.4142 19.75 12.75 19.4142 12.75 19V6.81066L18.4697 12.5303C18.7626 12.8232 19.2374 12.8232 19.5303 12.5303C19.8232 12.2374 19.8232 11.7626 19.5303 11.4697L12.5303 4.46967C12.3845 4.3238 12.1934 4.25057 12.0022 4.25C12.0015 4.25 12.0008 4.25 12 4.25C11.9992 4.25 11.9985 4.25 11.9978 4.25C11.8969 4.2503 11.8007 4.27051 11.7129 4.30691Z",
    fill: color
  });
  var arrow = right;

  switch (direction) {
    case 'up':
      arrow = up;
      break;

    case 'down':
      arrow = down;
      break;

    case 'left':
      arrow = left;
      break;
  }

  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), arrow);
}

function CheckIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5384 7.47789C18.8268 7.77526 18.8195 8.25007 18.5221 8.53843L10.2721 16.5384C9.98119 16.8205 9.51881 16.8205 9.22789 16.5384L5.47789 12.9021C5.18053 12.6137 5.17322 12.1389 5.46158 11.8415C5.74993 11.5442 6.22475 11.5369 6.52211 11.8252L9.75 14.9553L17.4779 7.46158C17.7753 7.17322 18.2501 7.18053 18.5384 7.47789Z",
    fill: color
  }));
}

function ChevronIcon(props) {
  var _a = props.direction,
      direction = _a === void 0 ? 'right' : _a,
      _b = props.color,
      color = _b === void 0 ? '#fff' : _b,
      _c = props.size,
      size = _c === void 0 ? 'medium' : _c,
      className = props.className,
      otherProps = __rest(props, ["direction", "color", "size", "className"]);

  var down = React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.46967 9.46967C7.76256 9.17678 8.23744 9.17678 8.53033 9.46967L12 12.9393L15.4697 9.46967C15.7626 9.17678 16.2374 9.17678 16.5303 9.46967C16.8232 9.76256 16.8232 10.2374 16.5303 10.5303L12.5303 14.5303C12.2374 14.8232 11.7626 14.8232 11.4697 14.5303L7.46967 10.5303C7.17678 10.2374 7.17678 9.76256 7.46967 9.46967Z",
    fill: color
  });
  var left = React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5303 7.46967C14.8232 7.76256 14.8232 8.23744 14.5303 8.53033L11.0607 12L14.5303 15.4697C14.8232 15.7626 14.8232 16.2374 14.5303 16.5303C14.2374 16.8232 13.7626 16.8232 13.4697 16.5303L9.46967 12.5303C9.17678 12.2374 9.17678 11.7626 9.46967 11.4697L13.4697 7.46967C13.7626 7.17678 14.2374 7.17678 14.5303 7.46967Z",
    fill: color
  });
  var right = React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.46967 7.46967C9.76256 7.17678 10.2374 7.17678 10.5303 7.46967L14.5303 11.4697C14.8232 11.7626 14.8232 12.2374 14.5303 12.5303L10.5303 16.5303C10.2374 16.8232 9.76256 16.8232 9.46967 16.5303C9.17678 16.2374 9.17678 15.7626 9.46967 15.4697L12.9393 12L9.46967 8.53033C9.17678 8.23744 9.17678 7.76256 9.46967 7.46967Z",
    fill: color
  });
  var up = React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4697 9.46967C11.7626 9.17678 12.2374 9.17678 12.5303 9.46967L16.5303 13.4697C16.8232 13.7626 16.8232 14.2374 16.5303 14.5303C16.2374 14.8232 15.7626 14.8232 15.4697 14.5303L12 11.0607L8.53033 14.5303C8.23744 14.8232 7.76256 14.8232 7.46967 14.5303C7.17678 14.2374 7.17678 13.7626 7.46967 13.4697L11.4697 9.46967Z",
    fill: color
  });
  var mergeClasses = useIconClassname(size).mergeClasses;
  var arrow = right;

  switch (direction) {
    case 'up':
      arrow = up;
      break;

    case 'down':
      arrow = down;
      break;

    case 'left':
      arrow = left;
      break;
  }

  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), arrow);
}

function CloseIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8016 6.15643C19.0661 5.89188 19.0661 5.46296 18.8016 5.19841C18.537 4.93386 18.1081 4.93386 17.8436 5.19841L12 11.042L6.15643 5.19841C5.89188 4.93386 5.46296 4.93386 5.19841 5.19841C4.93386 5.46296 4.93386 5.89188 5.19841 6.15643L11.042 12L5.19841 17.8436C4.93386 18.1081 4.93386 18.537 5.19841 18.8016C5.46296 19.0661 5.89188 19.0661 6.15643 18.8016L12 12.958L17.8436 18.8016C18.1081 19.0661 18.537 19.0661 18.8016 18.8016C19.0661 18.537 19.0661 18.1081 18.8016 17.8436L12.958 12L18.8016 6.15643Z",
    fill: color
  }));
}

function CommentIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.55556 5.75C6.34191 5.75 6.13701 5.83487 5.98594 5.98594C5.83487 6.13701 5.75 6.34191 5.75 6.55556V17.1893L7.58078 15.3586C7.72143 15.2179 7.9122 15.1389 8.11111 15.1389H17.4444C17.6581 15.1389 17.863 15.054 18.0141 14.9029C18.1651 14.7519 18.25 14.547 18.25 14.3333V6.55556C18.25 6.34191 18.1651 6.13701 18.0141 5.98594C17.863 5.83487 17.6581 5.75 17.4444 5.75H6.55556ZM4.92528 4.92528C5.35766 4.49291 5.94408 4.25 6.55556 4.25H17.4444C18.0559 4.25 18.6423 4.49291 19.0747 4.92528C19.5071 5.35766 19.75 5.94408 19.75 6.55556V14.3333C19.75 14.9448 19.5071 15.5312 19.0747 15.9636C18.6423 16.396 18.0559 16.6389 17.4444 16.6389H8.42177L5.53033 19.5303C5.31583 19.7448 4.99324 19.809 4.71299 19.6929C4.43273 19.5768 4.25 19.3033 4.25 19V6.55556C4.25 5.94408 4.49291 5.35766 4.92528 4.92528Z",
    fill: color
  }));
}

function CompareIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 20.25C11.25 20.6642 11.5858 21 12 21C12.4142 21 12.75 20.6642 12.75 20.25V3.75C12.75 3.33579 12.4142 3 12 3C11.5858 3 11.25 3.33579 11.25 3.75V20.25ZM10 4.25H5.77778C4.47893 4.25 3.25 5.19129 3.25 6.55556V17.4444C3.25 18.8087 4.47893 19.75 5.77778 19.75H10V15.0004H7.38003C7.21934 15.0004 7.12426 14.8205 7.21478 14.6877L9.52864 11.2941C9.61648 11.1652 9.81143 11.182 9.87596 11.324L10 11.5969V4.25ZM14 19.75H18.2222C19.5211 19.75 20.75 18.8087 20.75 17.4444V6.55556C20.75 5.19129 19.5211 4.25 18.2222 4.25H14V5.75H18.2222C18.8871 5.75 19.25 6.2016 19.25 6.55556V17.4444C19.25 17.7984 18.8871 18.25 18.2222 18.25H14V19.75ZM14 15.0004H16.6465C16.8024 15.0004 16.8983 14.83 16.8176 14.6967L14 10.0477V15.0004Z",
    fill: color
  }));
}

function CopyIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0191 4.98094C19.1669 5.1288 19.25 5.32935 19.25 5.53846V12.4615C19.25 12.6707 19.1669 12.8712 19.0191 13.0191C18.8712 13.1669 18.6707 13.25 18.4615 13.25H17.6923H17C16.5858 13.25 16.25 13.5858 16.25 14C16.25 14.4142 16.5858 14.75 17 14.75H17.6923H18.4615C19.0685 14.75 19.6506 14.5089 20.0797 14.0797C20.5089 13.6506 20.75 13.0685 20.75 12.4615V5.53846C20.75 4.93152 20.5089 4.34945 20.0797 3.92028C19.6506 3.49111 19.0685 3.25 18.4615 3.25H11.5385C10.9315 3.25 10.3494 3.49111 9.92028 3.92027C9.49111 4.34944 9.25 4.93152 9.25 5.53846V6.30769V7C9.25 7.41421 9.58579 7.75 10 7.75C10.4142 7.75 10.75 7.41421 10.75 7V6.30769V5.53846C10.75 5.32935 10.8331 5.1288 10.9809 4.98093C11.1288 4.83307 11.3293 4.75 11.5385 4.75L18.4615 4.75C18.6707 4.75 18.8712 4.83307 19.0191 4.98094ZM4.75 11.5385C4.75 11.103 5.10301 10.75 5.53846 10.75H12.4615C12.897 10.75 13.25 11.103 13.25 11.5385V18.4615C13.25 18.897 12.897 19.25 12.4615 19.25H5.53846C5.10301 19.25 4.75 18.897 4.75 18.4615V11.5385ZM5.53846 9.25C4.27458 9.25 3.25 10.2746 3.25 11.5385V18.4615C3.25 19.7254 4.27458 20.75 5.53846 20.75H12.4615C13.7254 20.75 14.75 19.7254 14.75 18.4615V11.5385C14.75 10.2746 13.7254 9.25 12.4615 9.25H5.53846Z",
    fill: color
  }));
}

function CounterpartyIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 6.75C9.0335 6.75 8.25 7.5335 8.25 8.5C8.25 9.4665 9.0335 10.25 10 10.25C10.9665 10.25 11.75 9.4665 11.75 8.5C11.75 7.5335 10.9665 6.75 10 6.75ZM6.75 8.5C6.75 6.70507 8.20507 5.25 10 5.25C11.7949 5.25 13.25 6.70507 13.25 8.5C13.25 10.2949 11.7949 11.75 10 11.75C8.20507 11.75 6.75 10.2949 6.75 8.5ZM5.25072 14.2507C5.89147 13.61 6.76051 13.25 7.66667 13.25H12.3333C13.2395 13.25 14.1085 13.61 14.7493 14.2507C15.39 14.8915 15.75 15.7605 15.75 16.6667V18C15.75 18.4142 15.4142 18.75 15 18.75H5C4.58579 18.75 4.25 18.4142 4.25 18V16.6667C4.25 15.7605 4.60997 14.8915 5.25072 14.2507ZM5.75 17.25H14.25V16.6667C14.25 16.1583 14.0481 15.6708 13.6886 15.3114C13.3292 14.9519 12.8417 14.75 12.3333 14.75H7.66667C7.15834 14.75 6.67082 14.9519 6.31138 15.3114C5.95193 15.6708 5.75 16.1583 5.75 16.6667V17.25ZM16.5303 8.46967C16.2374 8.17678 15.7626 8.17678 15.4697 8.46967C15.1768 8.76256 15.1768 9.23744 15.4697 9.53033L16.4393 10.5L15.4697 11.4697C15.1768 11.7626 15.1768 12.2374 15.4697 12.5303C15.7626 12.8232 16.2374 12.8232 16.5303 12.5303L17.5 11.5607L18.4697 12.5303C18.7626 12.8232 19.2374 12.8232 19.5303 12.5303C19.8232 12.2374 19.8232 11.7626 19.5303 11.4697L18.5607 10.5L19.5303 9.53033C19.8232 9.23744 19.8232 8.76256 19.5303 8.46967C19.2374 8.17678 18.7626 8.17678 18.4697 8.46967L17.5 9.43934L16.5303 8.46967Z",
    fill: color
  }));
}

function DotsIcon(props) {
  var _a = props.direction,
      direction = _a === void 0 ? 'vertical' : _a,
      _b = props.color,
      color = _b === void 0 ? '#fff' : _b,
      _c = props.size,
      size = _c === void 0 ? 'medium' : _c,
      className = props.className,
      otherProps = __rest(props, ["direction", "color", "size", "className"]);

  var horizontal = React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 10.25C4.0335 10.25 3.25 11.0335 3.25 12C3.25 12.9665 4.0335 13.75 5 13.75C5.9665 13.75 6.75 12.9665 6.75 12C6.75 11.0335 5.9665 10.25 5 10.25ZM12 10.25C11.0335 10.25 10.25 11.0335 10.25 12C10.25 12.9665 11.0335 13.75 12 13.75C12.9665 13.75 13.75 12.9665 13.75 12C13.75 11.0335 12.9665 10.25 12 10.25ZM19 10.25C18.0335 10.25 17.25 11.0335 17.25 12C17.25 12.9665 18.0335 13.75 19 13.75C19.9665 13.75 20.75 12.9665 20.75 12C20.75 11.0335 19.9665 10.25 19 10.25Z",
    fill: color
  });
  var vertical = React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.25C11.0335 3.25 10.25 4.0335 10.25 5C10.25 5.9665 11.0335 6.75 12 6.75C12.9665 6.75 13.75 5.9665 13.75 5C13.75 4.0335 12.9665 3.25 12 3.25ZM12 10.25C11.0335 10.25 10.25 11.0335 10.25 12C10.25 12.9665 11.0335 13.75 12 13.75C12.9665 13.75 13.75 12.9665 13.75 12C13.75 11.0335 12.9665 10.25 12 10.25ZM12 17.25C11.0335 17.25 10.25 18.0335 10.25 19C10.25 19.9665 11.0335 20.75 12 20.75C12.9665 20.75 13.75 19.9665 13.75 19C13.75 18.0335 12.9665 17.25 12 17.25Z",
    fill: color
  });
  var mergeClasses = useIconClassname(size).mergeClasses;
  var dots = vertical;

  switch (direction) {
    case 'horizontal':
      dots = horizontal;
      break;
  }

  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), dots);
}

function DownloadIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.25C12.4142 4.25 12.75 4.58579 12.75 5V14.1893L17.4697 9.46967C17.7626 9.17678 18.2374 9.17678 18.5303 9.46967C18.8232 9.76256 18.8232 10.2374 18.5303 10.5303L12.5303 16.5303C12.2374 16.8232 11.7626 16.8232 11.4697 16.5303L5.46967 10.5303C5.17678 10.2374 5.17678 9.76256 5.46967 9.46967C5.76256 9.17678 6.23744 9.17678 6.53033 9.46967L11.25 14.1893V5C11.25 4.58579 11.5858 4.25 12 4.25ZM5 13.25C5.41421 13.25 5.75 13.5858 5.75 14V17.3333C5.75 17.5925 5.84657 17.8315 6.0039 18.0001C6.1596 18.1669 6.35926 18.25 6.55556 18.25H17.4444C17.6407 18.25 17.8404 18.1669 17.9961 18.0001C18.1534 17.8315 18.25 17.5925 18.25 17.3333V14C18.25 13.5858 18.5858 13.25 19 13.25C19.4142 13.25 19.75 13.5858 19.75 14V17.3333C19.75 17.9582 19.5188 18.567 19.0927 19.0236C18.6649 19.4819 18.0733 19.75 17.4444 19.75H6.55556C5.92673 19.75 5.33507 19.4819 4.90732 19.0236C4.4812 18.567 4.25 17.9582 4.25 17.3333V14C4.25 13.5858 4.58579 13.25 5 13.25Z",
    fill: color
  }));
}

function FileIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 3.25C6.88707 3.25 6.30985 3.51016 5.89219 3.95567C5.47606 4.39955 5.25 4.9918 5.25 5.6V18.4C5.25 19.0082 5.47606 19.6005 5.89219 20.0443C6.30985 20.4898 6.88707 20.75 7.5 20.75H16.5C17.1129 20.75 17.6901 20.4898 18.1078 20.0443C18.5239 19.6005 18.75 19.0082 18.75 18.4V9.6C18.75 9.40946 18.6775 9.22605 18.5472 9.08704L13.2972 3.48704C13.1554 3.33581 12.9573 3.25 12.75 3.25H7.5ZM6.98649 4.98158C7.13143 4.82698 7.31728 4.75 7.5 4.75H12.25V10C12.25 10.4142 12.5858 10.75 13 10.75H17.25V18.4C17.25 18.6405 17.16 18.8622 17.0135 19.0184C16.8686 19.173 16.6827 19.25 16.5 19.25H7.5C7.31728 19.25 7.13143 19.173 6.98649 19.0184C6.84001 18.8622 6.75 18.6405 6.75 18.4V5.6C6.75 5.35951 6.84002 5.13783 6.98649 4.98158ZM16.6438 9.25L13.75 6.16325V9.25H16.6438Z",
    fill: color
  }));
}

function FilterIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? dark75 : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33093 4.66112C4.45866 4.40894 4.71733 4.25 5 4.25H19C19.2827 4.25 19.5413 4.40894 19.6691 4.66112C19.7968 4.91329 19.7719 5.21586 19.6046 5.44375L14.35 12.6035V19C14.35 19.2584 14.2169 19.4987 13.9979 19.6358C13.7788 19.7729 13.5045 19.7875 13.2721 19.6745L10.0721 18.119C9.8139 17.9935 9.65 17.7315 9.65 17.4444V12.6035L4.39537 5.44375C4.22812 5.21586 4.2032 4.91329 4.33093 4.66112ZM6.48075 5.75L11.0046 11.914C11.0991 12.0427 11.15 12.1982 11.15 12.3578V16.9751L12.85 17.8015V12.3578C12.85 12.1982 12.9009 12.0427 12.9954 11.914L17.5193 5.75H6.48075Z",
    fill: color
  }));
}

function FingerprintIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.89496 16.095C7.49677 16.3356 7.38579 16.8552 7.58029 17.2778C7.89156 17.9542 7.98739 18.5559 8.01689 19.1685C8.03898 19.6273 8.40236 20 8.86167 20C9.32098 20 9.70054 19.6274 9.68134 19.1685C9.64646 18.3347 9.50999 17.4182 8.97603 16.3722C8.77422 15.9768 8.2749 15.8655 7.89496 16.095ZM15.934 5.09103C13.8325 3.90795 8.48742 3.11977 5.76875 5.82634C2.96774 8.61462 3.89836 13.093 5.76958 14.9513C5.86771 15.049 5.9725 15.1347 6.07646 15.218C6.17369 15.2974 6.32296 15.3003 6.41823 15.2186L7.13343 14.6053C7.32801 14.4385 7.34025 14.1481 7.14098 13.9869L7.1138 13.9652C7.06265 13.9244 7.01103 13.8833 6.963 13.8363C5.58246 12.4658 4.87888 9.01672 6.96383 6.94133C9.06376 4.84993 13.6736 5.67656 15.0949 6.47595C16.5487 7.29237 17.5516 8.50427 18.0786 9.25879C18.3371 9.62889 18.839 9.78919 19.2457 9.59323C19.6605 9.39336 19.8225 8.89704 19.5658 8.51482C18.9721 7.63093 17.7687 6.12127 15.934 5.09103ZM9.98186 12.6472C9.12526 11.6379 8.4957 10.7913 8.8242 9.83887C9.04292 9.21008 9.50033 8.77754 10.1856 8.55407C10.9726 8.30018 11.9941 8.36225 12.8476 8.68511C13.2558 8.83955 13.7449 8.75264 13.9964 8.3959C14.2604 8.02131 14.162 7.49753 13.7432 7.31139C12.4672 6.74423 10.9126 6.62666 9.65253 7.03698C8.48156 7.41825 7.62745 8.23447 7.24739 9.33264C6.60212 11.1971 7.91149 12.7396 8.69411 13.6616L8.69446 13.662L8.74443 13.7211L8.74452 13.7212C8.84987 13.8456 8.94907 13.9628 9.03461 14.0721C10.9373 16.509 11.2848 17.9098 11.3482 19.1674C11.3714 19.6261 11.7348 19.9987 12.1941 19.9987C12.6534 19.9987 13.0329 19.6264 13.0138 19.1675C12.9532 17.715 12.5864 15.9558 10.3636 13.1093C10.2521 12.9668 10.1216 12.8122 9.98186 12.6472ZM15.3966 9.36922C15.0697 9.69653 15.0836 10.2276 15.3847 10.5788C16.4747 11.8507 17.2588 13.6195 17.8545 16.1378C17.959 16.5798 18.3904 16.8686 18.8363 16.7821C19.2911 16.6939 19.587 16.2495 19.4806 15.7987C18.796 12.8968 17.854 10.8605 16.5036 9.37142C16.2091 9.04665 15.7064 9.05899 15.3966 9.36922ZM11.3732 10.3705C11.6256 10.0086 12.1166 9.91576 12.4519 10.2026C13.2339 10.8717 14.5649 12.2468 15.3886 14.3977C15.5547 14.8313 15.2917 15.3001 14.8436 15.4223C14.4081 15.5412 13.9611 15.2873 13.7948 14.8675C13.1557 13.2547 12.1798 12.1644 11.5403 11.5753C11.2045 11.2658 11.112 10.745 11.3732 10.3705ZM14.5622 17.9942C14.5024 17.535 14.8036 17.0983 15.2598 17.0193C15.7078 16.9418 16.1372 17.2385 16.1988 17.689C16.2657 18.1787 16.3106 18.6695 16.334 19.1679C16.3555 19.6267 15.9809 19.9993 15.5216 19.9993C15.0623 19.9993 14.6925 19.6267 14.6687 19.168C14.6482 18.7728 14.6128 18.3828 14.5622 17.9942Z",
    fill: color
  }));
}

function HelpIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 12C5.75 8.54822 8.54822 5.75 12 5.75C15.4518 5.75 18.25 8.54822 18.25 12C18.25 15.4518 15.4518 18.25 12 18.25C8.54822 18.25 5.75 15.4518 5.75 12ZM12 4.25C7.71979 4.25 4.25 7.71979 4.25 12C4.25 16.2802 7.71979 19.75 12 19.75C16.2802 19.75 19.75 16.2802 19.75 12C19.75 7.71979 16.2802 4.25 12 4.25ZM11.2404 13.0139V13.3102H12.151V13.1019C12.151 12.8519 12.199 12.6528 12.295 12.5046C12.3941 12.3565 12.5877 12.1698 12.8757 11.9444C13.2133 11.6821 13.4503 11.4691 13.5865 11.3056C13.7259 11.142 13.8297 10.9707 13.8978 10.7917C13.9659 10.6096 14 10.4028 14 10.1713C14 9.64969 13.8219 9.24074 13.4657 8.94444C13.1096 8.64815 12.628 8.5 12.0209 8.5C11.3024 8.5 10.6287 8.67438 10 9.02315L10.3902 9.83796C10.6287 9.72068 10.8734 9.62037 11.1243 9.53704C11.3751 9.4537 11.6477 9.41204 11.9419 9.41204C12.2671 9.41204 12.5165 9.48148 12.6899 9.62037C12.8633 9.75926 12.9501 9.95833 12.9501 10.2176C12.9501 10.4398 12.8959 10.6312 12.7875 10.7917C12.6822 10.9522 12.4452 11.1775 12.0767 11.4676C11.7669 11.7083 11.5501 11.9414 11.4262 12.1667C11.3024 12.392 11.2404 12.6744 11.2404 13.0139ZM11.7329 14.088C11.2776 14.088 11.0499 14.321 11.0499 14.787C11.0499 15.0123 11.1088 15.1883 11.2265 15.3148C11.3442 15.4383 11.513 15.5 11.7329 15.5C11.9528 15.5 12.1216 15.4367 12.2393 15.3102C12.36 15.1806 12.4204 15.0062 12.4204 14.787C12.4204 14.5648 12.3616 14.3935 12.2439 14.2731C12.1262 14.1497 11.9559 14.088 11.7329 14.088Z",
    fill: color
  }));
}

function InformationIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.75C8.54822 5.75 5.75 8.54822 5.75 12C5.75 15.4518 8.54822 18.25 12 18.25C15.4518 18.25 18.25 15.4518 18.25 12C18.25 8.54822 15.4518 5.75 12 5.75ZM4.25 12C4.25 7.71979 7.71979 4.25 12 4.25C16.2802 4.25 19.75 7.71979 19.75 12C19.75 16.2802 16.2802 19.75 12 19.75C7.71979 19.75 4.25 16.2802 4.25 12ZM12 11.25C12.4142 11.25 12.75 11.5858 12.75 12V15C12.75 15.4142 12.4142 15.75 12 15.75C11.5858 15.75 11.25 15.4142 11.25 15V12C11.25 11.5858 11.5858 11.25 12 11.25ZM12 8.25C11.5858 8.25 11.25 8.58579 11.25 9C11.25 9.41421 11.5858 9.75 12 9.75H12.01C12.4242 9.75 12.76 9.41421 12.76 9C12.76 8.58579 12.4242 8.25 12.01 8.25H12Z",
    fill: color
  }));
}

function LegalIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    d: "M13.5537 14.7773C14.876 15.4061 15.5372 16.2678 15.5372 17.3624C15.5372 18.1426 15.2452 18.7773 14.6612 19.2664C14.0882 19.7555 13.2948 20 12.281 20C11.2231 20 10.3636 19.7147 9.70248 19.1441C9.24568 18.7514 8.92216 18.2552 8.73192 17.6555C8.59717 17.2307 8.95213 16.8384 9.39775 16.8384C9.77827 16.8384 10.0838 17.1309 10.212 17.4892C10.3205 17.7922 10.4812 18.0527 10.6942 18.2707C11.0579 18.6434 11.5923 18.8297 12.2975 18.8297C12.8154 18.8297 13.2287 18.7074 13.5372 18.4629C13.8457 18.23 14 17.8806 14 17.4148C14 16.9374 13.8017 16.5357 13.405 16.2096C13.0083 15.8836 12.3085 15.5517 11.3058 15.214C10.2479 14.8763 9.43251 14.4687 8.8595 13.9913C8.2865 13.5022 8 12.8384 8 12C8 11.3362 8.20937 10.7482 8.6281 10.2358C9.05785 9.72344 9.68044 9.38574 10.4959 9.22271C9.1405 8.58224 8.46281 7.70888 8.46281 6.60262C8.46281 5.82242 8.75482 5.1936 9.33884 4.71616C9.93388 4.23872 10.7493 4 11.7851 4C12.832 4 13.6749 4.2853 14.314 4.8559C14.768 5.25294 15.0886 5.75575 15.2757 6.36433C15.4033 6.77953 15.0577 7.16157 14.6233 7.16157C14.2434 7.16157 13.9416 6.8621 13.811 6.50536C13.7076 6.22297 13.5502 5.9701 13.3388 5.74673C12.9752 5.36245 12.4463 5.17031 11.7521 5.17031C11.2121 5.17031 10.7824 5.28675 10.4628 5.51965C10.1543 5.7409 10 6.0786 10 6.53275C10 7.02183 10.1983 7.43523 10.595 7.77293C11.0028 8.09898 11.7025 8.43086 12.6942 8.76856C13.7631 9.1179 14.5785 9.53712 15.1405 10.0262C15.7135 10.5036 16 11.1616 16 12C16 12.6405 15.7906 13.2169 15.3719 13.7293C14.9642 14.23 14.3581 14.5793 13.5537 14.7773ZM9.60331 12C9.60331 12.5939 9.81818 13.0771 10.2479 13.4498C10.6777 13.8108 11.2727 13.9913 12.0331 13.9913C12.7824 13.9913 13.3664 13.7991 13.7851 13.4148C14.2039 13.0306 14.4132 12.559 14.4132 12C14.4132 11.4061 14.1983 10.9287 13.7686 10.5677C13.3388 10.195 12.7438 10.0087 11.9835 10.0087C11.2342 10.0087 10.6501 10.2009 10.2314 10.5852C9.81267 10.9694 9.60331 11.441 9.60331 12Z",
    fill: color
  }));
}

function LinkIcon(props) {
  var external = props.external,
      _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["external", "color", "size", "className"]);

  var externalLink = React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.25 4C13.25 3.58579 13.5858 3.25 14 3.25H20C20.4142 3.25 20.75 3.58579 20.75 4V10C20.75 10.4142 20.4142 10.75 20 10.75C19.5858 10.75 19.25 10.4142 19.25 10V5.81066L10.5303 14.5303C10.2374 14.8232 9.76256 14.8232 9.46967 14.5303C9.17678 14.2374 9.17678 13.7626 9.46967 13.4697L18.1893 4.75H14C13.5858 4.75 13.25 4.41421 13.25 4ZM3.92528 5.92528C4.35766 5.49291 4.94408 5.25 5.55556 5.25H11C11.4142 5.25 11.75 5.58579 11.75 6C11.75 6.41421 11.4142 6.75 11 6.75H5.55556C5.34191 6.75 5.13701 6.83487 4.98594 6.98594C4.83487 7.13701 4.75 7.34191 4.75 7.55556V18.4444C4.75 18.6581 4.83487 18.863 4.98594 19.0141C5.13701 19.1651 5.34191 19.25 5.55556 19.25H16.4444C16.6581 19.25 16.863 19.1651 17.0141 19.0141C17.1651 18.863 17.25 18.6581 17.25 18.4444V13C17.25 12.5858 17.5858 12.25 18 12.25C18.4142 12.25 18.75 12.5858 18.75 13V18.4444C18.75 19.0559 18.5071 19.6423 18.0747 20.0747C17.6423 20.5071 17.0559 20.75 16.4444 20.75H5.55556C4.94408 20.75 4.35766 20.5071 3.92528 20.0747C3.49291 19.6423 3.25 19.0559 3.25 18.4444V7.55556C3.25 6.94408 3.49291 6.35766 3.92528 5.92528Z",
    fill: color
  });
  var defaultLink = React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.068 5.00015C14.0311 4.99128 13.0303 5.38364 12.2816 6.09565L12.2816 6.0956L12.275 6.10203L11.1295 7.22341C10.8783 7.46926 10.874 7.87216 11.1199 8.12331C11.3657 8.37446 11.7686 8.37876 12.0198 8.1329L13.1618 7.01492C13.6689 6.53427 14.3492 6.26677 15.0571 6.27283C15.7664 6.2789 16.4431 6.55913 16.9418 7.05017C17.4402 7.5409 17.7211 8.20266 17.7272 8.89236C17.7332 9.58034 17.4654 10.2451 16.9782 10.7438L14.9843 12.707L14.9843 12.7071C14.7116 12.9756 14.383 13.1838 14.0201 13.3171C13.6573 13.4503 13.2693 13.5053 12.8826 13.478C12.4958 13.4508 12.12 13.3419 11.7805 13.1593C11.4412 12.9768 11.1464 12.7249 10.9158 12.4214C10.7032 12.1415 10.304 12.087 10.0241 12.2996C9.74428 12.5122 9.68976 12.9114 9.90237 13.1913C10.2438 13.6407 10.6789 14.0119 11.1776 14.2802C11.6763 14.5484 12.2272 14.7077 12.793 14.7476C13.3589 14.7875 13.927 14.7072 14.459 14.5118C14.9909 14.3164 15.4747 14.0104 15.8773 13.6139L15.8774 13.6138L17.8753 11.6466L17.8754 11.6466L17.8831 11.6387C18.6068 10.901 19.0089 9.91086 18.9999 8.88113C18.9908 7.85141 18.5712 6.86841 17.8348 6.14328C17.0986 5.41846 16.1048 5.00902 15.068 5.00015ZM11.207 9.25238C10.6411 9.21248 10.073 9.29283 9.54105 9.48823C9.00908 9.68361 8.52527 9.98962 8.12271 10.3861L8.12262 10.3862L6.12467 12.3534L6.1246 12.3534L6.11686 12.3613C5.3932 13.099 4.99106 14.0891 5.00015 15.1189C5.00924 16.1486 5.42878 17.1316 6.16524 17.8567C6.90137 18.5815 7.89516 18.991 8.93204 18.9999C9.96891 19.0087 10.9697 18.6164 11.7184 17.9044L11.7185 17.9044L11.7263 17.8967L12.8652 16.7753C13.1156 16.5287 13.1188 16.1258 12.8722 15.8754C12.6256 15.6249 12.2227 15.6218 11.9723 15.8684L10.8375 16.9857C10.3305 17.466 9.65055 17.7332 8.94293 17.7272C8.23355 17.7211 7.5569 17.4409 7.05819 16.9498C6.55981 16.4591 6.27892 15.7973 6.27283 15.1076C6.26676 14.4197 6.53456 13.7549 7.02178 13.2563L9.01566 11.293L9.01575 11.2929C9.28835 11.0244 9.61705 10.8162 9.97985 10.6829C10.3427 10.5497 10.7307 10.4947 11.1174 10.522C11.5042 10.5492 11.88 10.6581 12.2195 10.8407C12.5588 11.0232 12.8536 11.2751 13.0842 11.5786C13.2968 11.8585 13.696 11.913 13.9759 11.7004C14.2557 11.4878 14.3102 11.0886 14.0976 10.8087C13.7562 10.3593 13.3211 9.98809 12.8224 9.71981C12.3237 9.45155 11.7728 9.29228 11.207 9.25238Z",
    fill: color
  });
  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), external ? externalLink : defaultLink);
}

function LogoutIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4697 17.4697C12.1768 17.7626 12.1768 18.2374 12.4697 18.5303C12.7626 18.8232 13.2374 18.8232 13.5303 18.5303L19.5303 12.5303C19.8232 12.2374 19.8232 11.7626 19.5303 11.4697L13.5303 5.46967C13.2374 5.17678 12.7626 5.17678 12.4697 5.46967C12.1768 5.76256 12.1768 6.23744 12.4697 6.53033L17.1893 11.25H8C7.58579 11.25 7.25 11.5858 7.25 12C7.25 12.4142 7.58579 12.75 8 12.75H17.1893L12.4697 17.4697ZM10.75 5C10.75 5.41421 10.4142 5.75 10 5.75H6.66667C6.40749 5.75 6.16846 5.84657 5.9999 6.0039C5.83307 6.1596 5.75 6.35926 5.75 6.55556V17.4444C5.75 17.6407 5.83307 17.8404 5.9999 17.9961C6.16846 18.1534 6.4075 18.25 6.66667 18.25H10C10.4142 18.25 10.75 18.5858 10.75 19C10.75 19.4142 10.4142 19.75 10 19.75H6.66667C6.04178 19.75 5.43297 19.5188 4.97642 19.0927C4.51812 18.6649 4.25 18.0733 4.25 17.4444V6.55556C4.25 5.92673 4.51812 5.33507 4.97642 4.90732C5.43297 4.4812 6.04178 4.25 6.66667 4.25H10C10.4142 4.25 10.75 4.58579 10.75 5Z",
    fill: color
  }));
}

function Logo(props) {
  return React.createElement(SvgIcon, _assign({
    style: {
      width: 210,
      height: 40
    },
    viewBox: '0 0 210 40'
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9295 8.44232C18.0223 4.0209 9.66009 4.55625 4.37226 9.78158C-1.45758 15.5425 -1.45757 24.8828 4.37226 30.6437C9.65553 35.8646 18.0086 36.4039 23.9155 31.9934C24.7378 31.3795 24.9007 30.2231 24.2794 29.4106C23.6581 28.598 22.4879 28.437 21.6656 29.051C17.2396 32.3557 10.9732 31.9511 7.01123 28.036C2.63885 23.7153 2.63885 16.71 7.01123 12.3893C10.9766 8.47082 17.2499 8.0692 21.6761 11.3821C22.4976 11.997 23.668 11.8374 24.2903 11.0256C24.9125 10.2138 24.751 9.05722 23.9295 8.44232Z",
    fill: "#48D2A0"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.386 25.0119V10.3547C111.386 9.57458 112.01 8.93628 112.825 8.93628C113.64 8.93628 114.288 9.57458 114.288 10.3547V15.7448C115.103 14.5864 116.278 13.5698 118.244 13.5698C121.097 13.5698 122.751 15.4611 122.751 18.3453V25.0119C122.751 25.8157 122.128 26.4304 121.313 26.4304C120.497 26.4304 119.85 25.8157 119.85 25.0119V19.22C119.85 17.2814 118.867 16.1703 117.141 16.1703C115.462 16.1703 114.288 17.3287 114.288 19.2672V25.0119C114.288 25.8157 113.64 26.4304 112.825 26.4304C112.034 26.4304 111.386 25.8157 111.386 25.0119ZM85.3963 10.6148V10.4729C85.3963 9.62186 86.1156 9.07813 87.0507 9.07813C87.9857 9.07813 88.705 9.62186 88.705 10.4729V10.6148C88.705 11.4658 87.9857 12.0332 87.0507 12.0332C86.1156 12.0332 85.3963 11.4658 85.3963 10.6148ZM15.0145 26.5959C11.2502 26.5959 8.46899 23.6881 8.46899 20.1419V20.0947C8.46899 16.5486 11.2502 13.5698 15.0624 13.5698C17.0524 13.5698 18.4191 14.2081 19.498 15.1301C19.6898 15.2956 19.9536 15.6502 19.9536 16.123C19.9536 16.8559 19.3542 17.4233 18.6109 17.4233C18.2512 17.4233 17.9396 17.2814 17.7478 17.1396C17.0045 16.5249 16.1893 16.0758 15.0385 16.0758C12.9286 16.0758 11.3701 17.8724 11.3701 20.0474V20.0947C11.3701 22.3169 12.9286 24.0899 15.1583 24.0899C16.3092 24.0899 17.1963 23.6408 17.9875 22.9788C18.1553 22.837 18.4431 22.6715 18.7787 22.6715C19.474 22.6715 20.0255 23.2389 20.0255 23.9245C20.0255 24.3027 19.8816 24.61 19.6179 24.8228C18.491 25.8866 17.1244 26.5959 15.0145 26.5959ZM30.0115 26.5959C26.1514 26.5959 23.2982 23.6881 23.2982 20.1419V20.0947C23.2982 16.5249 26.1753 13.5698 30.0595 13.5698C33.9436 13.5698 36.7968 16.4776 36.7968 20.0474V20.0947C36.7968 23.6408 33.9196 26.5959 30.0115 26.5959ZM33.8956 20.142C33.8956 22.2933 32.4091 24.0899 30.0595 24.0899C27.8057 24.0899 26.1993 22.2696 26.1993 20.0947V20.0474C26.1993 17.8725 27.6858 16.0758 30.0115 16.0758C32.2892 16.0758 33.8956 17.8961 33.8956 20.0947V20.142ZM41.2443 28.7944V15.1301C41.2443 14.3263 41.8677 13.688 42.6829 13.688C43.4981 13.688 44.1454 14.3263 44.1454 15.1301V15.9103C45.0805 14.61 46.3992 13.5698 48.4611 13.5698C51.4342 13.5698 54.3353 15.8866 54.3353 20.0474V20.0947C54.3353 24.2318 51.4581 26.5722 48.4611 26.5722C46.3512 26.5722 45.0325 25.532 44.1454 24.3736V28.7944C44.1454 29.5982 43.4981 30.2129 42.6829 30.2129C41.8917 30.2129 41.2443 29.5982 41.2443 28.7944ZM51.3862 20.0947C51.3862 22.5533 49.7558 24.09 47.7658 24.09C45.7998 24.09 44.0735 22.4824 44.0735 20.0947V20.0474C44.0735 17.6597 45.7998 16.0521 47.7658 16.0521C49.7319 16.0521 51.3862 17.636 51.3862 20.0474V20.0947ZM60.7729 30.1656C59.9577 30.1656 59.3583 30.0474 58.7589 29.811C58.3273 29.6691 57.8478 29.3145 57.8478 28.629C57.8478 27.9197 58.3992 27.4469 59.0226 27.4469C59.2624 27.4469 59.4062 27.4942 59.5501 27.5415C59.8857 27.636 60.1495 27.707 60.5571 27.707C61.4202 27.707 61.8758 27.3524 62.3553 26.3831L62.4512 26.123L57.7519 15.7684C57.656 15.5557 57.584 15.272 57.584 15.0829C57.584 14.2791 58.2074 13.6881 59.0226 13.6881C59.7659 13.6881 60.1735 14.1136 60.4372 14.7755L63.8418 23.0734L67.0066 14.7755C67.2464 14.1845 67.654 13.6881 68.3973 13.6881C69.1645 13.6881 69.7879 14.2791 69.7879 15.0356C69.7879 15.272 69.7159 15.5793 69.668 15.7211L65.0406 26.6668C63.9617 29.22 62.8108 30.1656 60.7729 30.1656ZM74.0436 15.1301V25.0119C74.0436 25.8157 74.691 26.4304 75.4822 26.4304C76.2974 26.4304 76.9447 25.7921 76.9447 25.0119V21.324C76.9447 18.3689 78.3593 16.8086 80.4213 16.454C81.0686 16.3358 81.5722 15.8394 81.5722 15.0829C81.5722 14.2554 81.0447 13.6644 80.1336 13.6644C78.8628 13.6644 77.6161 14.8464 76.9447 16.4067V15.1301C76.9447 14.3264 76.2974 13.6881 75.4822 13.6881C74.667 13.6881 74.0436 14.3264 74.0436 15.1301ZM85.6121 15.1301V25.0119C85.6121 25.8157 86.2594 26.4304 87.0506 26.4304C87.8658 26.4304 88.5132 25.8157 88.5132 25.0119V15.1301C88.5132 14.3263 87.8658 13.6881 87.0506 13.6881C86.2355 13.6881 85.6121 14.3263 85.6121 15.1301ZM99.4343 30.142C97.6601 30.142 96.0777 29.7637 94.5432 29.0308C94.0397 28.8417 93.728 28.4398 93.728 27.8961C93.728 27.2578 94.2794 26.7141 94.9508 26.7141C95.1666 26.7141 95.3344 26.7613 95.4782 26.8323C96.6291 27.4706 97.8998 27.8252 99.3624 27.8252C101.952 27.8252 103.366 26.5013 103.366 23.9954V23.0261C102.311 24.3736 100.993 25.3193 98.9068 25.3193C95.9338 25.3193 93.1526 23.1443 93.1526 19.48V19.4327C93.1526 15.7448 95.9578 13.5698 98.9068 13.5698C101.041 13.5698 102.359 14.5391 103.342 15.6975V15.1065C103.342 14.3263 103.99 13.688 104.781 13.688C105.596 13.688 106.243 14.3263 106.243 15.1301V23.759C106.243 25.863 105.692 27.4233 104.637 28.4635C103.486 29.5982 101.712 30.142 99.4343 30.142ZM103.39 19.4564C103.39 21.4895 101.688 22.8843 99.6741 22.8843C97.6841 22.8843 96.0777 21.4895 96.0777 19.4564V19.4091C96.0777 17.3524 97.6601 15.9812 99.6741 15.9812C101.688 15.9812 103.39 17.376 103.39 19.4091V19.4564ZM128.35 22.8606C128.35 25.6029 129.86 26.5249 131.994 26.5249C132.761 26.5249 133.361 26.4067 133.984 26.194C134.392 26.0285 134.751 25.6029 134.751 25.0829C134.751 24.4209 134.176 23.9008 133.528 23.9008C133.495 23.9008 133.438 23.9094 133.364 23.9206C133.226 23.9416 133.028 23.9717 132.809 23.9717C131.826 23.9717 131.251 23.5226 131.251 22.4115V16.2885H133.528C134.224 16.2885 134.799 15.7448 134.799 15.0592C134.799 14.3736 134.224 13.8299 133.528 13.8299H131.251V11.7022C131.251 10.9221 130.603 10.2838 129.812 10.2838C128.997 10.2838 128.35 10.9221 128.35 11.7022V13.8299H127.87C127.175 13.8299 126.623 14.3736 126.623 15.0592C126.623 15.7448 127.175 16.2885 127.87 16.2885H128.35V22.8606ZM143.227 26.5959C140.949 26.5959 138.503 25.3193 138.503 22.8133V22.7661C138.503 20.2602 140.685 18.8417 143.85 18.8417C145.552 18.8417 146.727 19.0545 147.902 19.3618V18.8417C147.902 16.4067 146.391 15.1538 143.874 15.1538C142.531 15.1538 141.404 15.4847 140.397 15.9576C140.302 16.0048 140.206 16.0285 140.134 16.0285C139.846 16.0285 139.582 15.7684 139.582 15.4847C139.582 15.2011 139.798 15.0119 139.918 14.9646C141.165 14.4209 142.387 14.0663 143.946 14.0663C145.6 14.0663 146.919 14.5155 147.806 15.3902C148.621 16.194 149.053 17.3051 149.053 18.7944V25.8157C149.053 26.1703 148.813 26.4067 148.477 26.4067C148.142 26.4067 147.902 26.1703 147.902 25.8157V24.3027C147.063 25.4611 145.552 26.5959 143.227 26.5959ZM147.926 21.7968C147.926 23.9954 145.792 25.5084 143.299 25.5084C141.428 25.5084 139.75 24.4918 139.75 22.7424V22.6951C139.75 21.0167 141.189 19.8819 143.778 19.8819C145.528 19.8819 146.895 20.1656 147.926 20.4256V21.7968ZM160.142 30.142C158.2 30.142 156.377 29.5746 154.795 28.4871C154.627 28.3689 154.531 28.1798 154.531 27.967C154.531 27.707 154.819 27.4233 155.131 27.4233C155.275 27.4233 155.37 27.4706 155.466 27.5178C156.857 28.5344 158.463 29.0545 160.166 29.0545C162.971 29.0545 164.961 27.4706 164.961 24.3736V22.6242C163.906 24.1136 162.276 25.4138 159.854 25.4138C156.905 25.4138 153.98 23.1916 153.98 19.7401V19.6928C153.98 16.2176 156.905 13.9717 159.854 13.9717C162.3 13.9717 163.954 15.2483 164.961 16.6668V14.7519C164.961 14.4209 165.201 14.1609 165.536 14.1609C165.872 14.1609 166.136 14.4209 166.136 14.7519V24.4446C166.136 26.194 165.56 27.5651 164.577 28.5344C163.522 29.5746 161.94 30.142 160.142 30.142ZM165.033 19.7164C165.033 22.4587 162.515 24.3027 159.974 24.3027C157.456 24.3027 155.251 22.4115 155.251 19.6928V19.6455C155.251 16.8323 157.408 15.0829 159.974 15.0829C162.515 15.0829 165.033 16.8795 165.033 19.6691V19.7164ZM172.501 19.7164H181.397C181.229 17.2814 179.814 15.0356 177.009 15.0356C174.587 15.0356 172.717 17.045 172.501 19.7164ZM177.249 26.5959C179.455 26.5959 180.821 25.8157 182.02 24.6337C182.164 24.4918 182.212 24.35 182.212 24.2318C182.212 23.9245 181.948 23.6881 181.636 23.6881C181.469 23.6881 181.349 23.759 181.253 23.8535C180.27 24.7992 179.047 25.5084 177.297 25.5084C174.899 25.5084 172.717 23.759 172.501 20.7566H182.092C182.38 20.7566 182.667 20.4966 182.667 20.2129C182.667 16.7613 180.486 13.9717 177.057 13.9717C173.748 13.9717 171.255 16.7613 171.255 20.2602V20.3074C171.255 24.0663 174.036 26.5959 177.249 26.5959ZM187.594 25.8157V14.7519C187.594 14.4209 187.834 14.1609 188.17 14.1609C188.506 14.1609 188.769 14.3973 188.769 14.7519V16.5013C189.584 15.0829 190.951 13.9717 193.181 13.9717C196.274 13.9717 198.072 16.0521 198.072 18.9363V25.8157C198.072 26.1703 197.832 26.4067 197.497 26.4067C197.161 26.4067 196.897 26.1703 196.897 25.8157V19.149C196.897 16.6668 195.483 15.0356 193.013 15.0356C190.615 15.0356 188.769 16.8323 188.769 19.3382V25.8157C188.769 26.1703 188.53 26.4067 188.194 26.4067C187.858 26.4067 187.594 26.1703 187.594 25.8157ZM204.438 23.2152C204.438 25.5084 205.972 26.5249 207.866 26.5249C208.562 26.5249 209.113 26.3831 209.592 26.2176C209.832 26.123 209.976 25.9576 209.976 25.7212C209.976 25.4375 209.712 25.2011 209.449 25.2011C209.397 25.2011 209.324 25.2236 209.224 25.2548C209 25.3246 208.638 25.4375 208.058 25.4375C206.643 25.4375 205.612 24.8228 205.612 23.097V15.3193H209.449C209.736 15.3193 210 15.0829 210 14.7992C210 14.5155 209.736 14.2554 209.449 14.2554H205.612V10.8985C205.612 10.5675 205.349 10.3074 205.013 10.3074C204.677 10.3074 204.438 10.5675 204.438 10.8985V14.2554H203.119C202.831 14.2554 202.568 14.4918 202.568 14.7755C202.568 15.0592 202.831 15.3193 203.119 15.3193H204.438V23.2152Z",
    fill: "#293833"
  }));
}

function SortingIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.46967 9.46967C7.17678 9.76256 7.17678 10.2374 7.46967 10.5303C7.76256 10.8232 8.23744 10.8232 8.53033 10.5303L12 7.06066L15.4697 10.5303C15.7626 10.8232 16.2374 10.8232 16.5303 10.5303C16.8232 10.2374 16.8232 9.76256 16.5303 9.46967L12.5303 5.46967C12.2374 5.17678 11.7626 5.17678 11.4697 5.46967L7.46967 9.46967ZM8.53033 13.4697C8.23744 13.1768 7.76256 13.1768 7.46967 13.4697C7.17678 13.7626 7.17678 14.2374 7.46967 14.5303L11.4697 18.5303C11.7626 18.8232 12.2374 18.8232 12.5303 18.5303L16.5303 14.5303C16.8232 14.2374 16.8232 13.7626 16.5303 13.4697C16.2374 13.1768 15.7626 13.1768 15.4697 13.4697L12 16.9393L8.53033 13.4697Z",
    fill: color
  }));
}

function TrashIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1044 5.95658C10.2348 5.81967 10.4036 5.75 10.5714 5.75H13.4286C13.5964 5.75 13.7652 5.81967 13.8956 5.95658C14.0272 6.09474 14.1071 6.2896 14.1071 6.5V7.25H9.89286V6.5C9.89286 6.2896 9.9728 6.09474 10.1044 5.95658ZM8.39286 7.25V6.5C8.39286 5.91475 8.61393 5.34655 9.01817 4.9221C9.4236 4.4964 9.9815 4.25 10.5714 4.25H13.4286C14.0185 4.25 14.5764 4.4964 14.9818 4.9221C15.3861 5.34655 15.6071 5.91475 15.6071 6.5V7.25H17H19C19.4142 7.25 19.75 7.58579 19.75 8C19.75 8.41421 19.4142 8.75 19 8.75H17.75L17.7502 17.5C17.7502 18.0853 17.5291 18.6535 17.1249 19.0779C16.7194 19.5036 16.1615 19.75 15.5716 19.75H8.42875C7.83882 19.75 7.28092 19.5036 6.8755 19.0779C6.47126 18.6535 6.25018 18.0853 6.25018 17.5L6.25001 8.75H5C4.58579 8.75 4.25 8.41421 4.25 8C4.25 7.58579 4.58579 7.25 5 7.25H6.55556H7H8.39286ZM7.75001 8.75L7.75018 17.5C7.75018 17.7104 7.83012 17.9053 7.9617 18.0434C8.0921 18.1803 8.26092 18.25 8.42875 18.25H15.5716C15.7394 18.25 15.9083 18.1803 16.0387 18.0434C16.1702 17.9053 16.2502 17.7104 16.2502 17.5L16.25 8.75H14.8571H9.14286H7.75001Z",
    fill: color
  }));
}

function UploadIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4697 11.5303C17.7626 11.8232 18.2374 11.8232 18.5303 11.5303C18.8232 11.2374 18.8232 10.7626 18.5303 10.4697L12.5303 4.46967C12.2374 4.17678 11.7626 4.17678 11.4697 4.46967L5.46967 10.4697C5.17678 10.7626 5.17678 11.2374 5.46967 11.5303C5.76256 11.8232 6.23744 11.8232 6.53033 11.5303L11.25 6.81066V16C11.25 16.4142 11.5858 16.75 12 16.75C12.4142 16.75 12.75 16.4142 12.75 16V6.81066L17.4697 11.5303ZM5 13.25C5.41421 13.25 5.75 13.5858 5.75 14V17.3333C5.75 17.5925 5.84657 17.8315 6.0039 18.0001C6.1596 18.1669 6.35926 18.25 6.55556 18.25H17.4444C17.6407 18.25 17.8404 18.1669 17.9961 18.0001C18.1534 17.8315 18.25 17.5925 18.25 17.3333V14C18.25 13.5858 18.5858 13.25 19 13.25C19.4142 13.25 19.75 13.5858 19.75 14V17.3333C19.75 17.9582 19.5188 18.567 19.0927 19.0236C18.6649 19.4819 18.0733 19.75 17.4444 19.75H6.55556C5.92673 19.75 5.33507 19.4819 4.90732 19.0236C4.4812 18.567 4.25 17.9582 4.25 17.3333V14C4.25 13.5858 4.58579 13.25 5 13.25Z",
    fill: color
  }));
}

function UserIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon$1, _assign({
    fill: "none"
  }, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.75 6.75C10.7835 6.75 10 7.5335 10 8.5C10 9.4665 10.7835 10.25 11.75 10.25C12.7165 10.25 13.5 9.4665 13.5 8.5C13.5 7.5335 12.7165 6.75 11.75 6.75ZM8.5 8.5C8.5 6.70507 9.95507 5.25 11.75 5.25C13.5449 5.25 15 6.70507 15 8.5C15 10.2949 13.5449 11.75 11.75 11.75C9.95507 11.75 8.5 10.2949 8.5 8.5ZM7.00072 14.2507C7.64147 13.61 8.51051 13.25 9.41667 13.25H14.0833C14.9895 13.25 15.8585 13.61 16.4993 14.2507C17.14 14.8915 17.5 15.7605 17.5 16.6667V18C17.5 18.4142 17.1642 18.75 16.75 18.75H6.75C6.33579 18.75 6 18.4142 6 18V16.6667C6 15.7605 6.35997 14.8915 7.00072 14.2507ZM7.5 17.25H16V16.6667C16 16.1583 15.7981 15.6708 15.4386 15.3114C15.0792 14.9519 14.5917 14.75 14.0833 14.75H9.41667C8.90834 14.75 8.42082 14.9519 8.06138 15.3114C7.70193 15.6708 7.5 16.1583 7.5 16.6667V17.25Z",
    fill: color
  }));
}

function ActivityIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6 4.25C9.92046 4.25 10.2055 4.45361 10.3095 4.75676L14.4 16.6875L16.0905 11.7568C16.1945 11.4536 16.4795 11.25 16.8 11.25H19C19.4142 11.25 19.75 11.5858 19.75 12C19.75 12.4142 19.4142 12.75 19 12.75H17.3357L15.1095 19.2432C15.0055 19.5464 14.7205 19.75 14.4 19.75C14.0795 19.75 13.7945 19.5464 13.6905 19.2432L9.6 7.3125L7.90946 12.2432C7.80552 12.5464 7.52047 12.75 7.2 12.75H5C4.58579 12.75 4.25 12.4142 4.25 12C4.25 11.5858 4.58579 11.25 5 11.25H6.66429L8.89054 4.75676C8.99447 4.45361 9.27953 4.25 9.6 4.25Z",
    fill: color
  }));
}

function DashboardIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4685 3.41435C12.1946 3.19522 11.8054 3.19522 11.5315 3.41435L4.53148 9.01435C4.35357 9.15668 4.25 9.37216 4.25 9.6V18.4C4.25 19.0165 4.48792 19.612 4.91787 20.0542C5.34851 20.4971 5.93716 20.75 6.55556 20.75H9H15H17.4444C18.0628 20.75 18.6515 20.4971 19.0821 20.0542C19.5121 19.612 19.75 19.0165 19.75 18.4V9.6C19.75 9.37216 19.6464 9.15668 19.4685 9.01435L12.4685 3.41435ZM15.75 19.25H17.4444C17.6512 19.25 17.8538 19.1657 18.0066 19.0086C18.1601 18.8507 18.25 18.6321 18.25 18.4V9.96047L12 4.96047L5.75 9.96047V18.4C5.75 18.6321 5.83986 18.8507 5.99336 19.0086C6.14616 19.1657 6.34884 19.25 6.55556 19.25H8.25V12C8.25 11.5858 8.58579 11.25 9 11.25H15C15.4142 11.25 15.75 11.5858 15.75 12V19.25ZM9.75 19.25V12.75H14.25V19.25H9.75Z",
    fill: color
  }));
}

function InReviewIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.25 4.25C15.6642 4.25 16 4.58579 16 5C16 5.41421 15.6642 5.75 15.25 5.75H5.75V18.25H18.25V10.75C18.25 10.3358 18.5858 10 19 10C19.4142 10 19.75 10.3358 19.75 10.75V19C19.75 19.4142 19.4142 19.75 19 19.75H5C4.58579 19.75 4.25 19.4142 4.25 19V5C4.25 4.58579 4.58579 4.25 5 4.25H15.25ZM19.5644 6.49389C19.8372 6.18216 19.8056 5.70834 19.4939 5.43558C19.1822 5.16282 18.7083 5.1944 18.4356 5.50613L11.9635 12.9028L9.53033 10.4697C9.23744 10.1768 8.76256 10.1768 8.46967 10.4697C8.17678 10.7626 8.17678 11.2374 8.46967 11.5303L11.4697 14.5303C11.6164 14.6771 11.8175 14.7565 12.025 14.7496C12.2324 14.7427 12.4277 14.6501 12.5644 14.4939L19.5644 6.49389Z",
    fill: color
  }));
}

function NotificationsIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 4.25C10.7403 4.25 9.5321 4.75045 8.6413 5.64124C7.7505 6.53204 7.25006 7.74022 7.25006 9C7.25006 11.2228 6.77476 12.5968 6.34164 13.3909C6.12404 13.7898 5.91298 14.05 5.76809 14.2029C5.69546 14.2796 5.63893 14.3299 5.60586 14.3574C5.58931 14.3712 5.5786 14.3794 5.57466 14.3823L5.5742 14.3826C5.30613 14.5675 5.18762 14.9048 5.28224 15.2173C5.37801 15.5337 5.66956 15.75 6.00006 15.75H18.0001C18.3306 15.75 18.6221 15.5337 18.7179 15.2173C18.8125 14.9048 18.694 14.5675 18.4259 14.3826L18.4272 14.3835C18.4272 14.3835 18.4268 14.3833 18.4262 14.3829L18.4225 14.3803L18.4197 14.3784L18.418 14.3772L18.417 14.3766L18.4098 14.3701C18.4176 14.3764 18.4229 14.3804 18.4255 14.3823L18.2813 14.2535C18.2659 14.2381 18.2494 14.2213 18.232 14.2029C18.0871 14.05 17.8761 13.7898 17.6585 13.3909C17.2254 12.5968 16.7501 11.2228 16.7501 9C16.7501 7.74022 16.2496 6.53204 15.3588 5.64124C14.468 4.75044 13.2598 4.25 12.0001 4.25ZM15.5164 11.7833L18.2813 14.2535C18.2883 14.2604 18.295 14.267 18.3015 14.2733L15.5167 11.7849C15.5166 11.7844 15.5165 11.7839 15.5164 11.7833ZM9.76251 6.64291L8.6413 5.64124L9.76239 6.64302C9.74202 6.66236 9.72188 6.68199 9.70196 6.7019C9.09247 7.3114 8.75006 8.13805 8.75006 9C8.75006 11.4438 8.22536 13.0699 7.65848 14.1091C7.63215 14.1574 7.60576 14.2044 7.57937 14.25H16.4207C16.3944 14.2044 16.368 14.1574 16.3416 14.1091C16.0257 13.53 15.7229 12.7686 15.5167 11.7849L9.76239 6.64302C9.76243 6.64298 9.76247 6.64295 9.76251 6.64291ZM9.76251 6.64291L15.5164 11.7833C15.3528 11.0023 15.2501 10.0812 15.2501 9C15.2501 8.13805 14.9076 7.3114 14.2982 6.7019C13.6887 6.09241 12.862 5.75 12.0001 5.75C11.1663 5.75 10.3656 6.07036 9.76251 6.64291ZM18.3015 14.2733L18.4098 14.3701C18.4054 14.3666 18.4002 14.3624 18.3943 14.3574C18.3727 14.3394 18.341 14.3117 18.3015 14.2733ZM10.6236 17.5833C10.3935 17.2389 9.92775 17.1463 9.58335 17.3764C9.23896 17.6066 9.14633 18.0723 9.37647 18.4167C9.65734 18.837 10.0519 19.1736 10.5106 19.4029C10.9692 19.6322 11.4824 19.75 12.0001 19.75C12.5177 19.75 13.0309 19.6322 13.4895 19.4029C13.9482 19.1736 14.3428 18.837 14.6236 18.4167C14.8538 18.0723 14.7612 17.6066 14.4168 17.3764C14.0724 17.1463 13.6066 17.2389 13.3765 17.5833C13.2508 17.7713 13.0619 17.9397 12.8187 18.0613C12.5752 18.183 12.2926 18.25 12.0001 18.25C11.7076 18.25 11.4249 18.183 11.1814 18.0613C10.9382 17.9397 10.7493 17.7713 10.6236 17.5833Z",
    fill: color
  }));
}

function PauseIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 5.25C7.08579 5.25 6.75 5.58579 6.75 6V18C6.75 18.4142 7.08579 18.75 7.5 18.75H10.5C10.9142 18.75 11.25 18.4142 11.25 18V6C11.25 5.58579 10.9142 5.25 10.5 5.25H7.5ZM8.25 17.25V6.75H9.75V17.25H8.25ZM13.5 5.25C13.0858 5.25 12.75 5.58579 12.75 6V18C12.75 18.4142 13.0858 18.75 13.5 18.75H16.5C16.9142 18.75 17.25 18.4142 17.25 18V6C17.25 5.58579 16.9142 5.25 16.5 5.25H13.5ZM14.25 17.25V6.75H15.75V17.25H14.25Z",
    fill: color
  }));
}

function PreApprovalsIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4345 4.5866C17.663 4.82656 17.6538 5.20634 17.4138 5.43487L12.1638 10.4349C11.9408 10.6472 11.5933 10.6563 11.3595 10.4559L9.60953 8.95595C9.35793 8.74029 9.32879 8.36151 9.54445 8.10992C9.7601 7.85832 10.1389 7.82918 10.3905 8.04484L11.7288 9.19199L16.5862 4.56591C16.8262 4.33738 17.206 4.34664 17.4345 4.5866ZM4.25 17.5004C4.25 16.2578 5.25736 15.2504 6.5 15.2504H17.5C18.7426 15.2504 19.75 16.2578 19.75 17.5004C19.75 18.743 18.7426 19.7504 17.5 19.7504H6.5C5.25736 19.7504 4.25 18.743 4.25 17.5004ZM6.5 16.7504C6.08579 16.7504 5.75 17.0862 5.75 17.5004C5.75 17.9146 6.08579 18.2504 6.5 18.2504H9.25V16.7504H6.5ZM10.75 18.2504H13.25V16.7504H10.75V18.2504ZM17.5 18.2504H14.75V16.7504H17.5C17.9142 16.7504 18.25 17.0862 18.25 17.5004C18.25 17.9146 17.9142 18.2504 17.5 18.2504ZM12.4 4.40078C12.7314 4.40078 13 4.66941 13 5.00078C13 5.33215 12.7314 5.60078 12.4 5.60078H8.59844V12.4008H15.3984V9.60078C15.3984 9.26941 15.6671 9.00078 15.9984 9.00078C16.3298 9.00078 16.5984 9.26941 16.5984 9.60078V13.0008C16.5984 13.3322 16.3298 13.6008 15.9984 13.6008H7.99844C7.66707 13.6008 7.39844 13.3322 7.39844 13.0008V5.00078C7.39844 4.66941 7.66707 4.40078 7.99844 4.40078H12.4Z",
    fill: color
  }));
}

function ReportsIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4.25C5.58579 4.25 5.25 4.58579 5.25 5V19C5.25 19.4142 5.58579 19.75 6 19.75H18C18.4142 19.75 18.75 19.4142 18.75 19V5C18.75 4.58579 18.4142 4.25 18 4.25H6ZM6.75 18.25V5.75H17.25V18.25H6.75ZM15 7.25C15.4142 7.25 15.75 7.58579 15.75 8V16C15.75 16.4142 15.4142 16.75 15 16.75C14.5858 16.75 14.25 16.4142 14.25 16V8C14.25 7.58579 14.5858 7.25 15 7.25ZM12.75 12C12.75 11.5858 12.4142 11.25 12 11.25C11.5858 11.25 11.25 11.5858 11.25 12V16C11.25 16.4142 11.5858 16.75 12 16.75C12.4142 16.75 12.75 16.4142 12.75 16V12ZM9.75 14C9.75 13.5858 9.41421 13.25 9 13.25C8.58579 13.25 8.25 13.5858 8.25 14V16C8.25 16.4142 8.58579 16.75 9 16.75C9.41421 16.75 9.75 16.4142 9.75 16V14Z",
    fill: color
  }));
}

function SearchIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 11.5C5.75 8.32436 8.32436 5.75 11.5 5.75C14.6756 5.75 17.25 8.32436 17.25 11.5C17.25 14.6756 14.6756 17.25 11.5 17.25C8.32436 17.25 5.75 14.6756 5.75 11.5ZM11.5 4.25C7.49594 4.25 4.25 7.49594 4.25 11.5C4.25 15.5041 7.49594 18.75 11.5 18.75C13.2319 18.75 14.8219 18.1427 16.0689 17.1295L18.4697 19.5303C18.7626 19.8232 19.2374 19.8232 19.5303 19.5303C19.8232 19.2374 19.8232 18.7626 19.5303 18.4697L17.1295 16.0689C18.1427 14.8219 18.75 13.2319 18.75 11.5C18.75 7.49594 15.5041 4.25 11.5 4.25Z",
    fill: color
  }));
}

function SettingsIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.97 18.15C10.2 19.11 11.02 19.75 12 19.75C12.98 19.75 13.8 19.11 14.03 18.14C14.05 18.05 14.09 17.97 14.15 17.9C14.21 17.83 14.28 17.78 14.37 17.74C14.45 17.71 14.55 17.69 14.64 17.7C14.73 17.7 14.82 17.73 14.9 17.78C15.74 18.29 16.77 18.17 17.47 17.47C18.17 16.77 18.29 15.74 17.78 14.9C17.74 14.82 17.71 14.73 17.7 14.64C17.69 14.55 17.7 14.46 17.74 14.37C17.77 14.29 17.83 14.21 17.9 14.15C17.98 14.09 18.06 14.04 18.15 14.02C19.11 13.79 19.75 12.97 19.75 11.99C19.75 11.01 19.11 10.19 18.15 9.96C18.06 9.94 17.98 9.9 17.91 9.84C17.84 9.78 17.79 9.71 17.75 9.62C17.72 9.54 17.7 9.45 17.71 9.35C17.71 9.26 17.74 9.17 17.79 9.09C18.3 8.25 18.18 7.22 17.48 6.52C16.78 5.82 15.75 5.7 14.91 6.21C14.83 6.25 14.74 6.28 14.65 6.29C14.56 6.3 14.47 6.29 14.38 6.25C14.29 6.22 14.22 6.16 14.16 6.09C14.1 6.02 14.05 5.94 14.03 5.85C13.8 4.89 12.98 4.25 12 4.25C11.02 4.25 10.2 4.89 9.97 5.84C9.92 6.03 9.8 6.18 9.62 6.25C9.44 6.33 9.25 6.31 9.09 6.21C8.25 5.7 7.21 5.82 6.52 6.52C5.83 7.22 5.7 8.25 6.21 9.09C6.26 9.17 6.29 9.26 6.3 9.35C6.31 9.44 6.29 9.53 6.25 9.62C6.22 9.71 6.16 9.78 6.09 9.84C6.02 9.9 5.94 9.95 5.85 9.97C4.89 10.2 4.25 11.02 4.25 12C4.25 12.98 4.89 13.8 5.85 14.03C5.94 14.05 6.02 14.1 6.09 14.16C6.16 14.22 6.21 14.3 6.25 14.38C6.28 14.46 6.3 14.56 6.29 14.65C6.29 14.74 6.26 14.83 6.21 14.91C5.7 15.75 5.82 16.78 6.52 17.48C7.22 18.18 8.25 18.3 9.1 17.8C9.18 17.75 9.27 17.72 9.36 17.71C9.45 17.7 9.55 17.71 9.63 17.75C9.71 17.78 9.79 17.84 9.85 17.91C9.91 17.98 9.95 18.06 9.97 18.15ZM10.2 16.36C9.94 16.25 9.67 16.2 9.39 16.2C9.34 16.2 9.28 16.2 9.23 16.21C8.9 16.24 8.58 16.34 8.3 16.51C7.94 16.73 7.66 16.5 7.58 16.42C7.5 16.35 7.27 16.07 7.49 15.7C7.66 15.42 7.77 15.1 7.79 14.77C7.82 14.44 7.76 14.11 7.64 13.81C7.52 13.51 7.32 13.24 7.07 13.02C6.82 12.8 6.52 12.65 6.2 12.57C5.78 12.47 5.75 12.11 5.75 12C5.75 11.89 5.78 11.53 6.2 11.43C6.52 11.35 6.82 11.2 7.07 10.99C7.32 10.77 7.52 10.5 7.64 10.2C7.76 9.9 7.82 9.57 7.79 9.24C7.76 8.91 7.66 8.59 7.49 8.31C7.27 7.94 7.5 7.66 7.58 7.58C7.66 7.5 7.94 7.27 8.3 7.49C8.88 7.84 9.57 7.9 10.19 7.64C10.82 7.38 11.27 6.86 11.43 6.2C11.53 5.78 11.89 5.75 12 5.75C12.11 5.75 12.47 5.78 12.57 6.2C12.65 6.52 12.8 6.82 13.01 7.08C13.23 7.33 13.5 7.53 13.8 7.65C14.1 7.77 14.43 7.83 14.76 7.8C15.09 7.77 15.41 7.67 15.69 7.5C16.07 7.28 16.34 7.51 16.42 7.59C16.5 7.67 16.73 7.95 16.51 8.32C16.34 8.6 16.23 8.92 16.21 9.24C16.18 9.56 16.23 9.89 16.36 10.2C16.49 10.51 16.68 10.78 16.93 10.99C17.18 11.2 17.48 11.35 17.8 11.43C18.22 11.53 18.25 11.89 18.25 12C18.25 12.11 18.22 12.47 17.79 12.59C17.47 12.66 17.17 12.82 16.92 13.03C16.67 13.24 16.48 13.52 16.35 13.82C16.23 14.12 16.18 14.45 16.2 14.78C16.23 15.1 16.33 15.42 16.5 15.7C16.72 16.06 16.49 16.34 16.41 16.42C16.33 16.5 16.05 16.73 15.68 16.51C15.4 16.34 15.08 16.23 14.76 16.21C14.44 16.18 14.1 16.23 13.8 16.36C13.5 16.48 13.22 16.68 13.01 16.93C12.8 17.18 12.65 17.48 12.57 17.8C12.47 18.22 12.11 18.25 12 18.25C11.89 18.25 11.53 18.22 11.43 17.8C11.36 17.48 11.2 17.18 10.99 16.93C10.78 16.68 10.5 16.49 10.2 16.36ZM9.25 12C9.25 13.52 10.48 14.75 12 14.75C13.52 14.75 14.75 13.52 14.75 12C14.75 10.48 13.52 9.25 12 9.25C10.48 9.25 9.25 10.48 9.25 12ZM10.75 12C10.75 11.31 11.31 10.75 12 10.75C12.69 10.75 13.25 11.31 13.25 12C13.25 12.69 12.69 13.25 12 13.25C11.31 13.25 10.75 12.69 10.75 12Z",
    fill: color
  }));
}

function AdminReviewIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    d: "M13.4212 3.91116C13.2654 3.75449 13.0537 3.66699 12.832 3.66699H6.9987C6.07953 3.66699 5.33203 4.41449 5.33203 5.33366V18.667C5.33203 19.5862 6.07953 20.3337 6.9987 20.3337H16.9987C17.9179 20.3337 18.6654 19.5862 18.6654 18.667V9.50033C18.6654 9.27866 18.5779 9.06699 18.4212 8.91116L13.4212 3.91116ZM6.9987 5.33366H12.487L16.9987 9.84533L17.0004 17.4903L14.8604 15.3503C15.152 14.8545 15.332 14.2828 15.332 13.667C15.332 11.8287 13.837 10.3337 11.9987 10.3337C10.1604 10.3337 8.66536 11.8287 8.66536 13.667C8.66536 15.5053 10.1604 17.0003 11.9987 17.0003C12.6145 17.0003 13.1862 16.8203 13.682 16.5287L15.8204 18.667H6.9987V5.33366ZM11.9987 15.3337C11.0795 15.3337 10.332 14.5862 10.332 13.667C10.332 12.7478 11.0795 12.0003 11.9987 12.0003C12.9179 12.0003 13.6654 12.7478 13.6654 13.667C13.6654 14.5862 12.9179 15.3337 11.9987 15.3337Z",
    fill: color
  }));
}

function CleaningIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    transform: 'translate(4 4)',
    d: "M0.505687 11.8217L4.23609 15.7334C4.39836 15.9045 4.61876 16 4.84958 16H4.85045H6.58592H6.93302H15.2633V14.1802H9.22558L15.4924 7.60886C16.1692 6.90004 16.1692 5.74446 15.4924 5.03564L11.1962 0.531612C10.5202 -0.177204 9.41821 -0.177204 8.74225 0.531612L4.6205 4.85275L0.495274 9.25942C-0.168544 9.96824 -0.165073 11.1174 0.505687 11.8217ZM9.96923 1.81822L14.2645 6.32225L12.0206 8.67526L7.72526 4.17123L9.96923 1.81822ZM5.85355 6.13299L6.49828 5.45784L10.7936 9.96187L6.8393 14.1083C6.81761 14.1311 6.79852 14.1556 6.77943 14.1802H6.58592H5.20882L1.73354 10.5342L5.85355 6.13299Z",
    fill: color
  }));
}

function ClientManagementIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 12C4 7.6632 7.6632 4 12 4C16.3368 4 20 7.6632 20 12C20 14.552 18.7264 16.8624 16.8 18.3392V18.4H16.7184C15.384 19.396 13.7496 20 12 20C10.2504 20 8.616 19.396 7.2816 18.4H7.2V18.3392C5.2736 16.8624 4 14.5512 4 12ZM11.2 15.6584C10.0544 15.6584 9.0968 16.4656 8.8592 17.5416C9.7936 18.0832 10.8672 18.4 12 18.4C13.1328 18.4 14.2064 18.0832 15.1408 17.5416C14.9032 16.4664 13.9456 15.6584 12.8 15.6584H11.2ZM12.8 14.0584C14.4576 14.0584 15.8824 15.0728 16.488 16.5128C17.6616 15.3456 18.4 13.7408 18.4 12C18.4 8.5304 15.4696 5.6 12 5.6C8.5304 5.6 5.6 8.5304 5.6 12C5.6 13.7408 6.3384 15.3456 7.512 16.5128C8.1168 15.0736 9.5424 14.0584 11.2 14.0584H12.8ZM8.79963 10.4C8.79963 8.57602 10.1756 7.20002 11.9996 7.20002C13.8236 7.20002 15.1996 8.57602 15.1996 10.4C15.1996 12.224 13.8236 13.6 11.9996 13.6C10.1756 13.6 8.79963 12.224 8.79963 10.4ZM10.3996 10.4C10.3996 11.3424 11.0572 12 11.9996 12C12.942 12 13.5996 11.3424 13.5996 10.4C13.5996 9.45762 12.942 8.80002 11.9996 8.80002C11.0572 8.80002 10.3996 9.45762 10.3996 10.4Z",
    fill: color
  }));
}

function DatamappingIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    d: "M17.8947 4.8C16.7335 4.8 15.7895 5.6968 15.7895 6.8C15.7895 7.0856 15.8552 7.3568 15.9697 7.604L14.3234 9.3632C13.7811 9.0096 13.1276 8.8 12.4211 8.8C11.7979 8.8 11.2219 8.9728 10.7208 9.2528L8.80589 7.4344L8.78653 7.4528C8.95158 7.1344 9.05263 6.78 9.05263 6.4C9.05263 5.0744 7.92168 4 6.52632 4C5.13095 4 4 5.0744 4 6.4C4 7.7256 5.13095 8.8 6.52632 8.8C6.92632 8.8 7.29853 8.704 7.63453 8.5472L7.61516 8.5656L9.53011 10.384C9.23368 10.8608 9.05263 11.4088 9.05263 12C9.05263 12.7976 9.37263 13.5192 9.88211 14.0808L7.712 16.1416C7.47453 16.0528 7.21768 16 6.94737 16C5.78695 16 4.84211 16.8968 4.84211 18C4.84211 19.1032 5.78695 20 6.94737 20C8.10779 20 9.05263 19.1032 9.05263 18C9.05263 17.7432 8.99705 17.4992 8.90358 17.2728L11.2935 15.0024C11.648 15.1224 12.0236 15.2 12.4211 15.2C14.2787 15.2 15.7895 13.7648 15.7895 12C15.7895 11.4912 15.6522 11.0168 15.4291 10.5888L17.2118 8.6824C17.4274 8.7528 17.6547 8.8 17.8947 8.8C19.056 8.8 20 7.9032 20 6.8C20 5.6968 19.056 4.8 17.8947 4.8ZM12.4211 13.6C11.4922 13.6 10.7368 12.8824 10.7368 12C10.7368 11.1176 11.4922 10.4 12.4211 10.4C13.3499 10.4 14.1053 11.1176 14.1053 12C14.1053 12.8824 13.3499 13.6 12.4211 13.6Z",
    fill: color
  }));
}

function FinalRevIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    d: "M19.9577 9.7432C19.8545 9.4408 19.5817 9.2272 19.2633 9.2024L14.7023 8.84L12.7287 4.4712C12.5999 4.184 12.3143 4 11.9999 4C11.6854 4 11.3998 4.184 11.271 4.4704L9.29737 8.84L4.73642 9.2024C4.42361 9.2272 4.154 9.4328 4.04759 9.728C3.94119 10.0232 4.01639 10.3536 4.2412 10.5728L7.61171 13.8584L6.41967 19.02C6.34607 19.3392 6.47487 19.6712 6.74448 19.8576C6.88209 19.952 7.04049 20 7.1997 20C7.3541 20 7.50931 19.9552 7.64371 19.8656L11.9999 16.9616L16.356 19.8656C16.6344 20.0512 17 20.044 17.272 19.8464C17.5424 19.6488 17.6616 19.3024 17.5696 18.9808L16.1064 13.8608L19.7353 10.5952C19.9729 10.3808 20.0601 10.0464 19.9577 9.7432Z",
    fill: color
  }));
}

function ImageIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 6.55556C4.75 6.2016 5.11295 5.75 5.77778 5.75H18.2222C18.8871 5.75 19.25 6.2016 19.25 6.55556V17.4444C19.25 17.7984 18.8871 18.25 18.2222 18.25H5.77778C5.11295 18.25 4.75 17.7984 4.75 17.4444V6.55556ZM5.77778 4.25C4.47893 4.25 3.25 5.19129 3.25 6.55556V17.4444C3.25 18.8087 4.47893 19.75 5.77778 19.75H18.2222C19.5211 19.75 20.75 18.8087 20.75 17.4444V6.55556C20.75 5.19129 19.5211 4.25 18.2222 4.25H5.77778ZM9.52864 11.2941C9.61648 11.1652 9.81143 11.182 9.87596 11.324L10.4909 12.6768C10.5554 12.8188 10.7504 12.8355 10.8382 12.7067L13.1901 9.25726C13.2721 9.13701 13.4509 9.1418 13.5264 9.26626L16.8176 14.6967C16.8983 14.83 16.8024 15.0004 16.6465 15.0004H7.38003C7.21934 15.0004 7.12426 14.8205 7.21478 14.6877L9.52864 11.2941Z",
    fill: color
  }));
}

function ImageImportIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.77778 5.75C5.11295 5.75 4.75 6.2016 4.75 6.55556V17.4444C4.75 17.7984 5.11295 18.25 5.77778 18.25H12.5H13H13.5C13.9142 18.25 14.25 18.5858 14.25 19C14.25 19.4142 13.9142 19.75 13.5 19.75H13H12.5H5.77778C4.47893 19.75 3.25 18.8087 3.25 17.4444V6.55556C3.25 5.19129 4.47893 4.25 5.77778 4.25H18.2222C19.5211 4.25 20.75 5.19129 20.75 6.55556V11V12C20.75 12.4142 20.4142 12.75 20 12.75C19.5858 12.75 19.25 12.4142 19.25 12V11V6.55556C19.25 6.2016 18.8871 5.75 18.2222 5.75H5.77778ZM9.52864 11.2941C9.61648 11.1652 9.81143 11.182 9.87596 11.324L10.4909 12.6768C10.5554 12.8188 10.7504 12.8355 10.8382 12.7067L13.1901 9.25726C13.2721 9.13701 13.4509 9.1418 13.5264 9.26626L16.8176 14.6967C16.8983 14.83 16.8024 15.0004 16.6465 15.0004H7.38003C7.21934 15.0004 7.12426 14.8205 7.21478 14.6877L9.52864 11.2941ZM19 14.25C19.4142 14.25 19.75 14.5858 19.75 15V17.25H22C22.4142 17.25 22.75 17.5858 22.75 18C22.75 18.4142 22.4142 18.75 22 18.75H19.75V21C19.75 21.4142 19.4142 21.75 19 21.75C18.5858 21.75 18.25 21.4142 18.25 21V18.75H16C15.5858 18.75 15.25 18.4142 15.25 18C15.25 17.5858 15.5858 17.25 16 17.25H18.25V15C18.25 14.5858 18.5858 14.25 19 14.25Z",
    fill: color
  }));
}

function InitialRevIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    d: "M6.41984 19.02C6.34624 19.3392 6.47424 19.6712 6.74465 19.8576C6.88225 19.952 7.04065 20 7.19986 20C7.35426 20 7.50946 19.9552 7.64387 19.8656L12 16.9616L16.356 19.8656C16.6344 20.0512 16.9993 20.044 17.2721 19.8464C17.5425 19.6488 17.6617 19.3024 17.5697 18.9808L16.1064 13.8608L19.7353 10.5952C19.9729 10.3816 20.0601 10.0464 19.9577 9.744C19.8545 9.4416 19.5817 9.228 19.2633 9.2032L14.7024 8.84L12.7288 4.4712C12.6 4.184 12.3144 4 12 4C11.6855 4 11.3999 4.184 11.2711 4.4704L9.2975 8.84L4.73661 9.2024C4.423 9.2272 4.1534 9.4328 4.04779 9.728C3.94059 10.0232 4.01739 10.3536 4.2414 10.5728L7.61267 13.8584L6.41984 19.02ZM12 6.7432L13.6336 10.36L14.104 10.3976C14.1048 10.3976 14.1048 10.3976 14.1048 10.3976L17.2825 10.6496L14.6656 13.0048C14.6648 13.0056 14.6648 13.0056 14.6648 13.0064L14.2944 13.3392L14.4312 13.8168C14.4312 13.8168 14.4312 13.8184 14.4312 13.8192L15.4336 17.3272L12 15.0384V6.7432Z",
    fill: color
  }));
}

function PotentialCasesIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49966 12.0003C4.03943 12.0003 3.66192 11.6263 3.70675 11.1683C3.78839 10.3341 3.99332 9.5242 4.318 8.75199C4.73716 7.75783 5.33716 6.86616 6.10133 6.10283C6.868 5.33699 7.7605 4.73699 8.75133 4.32033C10.7613 3.47283 13.088 3.46033 15.1138 4.27116C15.4897 3.89699 16.0088 3.66699 16.583 3.66699C17.738 3.66699 18.6663 4.59533 18.6663 5.75033C18.6663 6.90533 17.738 7.83366 16.583 7.83366C15.453 7.83366 14.5455 6.94283 14.5072 5.82199C12.883 5.16699 11.0122 5.17616 9.39883 5.85616C8.60633 6.18866 7.893 6.66866 7.2805 7.28116C6.6705 7.89116 6.18966 8.60366 5.8555 9.39866C5.61617 9.96592 5.45826 10.5586 5.38342 11.169C5.32741 11.6258 4.9599 12.0003 4.49966 12.0003ZM16.7188 16.7195C17.3297 16.1087 17.8097 15.3953 18.1438 14.602C18.3831 14.0343 18.541 13.4416 18.6158 12.8316C18.6719 12.3748 19.0394 12.0003 19.4997 12.0003C19.9599 12.0003 20.3374 12.3743 20.2926 12.8324C20.2109 13.6663 20.0058 14.4759 19.6805 15.2487C19.2613 16.242 18.6613 17.1337 17.8972 17.8978C17.133 18.662 16.2405 19.262 15.2472 19.6812C14.2205 20.1137 13.128 20.3337 11.9997 20.3337C10.9197 20.3337 9.87383 20.127 8.8855 19.7295C8.50966 20.1037 7.9905 20.3337 7.41633 20.3337C6.26133 20.3337 5.333 19.4053 5.333 18.2503C5.333 17.0953 6.26133 16.167 7.41633 16.167C8.54633 16.167 9.45383 17.0578 9.49216 18.1787C11.1163 18.8337 12.9872 18.8245 14.6005 18.1445C15.3947 17.8103 16.108 17.3303 16.7188 16.7195ZM8.21711 12.0004C8.21711 9.91542 9.91378 8.21875 11.9988 8.21875C14.0838 8.21875 15.7804 9.91542 15.7804 12.0004C15.7804 14.0854 14.0838 15.7821 11.9988 15.7821C9.91378 15.7821 8.21711 14.0854 8.21711 12.0004ZM9.88378 12.0004C9.88378 13.1663 10.8329 14.1154 11.9988 14.1154C13.1646 14.1154 14.1138 13.1663 14.1138 12.0004C14.1138 10.8346 13.1646 9.88542 11.9988 9.88542C10.8329 9.88542 9.88378 10.8346 9.88378 12.0004Z",
    fill: color
  }));
}

function ScanIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    d: "M12.0013 3.66699C7.4838 3.66699 3.66797 7.48366 3.66797 12.0003C3.66797 16.517 7.4838 20.3337 12.0013 20.3337C16.5188 20.3337 20.3346 16.517 20.3346 12.0003C20.3346 7.48366 16.5188 3.66699 12.0013 3.66699ZM12.0013 18.667C8.38714 18.667 5.33464 15.6137 5.33464 12.0003C5.33464 8.66866 7.93047 5.81949 11.168 5.39449V7.07533C8.80714 7.47449 7.0013 9.52783 7.0013 12.0003C7.0013 14.7578 9.2438 17.0003 12.0013 17.0003C13.0518 17.0003 14.0554 16.6745 14.8978 16.0701C15.2718 15.8018 15.2685 15.2673 14.9432 14.9418C14.6177 14.6161 14.0936 14.6276 13.6987 14.8645C13.1885 15.1705 12.6064 15.3337 12.0013 15.3337C10.163 15.3337 8.66797 13.8387 8.66797 12.0003C8.66797 10.452 9.7338 9.15783 11.168 8.78533V10.5737C10.6763 10.8678 10.3346 11.4012 10.3346 12.0003C10.3346 12.9012 11.1005 13.667 12.0013 13.667C12.9021 13.667 13.668 12.9012 13.668 12.0003C13.668 11.4012 13.3263 10.8678 12.8346 10.5737V5.39449C16.0721 5.81949 18.668 8.66866 18.668 12.0003C18.668 15.6137 15.6155 18.667 12.0013 18.667Z",
    fill: color
  }));
}

function SystemStatusIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.55078 6.39961C5.55078 5.85414 5.932 5.5498 6.24089 5.5498H17.7618C18.0707 5.5498 18.4519 5.85414 18.4519 6.39961V14.3986C18.4519 14.9441 18.0707 15.2484 17.7618 15.2484H6.24089C5.932 15.2484 5.55078 14.9441 5.55078 14.3986V12.1138H6.79454C7.28833 12.1138 7.72572 11.8316 7.90811 11.3956L8.4295 10.1545L10.2517 14.06C10.3489 14.2674 10.5643 14.3994 10.8006 14.3994C10.8102 14.3994 10.8198 14.3994 10.8294 14.3989C11.0772 14.3869 11.292 14.2326 11.3694 14.0086L13.1178 9.01346L13.7052 11.2482C13.8384 11.7579 14.3172 12.1138 14.8692 12.1138H16.2291C16.5447 12.1138 16.8005 11.858 16.8005 11.5425C16.8005 11.2269 16.5447 10.9711 16.2291 10.9711H14.8686L13.7826 6.83245C13.7184 6.58618 13.4904 6.40962 13.2234 6.40047C12.9642 6.38619 12.7158 6.54961 12.6318 6.79074L10.7202 12.2498L8.94909 8.45349C8.85129 8.24379 8.6239 8.10609 8.3893 8.11408C8.14811 8.11866 7.93271 8.25979 7.84331 8.47292L6.79454 10.9711H5.55078V6.39961ZM6.24089 4.0498C4.95909 4.0498 4.05078 5.17798 4.05078 6.39961V14.3986C4.05078 15.6203 4.95909 16.7484 6.24089 16.7484H11.2513V18.448H9.12095C8.70674 18.448 8.37095 18.7838 8.37095 19.198C8.37095 19.6123 8.70674 19.948 9.12095 19.948H11.9989L12.0013 19.948L12.0037 19.948H14.8814C15.2956 19.948 15.6314 19.6123 15.6314 19.198C15.6314 18.7838 15.2956 18.448 14.8814 18.448H12.7513V16.7484H17.7618C19.0436 16.7484 19.9519 15.6203 19.9519 14.3986V6.39961C19.9519 5.17798 19.0436 4.0498 17.7618 4.0498H6.24089Z",
    fill: color
  }));
}

function TextIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 7C5.44772 7 5 7.44772 5 8C5 8.55228 5.44772 9 6 9H7.5H9C9.55228 9 10 8.55228 10 8C10 7.44772 9.55228 7 9 7H7.5H6ZM5 12C5 11.4477 5.44772 11 6 11H18C18.5523 11 19 11.4477 19 12C19 12.5523 18.5523 13 18 13H6C5.44772 13 5 12.5523 5 12ZM5 16C5 15.4477 5.44772 15 6 15H18C18.5523 15 19 15.4477 19 16C19 16.5523 18.5523 17 18 17H6C5.44772 17 5 16.5523 5 16Z",
    fill: color
  }));
}

function WhitelistIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    d: "M4 6.96688C4 6.43289 4.43289 6 4.96688 6H13.5651C14.0991 6 14.532 6.43289 14.532 6.96688C14.532 7.50088 14.0991 7.93377 13.5651 7.93377H4.96688C4.43289 7.93377 4 7.50088 4 6.96688ZM4 10.8344C4 10.3004 4.43289 9.86754 4.96688 9.86754H13.5651C14.0991 9.86754 14.532 10.3004 14.532 10.8344C14.532 11.3684 14.0991 11.8013 13.5651 11.8013H4.96688C4.43289 11.8013 4 11.3684 4 10.8344ZM4 14.702C4 14.168 4.43289 13.7351 4.96688 13.7351H9.73529C10.2693 13.7351 10.7022 14.168 10.7022 14.702C10.7022 15.236 10.2693 15.6688 9.73529 15.6688H4.96688C4.43289 15.6688 4 15.236 4 14.702ZM19.331 11.8084C18.955 11.4275 18.3404 11.4268 17.9635 11.8067L14.531 15.2657L13.978 14.7077C13.6013 14.3275 12.9869 14.3278 12.6105 14.7082C12.2392 15.0833 12.2394 15.6875 12.611 16.0624L14.386 17.8536C14.4659 17.9343 14.5962 17.9343 14.6761 17.8537L19.3295 13.1619C19.7009 12.7874 19.7016 12.1837 19.331 11.8084Z",
    fill: color
  }));
}

function CheckboxIcon(props) {
  var _a = props.checked,
      checked = _a === void 0 ? false : _a,
      _b = props.fillColor,
      fillColor = _b === void 0 ? '#F4F5F5' : _b,
      _c = props.color,
      color = _c === void 0 ? '#48D2A0' : _c,
      otherProps = __rest(props, ["checked", "fillColor", "color"]);

  return React.createElement(SvgIcon, _assign({
    viewBox: '0 0 20 20'
  }, otherProps), React.createElement("rect", {
    x: "0.5",
    y: "0.5",
    width: "19",
    height: "19",
    rx: "3.5",
    fill: checked ? color : fillColor,
    stroke: checked ? color : '#E9EAEC'
  }), checked ? React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5384 5.47789C16.8268 5.77526 16.8195 6.25007 16.5221 6.53843L8.27211 14.5384C7.98119 14.8205 7.51881 14.8205 7.22789 14.5384L3.47789 10.9021C3.18053 10.6137 3.17322 10.1389 3.46158 9.84153C3.74993 9.54416 4.22475 9.53686 4.52211 9.82521L7.75 12.9553L15.4779 5.46158C15.7753 5.17322 16.2501 5.18053 16.5384 5.47789Z",
    fill: "white"
  }) : React.createElement(React.Fragment, null));
}

function SpinnerIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? green : _a,
      otherProps = __rest(props, ["color"]);

  return React.createElement(SvgIcon, _assign({
    viewBox: '0 0 20 20'
  }, otherProps), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.750001 10.0004C1.16421 10.0004 1.49654 9.66346 1.5326 9.25082C1.91209 4.90747 5.55816 1.50039 10 1.50039C14.6944 1.50039 18.5 5.30597 18.5 10.0004C18.5 14.4422 15.0929 18.0883 10.7496 18.4678C10.3369 18.5038 10 18.8362 10 19.2504C10 19.6646 10.337 20.0033 10.75 19.9727C15.9226 19.5891 20 15.2709 20 10.0004C20 4.47754 15.5228 0.0003868 10 0.000386318C4.72946 0.000385857 0.411249 4.07782 0.0277052 9.25035C-0.00292497 9.66343 0.335788 10.0004 0.750001 10.0004Z",
    fill: color
  }));
}

function FolderIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.size,
      size = _b === void 0 ? 'medium' : _b,
      className = props.className,
      otherProps = __rest(props, ["color", "size", "className"]);

  var mergeClasses = useIconClassname(size).mergeClasses;
  return React.createElement(SvgIcon, _assign({}, otherProps, {
    className: mergeClasses(className)
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3945 3.45455C3.15361 3.45455 2.92259 3.5482 2.75226 3.7149C2.58193 3.88159 2.48624 4.10769 2.48624 4.34343V15.6566C2.48624 15.8923 2.58193 16.1184 2.75226 16.2851C2.92259 16.4518 3.15361 16.5455 3.3945 16.5455H16.6055C16.8464 16.5455 17.0774 16.4518 17.2477 16.2851C17.4181 16.1184 17.5138 15.8923 17.5138 15.6566V6.76768C17.5138 6.53193 17.4181 6.30584 17.2477 6.13914C17.0774 5.97244 16.8464 5.87879 16.6055 5.87879H9.17431C8.92585 5.87879 8.69382 5.75726 8.556 5.55493L7.12523 3.45455H3.3945ZM1.70133 2.68638C2.15039 2.2469 2.75944 2 3.3945 2H7.52294C7.7714 2 8.00343 2.12153 8.14125 2.32385L9.57202 4.42424H16.6055C17.2406 4.42424 17.8496 4.67114 18.2987 5.11062C18.7477 5.5501 19 6.14616 19 6.76768V15.6566C19 16.2781 18.7477 16.8741 18.2987 17.3136C17.8496 17.7531 17.2406 18 16.6055 18H3.3945C2.75944 18 2.15039 17.7531 1.70133 17.3136C1.25228 16.8741 1 16.2781 1 15.6566V4.34343C1 3.72192 1.25228 3.12586 1.70133 2.68638Z",
    fill: color
  }));
}

function FolderFilledIcon(props) {
  var _a = props.color,
      color = _a === void 0 ? '#fff' : _a,
      _b = props.fillColor,
      fillColor = _b === void 0 ? '#000' : _b,
      otherProps = __rest(props, ["color", "fillColor"]);

  return React.createElement(SvgIcon, _assign({
    viewBox: '0 0 32 32'
  }, otherProps), React.createElement("path", {
    d: "M12.5 5H3.5L3 11.5L3.5 27H28.5L29 9L14.5 8.5L12.5 5Z",
    fill: fillColor
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.43129 5.52722C5.04587 5.52722 4.67624 5.67706 4.40371 5.94378C4.13118 6.2105 3.97808 6.57225 3.97808 6.94945V25.0505C3.97808 25.4277 4.13118 25.7894 4.40371 26.0561C4.67624 26.3228 5.04588 26.4727 5.43129 26.4727H26.5689C26.9543 26.4727 27.3239 26.3228 27.5965 26.0561C27.869 25.7894 28.0221 25.4277 28.0221 25.0505V10.8282C28.0221 10.451 27.869 10.0893 27.5965 9.82257C27.3239 9.55585 26.9543 9.40601 26.5689 9.40601H14.679C14.2815 9.40601 13.9102 9.21157 13.6897 8.88784L11.4005 5.52722H5.43129ZM2.72223 4.29815C3.44072 3.59499 4.41519 3.19995 5.43129 3.19995H12.0368C12.4343 3.19995 12.8056 3.3944 13.0261 3.71812L15.3153 7.07874H26.5689C27.585 7.07874 28.5595 7.47377 29.278 8.17694C29.9965 8.88011 30.4001 9.83381 30.4001 10.8282V25.0505C30.4001 26.0449 29.9965 26.9986 29.278 27.7017C28.5595 28.4049 27.585 28.7999 26.5689 28.7999H5.43129C4.41519 28.7999 3.44072 28.4049 2.72223 27.7017C2.00374 26.9986 1.6001 26.0449 1.6001 25.0505V6.94945C1.6001 5.95502 2.00374 5.00132 2.72223 4.29815Z",
    fill: color
  }));
}

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ArchiveIcon: ArchiveIcon,
  ArrowIcon: ArrowIcon,
  CheckIcon: CheckIcon,
  ChevronIcon: ChevronIcon,
  CloseIcon: CloseIcon,
  CommentIcon: CommentIcon,
  CompareIcon: CompareIcon,
  CopyIcon: CopyIcon,
  CounterpartyIcon: CounterpartyIcon,
  DotsIcon: DotsIcon,
  DownloadIcon: DownloadIcon,
  FileIcon: FileIcon,
  FilterIcon: FilterIcon,
  FingerprintIcon: FingerprintIcon,
  HelpIcon: HelpIcon,
  InformationIcon: InformationIcon,
  LegalIcon: LegalIcon,
  LinkIcon: LinkIcon,
  LogoutIcon: LogoutIcon,
  Logo: Logo,
  SortingIcon: SortingIcon,
  TrashIcon: TrashIcon,
  UploadIcon: UploadIcon,
  UserIcon: UserIcon,
  ActivityIcon: ActivityIcon,
  DashboardIcon: DashboardIcon,
  InReviewIcon: InReviewIcon,
  NotificationsIcon: NotificationsIcon,
  PauseIcon: PauseIcon,
  PreApprovalsIcon: PreApprovalsIcon,
  ReportsIcon: ReportsIcon,
  SearchIcon: SearchIcon,
  SettingsIcon: SettingsIcon,
  AdminReviewIcon: AdminReviewIcon,
  CleaningIcon: CleaningIcon,
  ClientManagementIcon: ClientManagementIcon,
  DatamappingIcon: DatamappingIcon,
  FinalReviewIcon: FinalRevIcon,
  ImageIcon: ImageIcon,
  ImageImportIcon: ImageImportIcon,
  InitialReviewIcon: InitialRevIcon,
  PotentialCasesIcon: PotentialCasesIcon,
  ScanIcon: ScanIcon,
  SystemStatusIcon: SystemStatusIcon,
  TextIcon: TextIcon,
  WhitelistIcon: WhitelistIcon,
  CheckboxIcon: CheckboxIcon,
  SpinnerIcon: SpinnerIcon,
  FolderIcon: FolderIcon,
  FolderFilledIcon: FolderFilledIcon
});
/* eslint-disable @typescript-eslint/no-explicit-any */

var useStyle = makeStyles({
  root: {
    display: 'block',
    width: '100%',
    height: 'auto',
    position: 'relative',
    overflow: 'hidden',
    backgroundColor: 'rgb(243, 243, 243)',
    cursor: function cursor(_a) {
      var onPreview = _a.onPreview;
      return onPreview ? 'pointer' : 'inherit';
    },
    '&::after': {
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      content: '""',
      position: 'absolute',
      animation: 'wawe 2s linear infinite',
      display: 'block',
      transform: 'translateX(-100%)',
      background: 'linear-gradient(90deg, transparent, rgb(236, 235, 235), transparent)'
    }
  },
  overlayContainer: {
    position: 'relative',
    overflow: 'hidden',
    '&:hover > div': {
      opacity: 1
    },
    '&:hover > svg': {
      opacity: 1
    }
  },
  overlay: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    width: '100%',
    height: '100%',
    cursor: 'pointer',
    opacity: 0,
    background: 'rgba(41, 56, 51, .48)',
    transition: 'all 250ms ease-in-out'
  },
  linkIcon: {
    zIndex: 2,
    opacity: 0,
    transition: 'opacity 250ms ease-in-out',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    cursor: 'pointer'
  }
});

var ImageComponent = function ImageComponent(_a) {
  var src = _a.src,
      alt = _a.alt,
      className = _a.className,
      overlayClassName = _a.overlayClassName,
      onLoad = _a.onLoad,
      onPreview = _a.onPreview;
  var classes = useStyle({
    onPreview: !!onPreview
  });

  var _b = useState(false),
      loaded = _b[0],
      setLoaded = _b[1];

  useEffect(function () {
    if (!src) return;
    setLoaded(false);
    if (onLoad) onLoad(false);
    var image = new Image();
    image.src = src;

    image.onload = function () {
      setLoaded(true);
      if (onLoad) onLoad(true);
    };
  }, [src]);

  var handleOnPreview = function handleOnPreview(e) {
    e.stopPropagation();
    onPreview === null || onPreview === void 0 ? void 0 : onPreview();
  };

  var renderImage = useMemo(function () {
    var image = React.createElement("img", {
      src: src,
      className: classes.root + " " + className,
      alt: alt || '',
      // if onPreview is provided, handler for it is attached to <div> instead
      onClick: onPreview ? undefined : handleOnPreview
    });

    if (!loaded) {
      return React.createElement("div", {
        className: classes.root + " " + className
      });
    }

    return onPreview ? React.createElement("div", {
      className: classes.overlayContainer + " " + overlayClassName,
      onClick: handleOnPreview
    }, image, React.createElement(LinkIcon, {
      external: true,
      className: classes.linkIcon
    }), React.createElement("div", {
      className: classes.overlay
    })) : image;
  }, [loaded, alt, src, classes, className, onPreview]);
  return renderImage;
};

var useStyle$1 = makeStyles({
  root: {
    display: 'flex'
  }
});

var Logo$1 = function Logo$1(_a) {
  var src = _a.src,
      className = _a.className;
  var classes = useStyle$1();
  return React.createElement("img", {
    src: src,
    className: classes.root + " " + className,
    alt: 'logo'
  });
};

var useStyle$2 = makeStyles({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
  }
});

var PageContainer = function PageContainer(_a) {
  var children = _a.children,
      onScroll = _a.onScroll,
      className = _a.className;
  var defaultStyle = useStyle$2();
  return React.createElement("div", {
    onScroll: onScroll,
    className: defaultStyle.root + " " + (className || '')
  }, children);
};

var useStyle$3 = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  }
});

var Row = function Row(_a) {
  var id = _a.id,
      children = _a.children,
      className = _a.className,
      _b = _a.justify,
      justify = _b === void 0 ? 'center' : _b,
      _c = _a.align,
      align = _c === void 0 ? 'center' : _c,
      style = _a.style,
      onClick = _a.onClick;
  var classes = useStyle$3();
  return React.createElement("div", {
    id: id,
    className: classes.root + " " + className,
    style: _assign({
      alignItems: align,
      justifyContent: justify
    }, style),
    onClick: onClick
  }, children);
};

var useStyle$4 = makeStyles$1(function (theme) {
  var _a;

  return {
    root: (_a = {
      position: 'fixed',
      width: 'calc(100% - 240px)',
      backgroundColor: 'white',
      padding: '19px 24px'
    }, _a[theme.breakpoints.down('md')] = {
      width: 'calc(100% - 60px)'
    }, _a.height = 72, _a.zIndex = 2, _a),
    whiteCorner: {
      position: 'absolute',
      backgroundColor: 'white',
      width: 20,
      height: 20,
      top: 72,
      left: 0,
      backgroundImage: "radial-gradient(circle at 20px 20px, " + dark5 + " 0, " + dark5 + " 20px, white 20px)"
    }
  };
});

var PageTitle = function PageTitle(_a) {
  var children = _a.children,
      hasBreadcrumbs = _a.hasBreadcrumbs;
  var classes = useStyle$4();
  return React.createElement(Row, {
    justify: 'space-between',
    className: classes.root
  }, React.createElement(Fragment, null, children, !hasBreadcrumbs && React.createElement("span", {
    className: classes.whiteCorner
  })));
};

var useStyle$5 = makeStyles(function (theme) {
  var _a, _b;

  return {
    root: (_a = {
      backgroundColor: dark5,
      borderTopLeftRadius: 20,
      padding: 24
    }, _a[theme.breakpoints.down('md')] = {
      padding: 20,
      marginTop: 72
    }, _a.flex = 1, _a.marginTop = 72, _a),
    hasBreadcrumbs: (_b = {
      borderTopLeftRadius: 0,
      marginTop: 0
    }, _b[theme.breakpoints.down('md')] = {
      marginTop: 0
    }, _b)
  };
});

var PageBody = function PageBody(_a) {
  var children = _a.children,
      className = _a.className,
      hasBreadcrumbs = _a.hasBreadcrumbs;
  var classes = useStyle$5();
  return React.createElement("div", {
    className: clsx(classes.root, className, hasBreadcrumbs ? classes.hasBreadcrumbs : '')
  }, children);
};

var useStyles$1 = makeStyles$1(function () {
  return {
    breadcrumbsBanner: {
      backgroundColor: dark10,
      height: 50,
      padding: '15px 35px',
      marginTop: 72
    },
    separator: {
      margin: 0,
      '& svg': {
        width: 14
      }
    },
    link: {
      fontSize: 14,
      color: dark50,
      fontWeight: 600,
      textTransform: 'capitalize'
    },
    lastLink: {
      color: dark75,
      fontWeight: 600,
      textTransform: 'capitalize'
    }
  };
});

var BreadcrumbsBanner = function BreadcrumbsBanner(_a) {
  var path = _a.path,
      title = _a.title;
  var classes = useStyles$1();
  var links = [];
  var pathElements = path.split('/').filter(function (el) {
    return el.length > 0;
  });
  if (pathElements[pathElements.length - 1] === 'dashboard') return null;

  if (pathElements[pathElements.length - 1].toUpperCase() === title.toUpperCase()) {
    links.push({
      name: 'Overview',
      href: path
    });
  } else {
    pathElements.forEach(function (item) {
      if (item !== 'dashboard') {
        links.push({
          name: item,
          href: path.slice(0, path.indexOf(item) + item.length)
        });
      }
    });
  }

  return React.createElement(Breadcrumbs, {
    separator: React.createElement(ChevronIcon, {
      direction: 'right',
      color: dark50
    }),
    "aria-label": "breadcrumb",
    classes: {
      root: classes.breadcrumbsBanner,
      separator: classes.separator
    }
  }, links.length === 1 && React.createElement(Typography$1, {
    className: classes.link
  }, title), links.map(function (link, key) {
    return React.createElement(Link, {
      key: key,
      href: link.href,
      className: key === links.length - 1 ? classes.lastLink : classes.link
    }, link.name);
  }));
};

var useStyles$2 = makeStyles$1(function () {
  return {
    title: {
      fontWeight: 600,
      paddingTop: 0
    }
  };
});

var Page = function Page(props) {
  var title = props.title,
      children = props.children,
      breadcrumbPath = props.breadcrumbPath;
  var classes = useStyles$2();
  var hasBreadcrumbs = breadcrumbPath !== undefined;
  return React.createElement(PageContainer, null, React.createElement(PageTitle, {
    hasBreadcrumbs: hasBreadcrumbs
  }, React.createElement(Typography$1, {
    variant: 'h5',
    className: classes.title
  }, title)), hasBreadcrumbs && React.createElement(BreadcrumbsBanner, {
    title: title,
    path: breadcrumbPath || ''
  }), React.createElement(PageBody, {
    hasBreadcrumbs: hasBreadcrumbs
  }, children));
};

var useStyle$6 = makeStyles(function () {
  return createStyles({
    root: {
      width: '100%',
      backgroundColor: 'white',
      padding: '0 35px',
      height: 80,
      zIndex: 2
    }
  });
});

var SlimPageTitle = function SlimPageTitle(_a) {
  var children = _a.children;
  var theme = useTheme();
  var classes = useStyle$6(theme);
  return React.createElement(Row, {
    justify: 'space-between',
    className: classes.root
  }, React.createElement(Fragment, null, children));
};

var useStyle$7 = makeStyles(function () {
  return {
    root: {
      backgroundColor: dark5,
      borderTopLeftRadius: 0,
      padding: 35,
      paddingBottom: 25,
      flex: 1
    },
    rounded: {
      borderTopLeftRadius: 20
    }
  };
});

var SlimPageBody = function SlimPageBody(_a) {
  var children = _a.children,
      className = _a.className,
      rounded = _a.rounded;
  var classes = useStyle$7();
  return React.createElement("div", {
    className: clsx(classes.root, className, rounded ? classes.rounded : '')
  }, children);
};

var SlimPage = function SlimPage(props) {
  var title = props.title,
      children = props.children,
      path = props.path,
      hasBreadcrumbs = props.hasBreadcrumbs;
  return React.createElement(PageContainer, null, React.createElement(SlimPageTitle, null, React.createElement(Typography$1, {
    variant: 'h4'
  }, title)), hasBreadcrumbs && React.createElement(BreadcrumbsBanner, {
    title: title,
    path: path
  }), React.createElement(SlimPageBody, null, children));
};

var useStyle$8 = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  }
});

var Col = function Col(_a) {
  var _b = _a.align,
      align = _b === void 0 ? 'flex-start' : _b,
      children = _a.children,
      _c = _a.className,
      className = _c === void 0 ? '' : _c,
      _d = _a.justify,
      justify = _d === void 0 ? 'center' : _d,
      style = _a.style;
  var classes = useStyle$8();
  return React.createElement("div", {
    className: classes.root + " " + className,
    style: _assign({
      alignItems: align,
      justifyContent: justify
    }, style)
  }, children);
};

var Typography = function Typography(props) {
  var _a = props.variant,
      variant = _a === void 0 ? 'body2' : _a,
      className = props.className,
      fontWeight = props.fontWeight,
      fontStyle = props.fontStyle,
      fontColor = props.fontColor,
      style = props.style,
      children = props.children,
      other = __rest(props, ["variant", "className", "fontWeight", "fontStyle", "fontColor", "style", "children"]);

  var finalStyle = _assign(_assign({}, style), {
    fontWeight: fontWeight,
    fontStyle: fontStyle
  });

  if (fontColor) finalStyle.color = fontColor;
  return React.createElement(Typography$1, _assign({}, other, {
    variant: variant,
    className: className,
    style: finalStyle
  }), children);
};

var useStyles$3 = makeStyles(function () {
  return createStyles$1({
    list: {
      display: 'flex',
      flexFlow: 'column wrap',
      justifyContent: 'flex-start',
      height: '100%'
    },
    card: {
      display: 'flex',
      flexFlow: 'column wrap',
      justifyContent: 'flex-start',
      height: '100%',
      borderRadius: 6,
      backgroundColor: 'white',
      padding: '24px !important',
      boxShadow: '0px 0px 1px rgba(41, 50, 65, 0.25)'
    },
    listHeader: {
      color: 'black',
      fontWeight: 600,
      paddingBottom: 12
    },
    listItem: {
      height: 40,
      borderRadius: 6,
      marginBottom: 6,
      '&:hover': {
        backgroundColor: dark5,
        '& > div > span': {
          color: 'black'
        },
        '& svg path': {
          fill: 'black'
        }
      }
    },
    listItemText: {
      '& > span': {
        color: dark50,
        cursor: 'pointer',
        fontWeight: 600,
        lineHeight: '20px',
        fontSize: 14
      }
    },
    logout: {
      '& > div > span': {
        color: dark50
      },
      '& svg path': {
        fill: dark50
      },
      marginTop: 'auto'
    },
    selectedListItem: {
      backgroundColor: green10 + "!important",
      '& svg path': {
        fill: green
      },
      '& > div > span': {
        color: green
      },
      '&:hover': {
        '& > div > span': {
          color: green
        }
      }
    },
    listItemIcon: {
      minWidth: 'unset',
      marginRight: 12,
      '& svg': {
        width: 16
      }
    }
  });
});

var SubMenu = function SubMenu(props) {
  var menuItems = props.menuItems,
      handleClick = props.handleClick,
      logout = props.logout,
      path = props.path;
  var classes = useStyles$3();
  return React.createElement(Fragment, null, React.createElement(List, {
    className: classes.card
  }, menuItems.map(function (section, index) {
    return React.createElement(Fragment, {
      key: index
    }, React.createElement(ListSubheader, {
      component: "div",
      className: classes.listHeader
    }, React.createElement(Typography, {
      variant: 'h5',
      fontWeight: "bolder"
    }, section.title)), React.createElement(Fragment, null, section.links.map(function (link, linkIndex) {
      var selected = path.match(link.regex) !== null;
      return React.createElement(ListItem, {
        key: linkIndex,
        onClick: function onClick() {
          return handleClick(link);
        },
        classes: {
          root: classes.listItem,
          selected: classes.selectedListItem
        },
        selected: selected,
        button: true
      }, React.createElement(ListItemText, {
        primary: link.label,
        className: classes.listItemText
      }));
    })));
  }), logout));
};

function InfiniteLoader(props) {
  var itemList = props.itemList,
      totalItemCount = props.totalItemCount,
      getItems = props.getItems,
      rowRender = props.rowRender;

  var isRowLoaded = function isRowLoaded(_a) {
    var index = _a.index;
    return !!itemList[index];
  };

  var loadMoreRows = function loadMoreRows(_a) {
    var startIndex = _a.startIndex,
        stopIndex = _a.stopIndex;
    return getItems(startIndex, stopIndex);
  };

  var rowRenderer = function rowRenderer(_a) {
    var key = _a.key,
        index = _a.index,
        style = _a.style,
        isVisible = _a.isVisible;
    return rowRender({
      item: itemList[index],
      style: style,
      isVisible: isVisible,
      key: key
    });
  };

  return React.createElement(InfiniteLoader$1, {
    isRowLoaded: isRowLoaded,
    loadMoreRows: loadMoreRows,
    rowCount: totalItemCount,
    minimumBatchSize: 50,
    threshold: 10
  }, function (_a) {
    var onRowsRendered = _a.onRowsRendered,
        registerChild = _a.registerChild;
    return React.createElement(WindowScroller, null, function (_a) {
      var height = _a.height,
          scrollTop = _a.scrollTop;
      return React.createElement(AutoSizer, {
        disableHeight: true
      }, function (_a) {
        var width = _a.width;
        return React.createElement(List$1, {
          autoHeight: true,
          height: height,
          onRowsRendered: onRowsRendered,
          ref: registerChild,
          rowCount: itemList.length < totalItemCount ? itemList.length + 1 : itemList.length,
          rowHeight: 80,
          rowRenderer: rowRenderer,
          width: width,
          scrollTop: scrollTop,
          overscanRowCount: 10
        });
      });
    });
  });
}

var useStyle$9 = makeStyles({
  tableHeadCellFirst: {
    flex: 1,
    minWidth: 350
  },
  tableHeadText: {
    color: '#878787'
  },
  tableHeadTitle: {
    fontSize: 20,
    fontWeight: 600,
    textTransform: 'capitalize'
  }
});

var ListItemCounter = function ListItemCounter(_a) {
  var totalItemCount = _a.totalItemCount,
      title = _a.title,
      itemNameSingular = _a.itemNameSingular,
      itemNamePlural = _a.itemNamePlural;
  var classes = useStyle$9();
  return React.createElement(Col, {
    className: classes.tableHeadCellFirst
  }, React.createElement(Typography, {
    className: classes.tableHeadTitle
  }, title), React.createElement(Typography, {
    className: classes.tableHeadText
  }, totalItemCount, " ", totalItemCount === 1 ? itemNameSingular : itemNamePlural));
};

var useStyles$4 = makeStyles({
  popover: {
    width: 248,
    padding: 8,
    marginTop: 8
  },
  option: {
    padding: '10px 8px',
    marginBottom: 8,
    borderRadius: 6,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: dark5
    },
    '& > .MuiCheckbox-root': {
      padding: 0,
      paddingRight: 8
    },
    '&:hover .MuiCheckbox-root:not(.Mui-checked) svg rect': {
      fill: dark10,
      stroke: dark25
    }
  },
  default: {
    cursor: 'not-allowed',
    '&:hover': {
      backgroundColor: 'white'
    }
  }
});

var Checkbox = function Checkbox(props) {
  return React.createElement(Checkbox$1, _assign({}, props, {
    disableRipple: true,
    icon: React.createElement(CheckboxIcon, null),
    checkedIcon: React.createElement(CheckboxIcon, {
      checked: true
    })
  }));
};

var useStyle$a = makeStyles({
  popover: {
    marginTop: 24,
    marginLeft: 1,
    boxShadow: '0px 0px 1px rgba(41, 56, 51, 0.24), 10px 10px 40px -5px rgba(41, 56, 51, 0.12);',
    transform: 'none !important',
    animation: '$popoverIn .2s forwards',
    '&.closing': {
      animation: '$popoverOut .2s forwards'
    }
  },
  '@keyframes popoverIn': {
    from: {
      transform: 'translateY(-24px)'
    },
    to: {
      transform: 'translateY(0px)'
    }
  },
  '@keyframes popoverOut': {
    from: {
      transform: 'translateY(0px)'
    },
    to: {
      transform: 'translateY(-24px)'
    }
  }
});
var CustomPopover = forwardRef(function (props, ref) {
  var button = props.button,
      children = props.children,
      onPopoverOpen = props.onPopoverOpen,
      onPopoverClose = props.onPopoverClose,
      className = props.className;
  var classes = useStyle$a();

  var _a = useState(null),
      anchorEl = _a[0],
      setAnchorEl = _a[1];

  var open = Boolean(anchorEl);

  var handlePopoverClose = function handlePopoverClose(args) {
    setAnchorEl(null);
    if (onPopoverClose) onPopoverClose(args);
  };

  useImperativeHandle(ref, function () {
    return {
      closePopover: function closePopover() {
        handlePopoverClose();
      }
    };
  });

  var handlePopoverOpen = function handlePopoverOpen(event) {
    return setAnchorEl(event.currentTarget);
  };

  var openingButton = React.cloneElement(button, {
    onClick: function onClick(event) {
      handlePopoverOpen(event);
      if (onPopoverOpen) onPopoverOpen(event);
    }
  });
  return React.createElement(Fragment, null, openingButton, React.createElement(Popover, {
    classes: {
      paper: clsx(classes.popover, !open && 'closing', className)
    },
    open: open,
    anchorEl: anchorEl,
    onClose: handlePopoverClose,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, children));
});

var DownloadCsv = function DownloadCsv(_a) {
  var options = _a.options,
      handlePopoverOpen = _a.handlePopoverOpen,
      onDownloadCsv = _a.onDownloadCsv,
      locales = _a.locales;

  var _b = useState({}),
      selectedOptions = _b[0],
      setSelectedOptions = _b[1];

  var _c = useState(false),
      expanded = _c[0],
      setExpanded = _c[1];

  var classes = useStyles$4();
  var popover = useRef(null);

  var handleClose = function handleClose() {
    if (!popover || !popover.current) return;
    popover.current.closePopover();
  };

  var clickCheckbox = function clickCheckbox(key) {
    if (selectedOptions[key]) return setSelectedOptions(omit(selectedOptions, key));
    setSelectedOptions(function (prevState) {
      var _a;

      return _assign(_assign({}, prevState), (_a = {}, _a[key] = options[key], _a));
    });
  };

  var downloadCsv = function downloadCsv() {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        handleClose();
        onDownloadCsv(selectedOptions);
        return [2
        /*return*/
        ];
      });
    });
  };

  var listOfOptions = React.createElement(Fragment, null, Object.keys(options).map(function (option, index) {
    if (!expanded && index >= 3) return React.createElement(Fragment, {
      key: option
    });
    return React.createElement(Row, {
      key: option,
      justify: 'flex-start',
      className: classes.option,
      onClick: function onClick() {
        return clickCheckbox(option);
      }
    }, React.createElement(Checkbox, {
      checked: selectedOptions[option] !== undefined
    }), React.createElement(Typography, null, options[option]));
  }));
  return React.createElement(CustomPopover, {
    ref: popover,
    button: React.createElement(SecondaryButton, {
      type: 'button',
      text: locales.export
    }),
    className: classes.popover,
    onPopoverOpen: handlePopoverOpen
  }, React.createElement(Row, {
    justify: 'flex-start',
    className: clsx(classes.option, classes.default)
  }, React.createElement(Checkbox, {
    checked: true,
    disabled: true
  }), React.createElement(Typography, null, locales.defaultOptions)), listOfOptions, !expanded ? React.createElement(InvisibleButton, {
    buttonStyle: {
      defaultCSS: {
        width: '100%',
        textAlign: 'center',
        marginBottom: 8
      }
    },
    onClick: function onClick() {
      return setExpanded(!expanded);
    },
    text: locales.viewMore
  }) : React.createElement(React.Fragment, null), React.createElement(PrimaryButton, {
    style: {
      width: '100%'
    },
    type: 'button',
    onClick: downloadCsv,
    text: locales.download
  }));
};

var CopyrightAgentLoader = function CopyrightAgentLoader(props) {
  return React.createElement(SvgIcon, _assign({
    width: "50",
    height: "50",
    viewBox: "0 0 144 144",
    fill: "none"
  }, props), React.createElement("path", {
    d: "M72 87.34C62.54 87.34 55.09 78.79 56.95 68.99C58.09 62.98 62.92 58.13 68.92 56.96C72.46 56.27 75.85 56.8 78.72 58.21C81.6 59.62 85.07 58.93 87.33 56.67C91.04 52.96 90.05 46.65 85.32 44.37C80.76 42.17 75.57 41.06 70.09 41.39C54.69 42.32 42.12 55.03 41.35 70.44C40.48 88.08 54.54 102.68 72 102.68C77.02 102.68 81.75 101.48 85.93 99.34C90.33 97.1 91.12 91.11 87.63 87.62L87.15 87.14C84.89 84.88 81.47 84.48 78.59 85.86C76.59 86.81 74.36 87.34 72 87.34Z",
    fill: "#293241"
  }, React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    dur: "1s",
    keySplines: "\n\t\t\t\t\t\t0.21 0.61 0.8 0.3;\n\t\t\t\t\t\t0.21 0.61 0.8 0.3;\n\t\t\t\t\t\t0.21 0.61 0.8 0.3;\n\t\t\t\t\t\t0.21 0.61 0.8 0.3;\n\t\t\t\t\t\t0.21 0.61 0.8 0.3;\n\t\t\t\t\t\t0.21 0.61 0.8 0.3",
    keyTimes: "0;0.22;0.33;0.55;0.66;0.88;1",
    calcMode: "spline",
    from: "0 72 72",
    to: "-360 72 72",
    repeatCount: "indefinite"
  })), React.createElement("path", {
    d: "M72 126C40.98 126 16.06 99.83 18.12 68.36C19.92 40.86 42.84 18.83 70.39 18.02C83.09 17.65 94.82 21.66 104.21 28.65C107.85 31.36 112.88 31.12 116.09 27.91C119.95 24.05 119.54 17.63 115.16 14.35C101.97 4.48 85.28 -1 67.29 0.15C31.63 2.42 2.64004 31.24 0.180043 66.89C-2.72996 108.96 30.55 144 72 144C88.23 144 103.22 138.62 115.26 129.56C119.56 126.33 120.05 120.05 116.24 116.25L115.96 115.97C112.81 112.82 107.86 112.6 104.3 115.27C95.29 122.01 84.12 126 72 126Z",
    fill: "#48D2A0"
  }, React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    dur: "1s",
    keySplines: "\n\t\t\t\t\t\t0.21 0.61 0.8 0.3;\n\t\t\t\t\t\t0.21 0.61 0.8 0.3;\n\t\t\t\t\t\t0.21 0.61 0.8 0.3;\n\t\t\t\t\t\t0.21 0.61 0.8 0.3;\n\t\t\t\t\t\t0.21 0.61 0.8 0.3;\n\t\t\t\t\t\t0.21 0.61 0.8 0.3",
    keyTimes: "0;0.22;0.33;0.55;0.66;0.88;1",
    calcMode: "spline",
    from: "0 72 72",
    to: "360 72 72",
    repeatCount: "indefinite"
  })));
};

CopyrightAgentLoader.defaultProps = {
  className: '',
  style: {
    width: 50,
    height: 50
  }
};
var useStyle$b = makeStyles({
  infiniteScrollWrap: {
    overflow: 'visible !important',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    flexBasis: '100%',
    flex: 1
  },
  noItems: {
    minHeight: 'calc(100vh - 280px)'
  },
  absoluteCenter: {
    position: 'absolute',
    top: 'calc(50% - 20px)',
    left: 'calc(50% - 20px)'
  }
});

function ListRender(prop) {
  var _this = this;

  var rowRender = prop.rowRender,
      noItemsRender = prop.noItemsRender,
      onUpdateTotalCount = prop.onUpdateTotalCount,
      parentGetItems = prop.getItems,
      updateFilters = prop.updateFilters,
      onItemsLoad = prop.onItemsLoad,
      triggerRefetch = prop.triggerRefetch,
      locationSearch = prop.locationSearch;
  var classes = useStyle$b();
  var mediaQueryMatchesLargeHeight = useMediaQuery('(min-height:2000px)');
  var perPage = mediaQueryMatchesLargeHeight ? 50 : 25;

  var _a = useState([]),
      itemList = _a[0],
      setItemList = _a[1];

  var _b = useState(0),
      totalItemCount = _b[0],
      setTotalItemCount = _b[1];

  var _c = useState(false),
      loaded = _c[0],
      setLoaded = _c[1];

  var updateTotalCount = useCallback(function (count) {
    var total = typeof count === 'string' ? parseInt(count, 10) : count;
    onUpdateTotalCount(total);
    setTotalItemCount(total);
  }, [onUpdateTotalCount]);
  var getItems = useCallback(function (startIndex, stopIndex) {
    if (stopIndex === void 0) {
      stopIndex = perPage;
    }

    return __awaiter(_this, void 0, void 0, function () {
      var _a, isSuccessful, items, count, filters;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            if (startIndex === 0) setLoaded(false);
            return [4
            /*yield*/
            , parentGetItems(startIndex, stopIndex)];

          case 1:
            _a = _b.sent(), isSuccessful = _a.isSuccessful, items = _a.items, count = _a.count, filters = _a.filters;
            if (!isSuccessful) return [2
            /*return*/
            ];
            updateFilters(filters);
            updateTotalCount(count);

            if (items) {
              setItemList(function (prev) {
                return startIndex === 0 ? items : __spreadArrays(prev, items);
              });
              onItemsLoad(items);
            }

            setLoaded(true);
            return [2
            /*return*/
            ];
        }
      });
    });
  }, [locationSearch, parentGetItems, updateFilters, updateTotalCount, onItemsLoad]);
  useEffect(function () {
    getItems(0);
  }, [locationSearch, triggerRefetch, getItems]);
  var displayItemLoader = React.createElement(InfiniteLoader, {
    totalItemCount: totalItemCount,
    itemList: itemList,
    getItems: getItems,
    rowRender: rowRender
  });

  var displayItems = function displayItems() {
    if (!itemList.length) {
      return React.createElement("div", {
        className: clsx(classes.infiniteScrollWrap, classes.noItems)
      }, noItemsRender());
    }

    return displayItemLoader;
  };

  var displayItemList = function displayItemList() {
    if (!loaded) return React.createElement(CopyrightAgentLoader, {
      className: classes.absoluteCenter
    });
    return displayItems();
  };

  return displayItemList();
}

var useStyle$c = function useStyle$c(width, maxHeight) {
  return makeStyles({
    container: {
      width: width
    },
    formControl: {
      width: '100%',
      borderRadius: 6,
      '& .MuiInputBase-root': {
        backgroundColor: 'unset',
        '&:hover': {
          border: 'unset'
        },
        '& .MuiSelect-root': {
          padding: '10px 48px 10px 17px',
          textTransform: 'capitalize',
          '&:focus': {
            backgroundColor: 'unset'
          }
        },
        '& .MuiSvgIcon-root': {
          position: 'absolute',
          right: 16,
          pointerEvents: 'none'
        },
        '& .MuiOutlinedInput-notchedOutline': {
          backgroundColor: dark5,
          border: "1px solid " + dark10,
          borderRadius: 6
        },
        '&:not(.Mui-disabled):hover .MuiOutlinedInput-notchedOutline': {
          backgroundColor: dark10,
          borderColor: dark25
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: green,
          boxShadow: '0px 0px 0px 2px rgba(72, 210, 160, 0.25);'
        }
      }
    },
    paper: {
      marginTop: 49,
      border: "1px solid " + dark10,
      borderRadius: 6,
      boxShadow: '0px 0px 1px rgba(41, 56, 51, 0.24), 10px 10px 40px -5px rgba(41, 56, 51, 0.12);',
      transform: 'none !important',
      '& .MuiList-root': {
        padding: 0,
        minWidth: width - 2,
        maxHeight: maxHeight,
        overflow: 'overlay',
        '& .MuiListItem-root': {
          margin: 8,
          borderRadius: 6,
          paddingTop: 10,
          paddingBottom: 10,
          paddingLeft: 8,
          fontSize: 14,
          fontWeight: 600,
          color: dark75,
          textTransform: 'capitalize',
          '&:hover': {
            backgroundColor: dark5
          },
          '&.Mui-selected': {
            backgroundColor: dark10
          }
        }
      }
    },
    hideItem: {
      display: 'none'
    },
    '@keyframes optionsIn': {
      from: {
        transform: 'translateY(-24px)'
      },
      to: {
        transform: 'translateY(0px)'
      }
    },
    '@keyframes optionsOut': {
      from: {
        transform: 'translateY(0px)'
      },
      to: {
        transform: 'translateY(-24px)'
      }
    }
  });
};

var DropdownSelect = function DropdownSelect(props) {
  var placeholder = props.placeholder,
      value = props.value,
      options = props.options,
      onSelect = props.onSelect,
      disable = props.disable,
      _a = props.width,
      width = _a === void 0 ? 300 : _a,
      _b = props.dropDownMaxHeight,
      dropDownMaxHeight = _b === void 0 ? 255 : _b,
      _c = props.multiple,
      multiple = _c === void 0 ? false : _c,
      otherProps = __rest(props, ["placeholder", "value", "options", "onSelect", "disable", "width", "dropDownMaxHeight", "multiple"]);

  var classes = useStyle$c(width, dropDownMaxHeight)();

  var _d = useState(value || (multiple ? [''] : '')),
      selected = _d[0],
      setSelected = _d[1];

  var _e = useState(false),
      isOpen = _e[0],
      setIsOpen = _e[1];

  var handleSelectForArray = function handleSelectForArray(selection) {
    // If array is empty, we need to return an empty string in the array,
    // to show the placeholder text
    if (selection.length === 0) return ['']; // We need to see if the empty string is in the array.

    var index = selection.indexOf(''); // If the empty string is not in the array, we can just return the array.

    if (index === -1) return selection; // If array is not empty, but have the empty string already,
    // we need to remove it, to make sure we no longere show the placeholder text

    selection.splice(index, 1);
    return selection;
  };

  var handleSelect = function handleSelect(event) {
    if (!Array.isArray(event.target.value) && typeof event.target.value !== 'string') throw new Error('Value needs to be a string or a array of strings.');
    var selection = event.target.value;
    if (multiple && Array.isArray(selection)) selection = handleSelectForArray(selection);
    setSelected(selection);
    onSelect(selection);
  };

  return React.createElement("div", {
    className: classes.container
  }, React.createElement(FormControl, {
    variant: 'outlined',
    disabled: disable,
    className: classes.formControl
  }, React.createElement(Select, _assign({}, otherProps, {
    value: selected,
    onChange: handleSelect,
    displayEmpty: true,
    placeholder: placeholder,
    multiple: multiple,
    IconComponent: function IconComponent() {
      return React.createElement(ChevronIcon, {
        direction: isOpen ? 'up' : 'down',
        color: dark75
      });
    },
    MenuProps: {
      getContentAnchorEl: null,
      classes: {
        paper: classes.paper
      }
    },
    onOpen: function onOpen() {
      return setIsOpen(true);
    },
    onClose: function onClose() {
      return setIsOpen(false);
    }
  }), React.createElement(MenuItem, {
    value: '',
    disabled: true,
    classes: {
      root: classes.hideItem
    }
  }, placeholder), options.map(function (item, key) {
    return React.createElement(MenuItem, {
      key: key,
      value: item.value
    }, item.label);
  }))));
};

var useStyle$d = makeStyles$1({
  filterPopupRow: {
    width: '100%',
    flexDirection: 'column',
    marginBottom: 12
  },
  filterPopupLabel: {
    marginBottom: 4,
    color: dark75
  }
}, {
  index: 1
});

var SelectTemplate = function SelectTemplate(selectProps) {
  var label = selectProps.label,
      _a = selectProps.options,
      options = _a === void 0 ? [] : _a,
      _b = selectProps.value,
      value = _b === void 0 ? [] : _b,
      _c = selectProps.disable,
      disable = _c === void 0 ? false : _c,
      _d = selectProps.onSelect,
      onSelect = _d === void 0 ? function () {
    return null;
  } : _d,
      _e = selectProps.placeholder,
      placeholder = _e === void 0 ? '' : _e;
  var classes = useStyle$d();
  return React.createElement(Row, {
    className: classes.filterPopupRow,
    align: 'flex-start'
  }, React.createElement(Typography, {
    className: classes.filterPopupLabel
  }, label), React.createElement(DropdownSelect, {
    multiple: Array.isArray(value),
    options: options,
    value: Array.isArray(value) && value.length === 0 ? null : value,
    disable: disable,
    onSelect: onSelect,
    placeholder: placeholder,
    width: 248
  }));
};

function DisplayFilterSelect(props) {
  var _a = props.shouldRender,
      shouldRender = _a === void 0 ? true : _a,
      filterKey = props.filterKey,
      filterOptions = props.filterOptions,
      selectedValue = props.selectedValue,
      handleSelectChange = props.handleSelectChange,
      locales = props.locales;
  if (!shouldRender) return React.createElement(React.Fragment, null);

  if (filterOptions.length === 0) {
    return React.createElement(SelectTemplate, {
      label: locales.label,
      disable: true,
      placeholder: locales.noOptionsAvailable
    });
  }

  if (filterOptions.length === 1) {
    return React.createElement(SelectTemplate, {
      label: locales.label,
      disable: true,
      options: filterOptions,
      value: filterOptions[0].value
    });
  }

  return React.createElement(SelectTemplate, {
    label: locales.label,
    options: filterOptions,
    value: selectedValue,
    placeholder: locales.placeholder,
    onSelect: function onSelect(value) {
      return handleSelectChange(value, filterKey);
    }
  });
}

function DisplayFilterSelects(props) {
  var filterDetails = props.filterDetails,
      setCurrentFilters = props.setCurrentFilters;
  var handleSelectChange = useCallback(function (value, key) {
    setCurrentFilters(function (prev) {
      var _a;

      return _assign(_assign({}, prev), (_a = {}, _a[key] = Array.isArray(value) ? value : [value], _a));
    });
  }, []);
  return React.createElement(React.Fragment, null, filterDetails.map(function (filterDetail, index) {
    return React.createElement(DisplayFilterSelect, _assign({
      key: index,
      handleSelectChange: handleSelectChange
    }, filterDetail));
  }));
}

var useStyle$e = makeStyles$1({
  filterButton: {
    width: 40,
    height: 40
  },
  filterPopupCol: {
    width: 296,
    padding: 24,
    borderRadius: 6,
    border: "1px solid " + dark10,
    boxShadow: '0px 0px 1px rgba(41, 50, 65, 0.25)'
  },
  filterPopupButtons: {
    marginTop: 12,
    paddingTop: 24,
    borderTop: "1px solid " + dark10
  },
  filterPopupButton: {
    width: 118,
    '&:last-child': {
      marginLeft: 12
    }
  },
  '@keyframes filterPopoverIn': {
    from: {
      transform: 'translateY(-24px)'
    },
    to: {
      transform: 'translateY(0px)'
    }
  },
  '@keyframes filterPopoverOut': {
    from: {
      transform: 'translateY(0px)'
    },
    to: {
      transform: 'translateY(-24px)'
    }
  }
}, {
  index: 1
});

function FilterPopoverInner(props, ref) {
  var setCurrentFilters = props.setCurrentFilters,
      filterDetails = props.filterDetails,
      locales = props.locales,
      resetFiltersAndSearch = props.resetFiltersAndSearch,
      applyFiltering = props.applyFiltering;
  var classes = useStyle$e();
  var displayFilterSelects = useMemo(function () {
    return React.createElement(DisplayFilterSelects, {
      filterDetails: filterDetails,
      setCurrentFilters: setCurrentFilters
    });
  }, [filterDetails]);
  return React.createElement(CustomPopover, {
    ref: ref,
    button: React.createElement(InvisibleButton, {
      className: classes.filterButton
    }, React.createElement(FilterIcon, {
      color: dark75
    }))
  }, React.createElement(Col, {
    className: classes.filterPopupCol,
    justify: 'flex-start'
  }, displayFilterSelects, React.createElement(Row, {
    className: classes.filterPopupButtons
  }, React.createElement(SecondaryButton, {
    type: 'submit',
    onClick: resetFiltersAndSearch,
    text: locales.reset,
    className: classes.filterPopupButton
  }), React.createElement(PrimaryButton, {
    type: 'submit',
    onClick: applyFiltering,
    text: locales.apply,
    className: classes.filterPopupButton
  }))));
} // See:
// https://fettblog.eu/typescript-react-generic-forward-refs/


var FilterPopover = React.forwardRef(FilterPopoverInner);
var useStyles$5 = makeStyles({
  inputWrapper: {
    width: '100%'
  },
  root: {
    height: 40,
    fontSize: 14,
    borderRadius: 6,
    color: dark75,
    backgroundColor: dark5,
    border: "1px solid " + dark10
  },
  inputFocused: {
    backgroundColor: dark5 + " !important",
    borderColor: "" + green,
    boxShadow: "0px 0px 0px 2px " + green25
  },
  inputProp: {
    borderRadius: 5
  },
  disabled: {
    color: dark25 + " !important",
    backgroundColor: dark5 + " !important"
  },
  input: {
    lineHeight: '16px',
    '& input': {
      color: '#65706C',
      fontWeight: 600,
      paddingTop: 6,
      paddingLeft: 20,
      paddingBottom: 7,
      paddingRight: 20,
      transition: 'background-color 0.1s',
      '& .MuiInputBase-input.Mui-disabled': {
        backgroundColor: dark5
      }
    },
    '& :hover .MuiInputBase-input, .MuiFilledInput-root:hover': {
      color: dark75,
      transition: 'background-color 0.3s'
    },
    '& .MuiFilledInput-root.Mui-disabled': {
      backgroundColor: dark5
    }
  },
  label: {
    paddingBottom: 10
  },
  inputError: {
    borderColor: red,
    boxShadow: "0px 0px 0px 2px " + red25
  }
});

var Input = function Input(props) {
  var type = props.type,
      value = props.value,
      label = props.label,
      className = props.className,
      labelClassName = props.labelClassName,
      other = __rest(props, ["type", "value", "label", "className", "labelClassName"]);

  var classes = useStyles$5();

  var inputProps = _assign(_assign({
    required: true
  }, other.InputProps), {
    disableUnderline: true,
    classes: {
      root: classes.root,
      focused: classes.inputFocused,
      disabled: classes.disabled,
      input: classes.inputProp,
      error: classes.inputError
    },
    type: type
  });

  var helperTextProps = {
    className: classes.inputError
  };
  return React.createElement(Col, {
    className: classes.inputWrapper
  }, label && React.createElement(Typography$1, {
    className: clsx(classes.label, labelClassName),
    variant: "body2"
  }, label), React.createElement(TextField, _assign({
    fullWidth: true,
    value: value,
    className: clsx(classes.input, className),
    InputProps: inputProps,
    FormHelperTextProps: helperTextProps
  }, other, {
    variant: 'filled'
  })));
};

var useClasses = makeStyles$1(function () {
  return {
    filterLabel: {
      height: 24,
      backgroundColor: dark10,
      color: dark75,
      borderRadius: 6,
      display: 'flex',
      alignItems: 'center',
      padding: '2px 8px',
      fontWeight: 600,
      marginRight: 4
    },
    filterLabelText: {
      textTransform: 'capitalize'
    },
    filterLabelRemoveButton: {
      width: 15,
      height: 15,
      marginLeft: 6,
      cursor: 'pointer'
    }
  };
}, {
  index: 1
});

function FilterAdornment(props) {
  var label = props.label,
      onRemove = props.onRemove;
  var classes = useClasses();
  return React.createElement("div", {
    className: classes.filterLabel
  }, React.createElement("div", {
    className: classes.filterLabelText
  }, label), React.createElement(CloseIcon, {
    color: dark75,
    className: classes.filterLabelRemoveButton,
    onClick: onRemove
  }));
}

var useStyle$f = makeStyles$1({
  form: {
    width: '100%'
  },
  icon: {
    marginRight: 8
  },
  submitButton: {
    margin: '0 8px 0 12px',
    width: 150
  },
  input: {
    height: 40,
    backgroundColor: dark4,
    border: "1px solid " + dark12,
    borderRadius: 6,
    paddingLeft: 8,
    fontSize: 14,
    fontFamily: 'Open Sans',
    '&::before': {
      border: 'unset'
    },
    '&::after': {
      border: 'unset'
    },
    '&:hover': {
      backgroundColor: dark12,
      borderColor: dark24,
      '&::before': {
        border: 'unset'
      }
    },
    '&:focus': {
      backgroundColor: dark4,
      borderColor: green,
      '&::before': {
        border: 'unset'
      }
    }
  }
}, {
  index: 1
});
var qsArrayFormat = {
  skipEmptyString: true,
  skipNull: true,
  arrayFormat: 'comma'
};

var transformValue = function transformValue(value) {
  if (value === null) return '';
  if (Array.isArray(value)) return value.map(function (v) {
    return v || '';
  });
  return value;
};

function parseQueryParams(initialFilters, search) {
  var parsedQueryParams = qs.parse(search, {
    arrayFormat: 'comma'
  });
  var parsedFilters = Object.entries(initialFilters).reduce(function (acc, _a) {
    var key = _a[0];
    var value = parsedQueryParams[key];
    var transformedValue = transformValue(value);
    var valueIsArray = Array.isArray(transformedValue);
    var arrayValue = valueIsArray ? transformedValue : [transformedValue];
    var singleValue = valueIsArray ? transformedValue[0] : transformedValue;

    if (parsedQueryParams[key]) {
      if (Array.isArray(initialFilters[key])) {
        // @ts-ignore
        acc[key] = arrayValue;
      } else {
        // @ts-ignore
        acc[key] = singleValue;
      }
    }

    return acc;
  }, initialFilters);
  return parsedFilters;
}

function FilterSearch(props) {
  var _a = props.disabled,
      disabled = _a === void 0 ? false : _a,
      applyFiltering = props.applyFiltering,
      onSearchSubmit = props.onSearchSubmit,
      filterSearchKey = props.filterSearchKey,
      locales = props.locales,
      getFilterByURLSearchPart = props.getFilterByURLSearchPart,
      setLabelByKey = props.setLabelByKey,
      location = props.location,
      history = props.history;
  var classes = useStyle$f();
  var initialFilters = useMemo(function () {
    return getFilterByURLSearchPart(location.search);
  }, [location.search]);
  var initialSearchRaw = initialFilters[filterSearchKey];
  var initialSearch = typeof initialSearchRaw === 'string' ? initialSearchRaw : '';

  var _b = useState(initialFilters),
      currentFilters = _b[0],
      setCurrentFilters = _b[1];

  var _c = useState(initialSearch),
      searchTerm = _c[0],
      setSearchTerm = _c[1]; // update the current filters when the url params change


  useEffect(function () {
    var parsedFilters = getFilterByURLSearchPart(location.search);
    setCurrentFilters(parsedFilters);
  }, [location.search]); // update url params when the current filters change

  useEffect(function () {
    var qString = qs.stringify(currentFilters, qsArrayFormat);
    history.replace(location.pathname + "?" + qString);
    if (!currentFilters.searchTerm) setSearchTerm('');
  }, [currentFilters]);
  var flattenedAdornments = useMemo(function () {
    return Object.entries(currentFilters).filter(function (_a) {
      var value = _a[1];
      return Array.isArray(value) && value.length > 0;
    }).map(function (_a) {
      var key = _a[0],
          subArr = _a[1];
      return subArr.map(function (value) {
        var finalObj = {
          key: key,
          value: value,
          label: value
        };
        if (setLabelByKey) setLabelByKey(key, finalObj);
        return finalObj;
      });
    }).flat();
  }, [currentFilters]);
  var handleSubmit = useCallback(function (e) {
    e.preventDefault();
    onSearchSubmit(searchTerm);
    setCurrentFilters(function (prev) {
      return _assign(_assign({}, prev), {
        searchTerm: searchTerm
      });
    });
    applyFiltering();
  }, [searchTerm, applyFiltering, onSearchSubmit]);
  var removeFilterByAdornment = useCallback(function (adornment) {
    var newFilters = cloneDeep(currentFilters);
    var appliedFilter = newFilters[adornment.key];
    if (Array.isArray(appliedFilter)) appliedFilter.splice(appliedFilter.indexOf(adornment.value), 1);
    setCurrentFilters(function (prev) {
      var _a;

      return _assign(_assign({}, prev), (_a = {}, _a[adornment.key] = appliedFilter, _a));
    });
  }, [currentFilters]);
  var displaySearchField = useMemo(function () {
    return React.createElement(InputAdornment, {
      position: "start",
      style: {
        marginTop: 0,
        marginRight: 0
      }
    }, React.createElement(SearchIcon, {
      className: classes.icon,
      color: disabled ? dark25 : dark75
    }), flattenedAdornments.map(function (adornment, index) {
      return React.createElement(FilterAdornment, {
        label: adornment.label,
        key: index,
        onRemove: function onRemove() {
          return removeFilterByAdornment(adornment);
        }
      });
    }));
  }, [flattenedAdornments, removeFilterByAdornment, disabled]);
  var onChange = useCallback(function (e) {
    e.persist();
    setSearchTerm(e.target.value);
  }, [setSearchTerm]);
  var inputProps = useMemo(function () {
    return {
      startAdornment: displaySearchField,
      className: classes.input,
      required: false
    };
  }, [displaySearchField]);
  return React.createElement("form", {
    className: classes.form,
    onSubmit: handleSubmit
  }, React.createElement(Row, {
    align: 'stretch'
  }, React.createElement(Input, {
    InputProps: inputProps,
    disabled: disabled,
    value: searchTerm,
    onChange: onChange,
    type: 'text',
    placeholder: locales.placeholder
  }), React.createElement(PrimaryButton, {
    type: 'submit',
    text: locales.submitText,
    className: classes.submitButton
  })));
}

var useStyle$g = makeStyles$1({
  rootRow: {
    backgroundColor: '#fff',
    padding: 12,
    boxShadow: '0px 0px 1px rgba(41, 50, 65, 0.25)',
    borderRadius: 6
  },
  '@keyframes filterPopoverIn': {
    from: {
      transform: 'translateY(-24px)'
    },
    to: {
      transform: 'translateY(0px)'
    }
  },
  '@keyframes filterPopoverOut': {
    from: {
      transform: 'translateY(0px)'
    },
    to: {
      transform: 'translateY(-24px)'
    }
  }
}, {
  index: 1
});

function SearchBar(props) {
  var getDefaultFilters = props.getDefaultFilters,
      onSearchSubmit = props.onSearchSubmit,
      setLabelByKey = props.setLabelByKey,
      getFilterDetails = props.getFilterDetails,
      locales = props.locales,
      location = props.location,
      history = props.history;
  var classes = useStyle$g();

  var _a = useState(function () {
    return parseQueryParams(getDefaultFilters(), location.search);
  }),
      currentFilters = _a[0],
      setCurrentFilters = _a[1];

  var popoverRef = useRef(null);
  var filterDetails = getFilterDetails(currentFilters);
  var getFilterByURLSearchPart = useCallback(function (URLSearchPart) {
    return parseQueryParams(getDefaultFilters(), URLSearchPart);
  }, []); // Update the current filters when the url params change

  useEffect(function () {
    var parsedFilters = getFilterByURLSearchPart(location.search);
    setCurrentFilters(parsedFilters);
  }, [getFilterByURLSearchPart, location.search]);
  var onApplyFilters = useCallback(function () {
    var qString = qs.stringify(currentFilters, qsArrayFormat);
    history.replace(location.pathname + "?" + qString);
  }, [currentFilters, history, location.pathname]);
  var onResetFilters = useCallback(function () {
    setCurrentFilters(getDefaultFilters());
    history.replace(location.pathname);
  }, [history, location.pathname]);
  var handleClose = useCallback(function () {
    if (!popoverRef || !popoverRef.current) return;
    popoverRef.current.closePopover();
  }, [popoverRef]);
  var applyFiltering = useCallback(function () {
    handleClose();
    onApplyFilters();
  }, [onApplyFilters, handleClose]);
  var resetFiltersAndSearch = useCallback(function () {
    handleClose();
    onResetFilters();
  }, [handleClose, onResetFilters]);
  var filterSearch = useMemo(function () {
    return React.createElement(FilterSearch, {
      filterSearchKey: "searchTerm",
      applyFiltering: applyFiltering,
      onSearchSubmit: onSearchSubmit,
      locales: locales.filterSearchLocales,
      getFilterByURLSearchPart: getFilterByURLSearchPart,
      setLabelByKey: setLabelByKey,
      location: location,
      history: history
    });
  }, [applyFiltering, onSearchSubmit, locales, getFilterByURLSearchPart, setLabelByKey, location, history]);
  var displayFilterPopover = useMemo(function () {
    return React.createElement(FilterPopover, {
      setCurrentFilters: setCurrentFilters,
      filterDetails: filterDetails,
      resetFiltersAndSearch: resetFiltersAndSearch,
      applyFiltering: applyFiltering,
      ref: popoverRef,
      locales: locales.filterPopoverLocales
    });
  }, [filterDetails, resetFiltersAndSearch, applyFiltering, popoverRef, locales]);
  return React.createElement(Row, {
    className: classes.rootRow,
    align: 'stretch'
  }, filterSearch, displayFilterPopover);
}

var ModalSection = function ModalSection(props) {
  return React.createElement("div", {
    className: 'ModalSection'
  }, props.children);
};

var useStyle$h = makeStyles$1({
  main: {
    padding: function padding(_a) {
      var size = _a.size;
      return size === 'extraLarge' ? 23 : 32;
    },
    backgroundColor: 'white',
    borderRadius: function borderRadius(_a) {
      var size = _a.size;
      return size === 'extraLarge' ? 6 : 12;
    },
    boxShadow: '10px 10px 40px -5px rgb(41 50 65 / 24%), 0px 0px 1px rgb(41 50 65 / 12%)',
    '& div.ModalSection:not(:last-child)': {
      marginBottom: 24
    },
    width: function width(_a) {
      var size = _a.size;

      switch (size) {
        case 'large':
          return 624;

        case 'extraLarge':
          return 1248;

        case 'small':
        default:
          return 448;
      }
    }
  },
  title: {
    padding: 0
  },
  titleText: {
    marginTop: 12
  }
});

var Modal = function Modal(props) {
  var open = props.open,
      _a = props.size,
      size = _a === void 0 ? 'small' : _a,
      title = props.title,
      titleText = props.titleText,
      children = props.children,
      onClose = props.onClose,
      className = props.className,
      dialogProps = __rest(props, ["open", "size", "title", "titleText", "children", "onClose", "className"]);

  var classes = useStyle$h({
    size: size
  });
  return React.createElement(Dialog, _assign({
    open: open,
    onClose: onClose,
    PaperProps: {
      className: clsx(classes.main, className)
    },
    maxWidth: false
  }, dialogProps), (title || titleText) && React.createElement(ModalSection, null, React.createElement(Typography, {
    className: classes.title,
    variant: 'h5',
    fontWeight: 600,
    fontColor: dark
  }, title), React.createElement(Typography, {
    className: classes.titleText,
    fontWeight: 400,
    fontColor: dark75
  }, titleText)), children);
};

var useStyles$6 = makeStyles({
  root: {
    fontSize: 14,
    borderRadius: 6,
    border: "1px solid " + dark10,
    height: 100
  },
  inputFocused: {
    borderColor: "" + green,
    boxShadow: "0px 0px 0px 2px " + green25
  },
  inputProp: {
    fontWeight: 600
  },
  input: {
    lineHeight: '16px',
    fontWeight: 600
  },
  labelForm: {
    transform: 'translate(16px, 10px) scale(1)'
  },
  labelFilled: {
    fontSize: 14,
    fontWeight: 600,
    color: dark50
  },
  labelFocused: {
    display: 'none'
  },
  labelError: {
    display: 'none'
  },
  inputError: {
    color: red,
    borderColor: red,
    boxShadow: "0px 0px 0px 2px " + red25
  },
  multiline: {
    padding: '10px 16px 10px 16px',
    backgroundColor: dark5,
    display: 'block'
  }
});

var TextArea = function TextArea(props) {
  var value = props.value,
      label = props.label,
      className = props.className,
      other = __rest(props, ["value", "label", "className"]);

  var classes = useStyles$6();
  var inputProps = {
    disableUnderline: true,
    required: true,
    classes: {
      root: classes.root,
      focused: classes.inputFocused,
      input: classes.inputProp,
      error: classes.inputError,
      multiline: classes.multiline
    }
  };
  var inputLabelProps = {
    classes: {
      formControl: classes.labelForm,
      focused: classes.labelFocused,
      filled: classes.labelFilled,
      error: classes.labelError,
      shrink: classes.labelFocused
    }
  };
  var helperTextProps = {
    className: classes.inputError
  };
  return React.createElement(TextField, _assign({
    fullWidth: true,
    label: label,
    value: value,
    className: classes.input + " " + className,
    InputProps: inputProps,
    InputLabelProps: inputLabelProps,
    FormHelperTextProps: helperTextProps
  }, other, {
    variant: 'filled',
    type: 'text',
    multiline: true
  }));
};

var useStyle$i = makeStyles$1({
  arrow: {
    color: 'white',
    fontSize: 20,
    '&::before': {
      boxShadow: '0px 0px 40px -5px rgb(41 56 51 / 12%)'
    }
  },
  tooltip: {
    backgroundColor: 'white',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: function maxWidth(_a) {
      var maxWidth = _a.maxWidth;
      return maxWidth + "px";
    },
    boxShadow: '0px 0px 40px -5px rgb(41 56 51 / 12%)',
    padding: '16px',
    borderRadius: '6px'
  }
});

var Tooltip = function Tooltip(_a) {
  var _b = _a.maxWidth,
      maxWidth = _b === void 0 ? 300 : _b,
      props = __rest(_a, ["maxWidth"]);

  var classes = useStyle$i({
    maxWidth: maxWidth
  });
  return React.createElement(Tooltip$1, _assign({
    arrow: true,
    classes: classes
  }, props));
};

var InfoIconWithTooltip = function InfoIconWithTooltip(props) {
  var content = props.content,
      color = props.iconColor,
      styleIcon = props.styleIcon,
      placement = props.placement,
      maxWidth = props.maxWidth;
  var id = useState(Math.random().toString())[0];
  var getContent = useMemo(function () {
    if (typeof content === 'string') return React.createElement(Typography, {
      fontWeight: 'normal'
    }, content);
    return content;
  }, [content]);
  return React.createElement(Fragment, null, React.createElement(Tooltip, {
    title: React.createElement(React.Fragment, null, getContent),
    placement: placement,
    maxWidth: maxWidth
  }, React.createElement(InfoOutlined, {
    id: id + "-anchor",
    style: _assign({
      color: color,
      cursor: 'help'
    }, styleIcon),
    fontSize: 'small'
  })));
};

InfoIconWithTooltip.defaultProps = {
  iconColor: dark50,
  content: null,
  styleIcon: {},
  placement: 'bottom-end',
  maxWidth: 300
};
var useStyle$j = makeStyles(function () {
  return {
    selfEnd: {
      alignSelf: 'flex-end'
    },
    fullWith: {
      width: '100%'
    },
    logo: {
      maxWidth: 250,
      maxHeight: 100,
      marginTop: 55,
      marginRight: 50
    },
    rightImageWrapper: {
      height: 'calc(100% - 200px)'
    },
    rightCol: {
      flex: 1.74,
      backgroundColor: dark5
    },
    rightImage: {
      width: '70%'
    }
  };
});

var RightPlaceholder = function RightPlaceholder(props) {
  var isMobile = props.isMobile,
      src = props.src,
      logoSrc = props.logoSrc;
  var classes = useStyle$j();
  if (isMobile) return null;
  return React.createElement(Col, {
    justify: 'flex-start',
    className: classes.rightCol
  }, React.createElement(Row, {
    justify: 'flex-end',
    className: classes.fullWith
  }, React.createElement(Logo$1, {
    src: logoSrc,
    className: classes.logo + " " + classes.selfEnd
  })), React.createElement(Row, {
    className: classes.rightImageWrapper
  }, React.createElement("img", {
    src: src,
    alt: 'login',
    className: classes.rightImage
  })));
};

var useStyles$7 = makeStyles(function (theme) {
  return {
    success: {
      backgroundColor: green,
      boxShadow: "10px 10px 40px " + green25
    },
    error: {
      backgroundColor: theme.palette.error.main,
      boxShadow: "10px 10px 40px " + red25
    },
    info: {
      backgroundColor: 'white',
      color: theme.palette.text.primary,
      boxShadow: "10px 10px 40px " + dark10
    },
    warning: {
      backgroundColor: yellow,
      color: theme.palette.text.primary,
      boxShadow: "10px 10px 40px " + yellow25
    },
    messageError: {
      color: theme.palette.text.secondary
    }
  };
});

var CustomSnackBar = function CustomSnackBar(props) {
  var classes = useStyles$7();

  var className = props.className,
      message = props.message,
      variant = props.variant,
      open = props.open,
      other = __rest(props, ["className", "message", "variant", "open"]);

  return React.createElement(Snackbar, {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    open: open
  }, React.createElement(SnackbarContent, _assign({
    className: clsx(classes[variant], className),
    "aria-describedby": 'client-snackbar',
    message: React.createElement("span", {
      id: 'client-snackbar',
      className: variant === 'error' ? classes.messageError : ''
    }, message)
  }, other)));
};

var useStyle$k = makeStyles$1(function () {
  return {
    imageLabel: {
      position: 'absolute',
      top: 0,
      whiteSpace: 'nowrap',
      left: 'calc(50% - 57px)',
      backgroundColor: 'lightblue',
      zIndex: 1,
      padding: '4px 15px',
      borderBottomLeftRadius: 6,
      borderBottomRightRadius: 6,
      fontWeight: 600,
      color: '#fff',
      textTransform: 'uppercase'
    },
    brand: {
      backgroundColor: green
    },
    error: {
      backgroundColor: red
    },
    neutral: {
      backgroundColor: blue
    }
  };
});

var ImageLabel = function ImageLabel(props) {
  var text = props.text,
      type = props.type;
  var classes = useStyle$k();
  return React.createElement(Typography$1, {
    variant: 'caption',
    align: 'center',
    className: classes.imageLabel + " " + classes[type]
  }, text);
};

var MENU_SHRINKED_WIDTH = 62;
var MENU_EXPANDED_WIDTH = 240;
var useDrawerStyles = makeStyles$1(function (theme) {
  var _a;

  return {
    root: {
      display: 'flex'
    },
    drawer: (_a = {
      whiteSpace: 'nowrap'
    }, _a[theme.breakpoints.down('md')] = {
      width: 60
    }, _a[theme.breakpoints.down('xs')] = {
      width: 0
    }, _a),
    drawerRoot: {
      width: '100%',
      display: 'flex',
      backgroundColor: '#fff',
      border: 'none'
    },
    drawerPaperRoot: {
      padding: '8px 10px',
      borderRight: 'none',
      overflow: 'visible',
      '& > .MuiDivider-root:first-of-type': {
        marginTop: 64
      }
    },
    widthWhenExpanded: {
      width: MENU_EXPANDED_WIDTH
    },
    widthWhenShrinked: {
      width: MENU_SHRINKED_WIDTH
    },
    toggler: {
      backgroundColor: dark,
      borderRadius: '50%',
      cursor: 'pointer',
      position: 'absolute',
      top: 62,
      left: function left(_a) {
        var expanded = _a.expanded;
        return expanded ? MENU_EXPANDED_WIDTH - 10 : MENU_SHRINKED_WIDTH - 10;
      },
      zIndex: 2,
      maxWidth: 20,
      maxHeight: 20
    }
  };
}, {
  index: 1
});
var useStyleTooltip = makeStyles$1(function () {
  return {
    arrow: {
      color: dark,
      opacity: 100
    },
    tooltip: {
      fontSize: 14,
      backgroundColor: dark,
      opacity: 1
    }
  };
});
var useStyles$8 = makeStyles$1(function (theme) {
  var _a;

  return {
    list: (_a = {
      paddingTop: 0,
      paddingBottom: 8,
      marginTop: 16,
      width: '100%'
    }, _a[theme.breakpoints.down('md')] = {
      paddingTop: 0
    }, _a),
    listCollapse: {
      padding: 4,
      marginTop: 4
    },
    bottomList: {
      width: '100%',
      marginTop: 'auto',
      paddingBottom: 0,
      overflow: 'hidden',
      borderTop: "1px solid " + dark10
    },
    listLogoOpen: {
      width: 210,
      marginLeft: 5,
      paddingTop: 5
    },
    listLogoClosed: {
      width: 30,
      marginLeft: 5,
      paddingTop: 10
    },
    entered: {
      padding: 4
    },
    listItem: {
      color: dark50,
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      height: 40,
      width: 'auto',
      marginBottom: 8,
      marginRight: 0,
      padding: '0 4px',
      borderRadius: 6,
      transition: 'all 200ms ease-in-out',
      '&:last-child': {
        marginBottom: 0
      },
      '& > p': {
        color: dark75,
        cursor: 'pointer',
        fontWeight: 600,
        lineHeight: '20px',
        fontSize: 14
      },
      '&:hover': {
        background: dark5,
        color: dark,
        '& > p': {
          color: dark
        },
        '& svg path': {
          fill: dark
        }
      }
    },
    listItemAccordion: {
      height: 32
    },
    listItemAction: {
      justifyContent: 'center'
    },
    selectedListItem: {
      backgroundColor: 'rgba(72, 210, 160, 0.1) !important',
      '& svg path': {
        fill: green + " !important"
      },
      '& > p': {
        color: dark
      }
    },
    listItemIcon: {
      minWidth: 'unset',
      transition: 'padding 200ms ease-in-out'
    },
    listItemIconPaddingCollapsed: {
      paddingLeft: 6
    },
    listItemIconPaddingPage: {
      paddingLeft: 8
    },
    listItemIconPaddingSubpage: {
      paddingLeft: 16
    },
    listItemLabel: {
      paddingLeft: 8
    },
    badge: {
      '& .MuiBadge-dot': {
        minWidth: 6,
        height: 6
      }
    },
    indicatorContainer: {
      marginLeft: 'auto',
      paddingRight: 8,
      display: 'flex'
    },
    greenDot: {
      borderRadius: '50%',
      width: 6,
      height: 6,
      backgroundColor: green,
      marginRight: 8,
      marginLeft: 'auto'
    },
    white: {
      color: '#fff'
    },
    link: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      textDecoration: 'none'
    },
    // ACCORDION LIST WITH LOGO
    collapseContainer: {
      zIndex: 10,
      background: '#fff',
      position: 'fixed',
      top: 16,
      left: 10,
      minHeight: 40,
      borderRadius: 6,
      cursor: 'pointer',
      border: function border(_a) {
        var expanded = _a.expanded;
        return expanded ? '1px solid transparent' : "1px solid " + dark10;
      },
      transition: 'width 200ms ease-out',
      overflow: 'hidden',
      width: function width(_a) {
        var fullWidth = _a.fullWidth;
        return fullWidth ? 220 : 42;
      },
      boxShadow: function boxShadow(_a) {
        var expanded = _a.expanded;
        if (!expanded) return 'none';
        return '0px 0px 1px rgba(41, 56, 51, 0.24), 10px 10px 40px -5px rgba(41, 56, 51, 0.12)';
      }
    },
    collapseHeader: {
      height: 40,
      padding: 8,
      display: 'flex',
      alignItems: 'center',
      transition: 'all 200ms ease-out',
      marginBottom: function marginBottom(_a) {
        var expanded = _a.expanded,
            fullWidth = _a.fullWidth;
        if (expanded) return fullWidth ? 4 : 0;
        return 0;
      }
    },
    clientName: {
      marginLeft: 8,
      transition: 'all 200ms ease-out'
    },
    clientInfoHidden: {
      opacity: 0,
      display: 'none',
      width: 0
    },
    clientInfoShown: {
      opacity: 1,
      display: 'block',
      width: 'auto'
    },
    expandIcon: {
      marginRight: 4,
      marginLeft: 'auto',
      fontSize: '1.1rem',
      transition: 'none !important'
    },
    dropdownLabel: {
      fontWeight: 600
    },
    middle: {
      marginLeft: 3,
      marginRight: 3
    }
  };
}, {
  index: 1
});
var NavigationMenuContext = createContext(undefined);

var NavigationMenuBase = function NavigationMenuBase(_a) {
  var children = _a.children;
  var smallScreen = useMediaQuery('(max-width:1440px)', {
    noSsr: true
  });

  var _b = useState(!smallScreen),
      expanded = _b[0],
      setExpanded = _b[1];

  var classes = useDrawerStyles({
    expanded: expanded
  }); // set menu to expanded or shrinked depending on viewport width

  useEffect(function () {
    setExpanded(!smallScreen);
  }, [smallScreen]);

  var toggleExpanded = function toggleExpanded() {
    setExpanded(function (prev) {
      return !prev;
    });
  };

  var drawerProps = {
    open: true,
    classes: {
      root: expanded ? classes.widthWhenExpanded : classes.widthWhenShrinked,
      paper: clsx(classes.drawerPaperRoot, expanded ? classes.widthWhenExpanded : classes.widthWhenShrinked)
    },
    className: classes.drawer,
    variant: 'persistent'
  };
  var defaultContextValue = {
    expanded: expanded
  };
  return React.createElement(NavigationMenuContext.Provider, {
    value: defaultContextValue
  }, React.createElement("div", {
    className: classes.root
  }, React.createElement(Drawer, _assign({}, drawerProps), React.createElement(ChevronIcon, {
    direction: expanded ? 'left' : 'right',
    color: '#fff',
    onClick: toggleExpanded,
    className: classes.toggler
  }), children)));
};

var useNavigationMenu = function useNavigationMenu() {
  var context = useContext(NavigationMenuContext);
  if (!context) throw new Error('useNavigationMenu must be used within NavigationMenuContext');
  return context;
};

var AccountSwitcher = function AccountSwitcher(props) {
  return React.createElement(AccordionListWithLogo, _assign({}, props));
};

NavigationMenuBase.AccountSwitcher = AccountSwitcher;
NavigationMenuBase.AccountSwitcher.displayName = 'NavigationMenuBase.AccountSwitcher';

var NavigationItems = function NavigationItems(props) {
  return React.createElement(ListWithIcons, _assign({}, props));
};

NavigationMenuBase.NavigationItems = NavigationItems;
NavigationMenuBase.NavigationItems.displayName = 'NavigationMenuBase.NavigationItems';
var useStyle$l = makeStyles({
  logoWrapper: {
    overflow: 'hidden',
    borderRadius: 3,
    boxShadow: '0px 0px 1px rgba(41, 50, 65, 0.25)',
    minWidth: 24,
    minHeight: 24,
    width: 24,
    height: 24
  },
  logoImage: {
    minWidth: 24,
    maxWidth: '100%',
    height: 'auto'
  }
});

var LogoIcon = function LogoIcon(props) {
  var logosrc = props.logosrc,
      name = props.name;
  var classes = useStyle$l();
  return React.createElement("div", {
    className: classes.logoWrapper
  }, React.createElement("img", {
    src: logosrc,
    alt: name + " logo image",
    className: classes.logoImage
  }));
};

var AccordionListWithLogo = function AccordionListWithLogo(props) {
  var defaultClient = props.defaultClient,
      clients = props.clients,
      onClientChange = props.onClientChange,
      actions = props.actions;
  var open = useNavigationMenu().expanded;

  var _a = useState(false),
      expanded = _a[0],
      setExpanded = _a[1];

  var classes = useStyles$8({
    expanded: expanded,
    fullWidth: open
  });

  var onAccordionClicked = function onAccordionClicked() {
    setExpanded(!expanded);
  };

  return React.createElement("div", {
    className: classes.collapseContainer
  }, React.createElement("div", {
    className: classes.collapseHeader,
    onClick: onAccordionClicked
  }, React.createElement(LogoIcon, {
    logosrc: defaultClient.logosrc,
    name: defaultClient.name
  }), React.createElement(Typography$1, {
    variant: 'body2',
    className: clsx(classes.clientName, open ? classes.clientInfoShown : classes.clientInfoHidden)
  }, defaultClient.name), React.createElement(SortingIcon, {
    color: dark75,
    className: clsx(classes.expandIcon, open ? classes.clientInfoShown : classes.clientInfoHidden)
  })), React.createElement(Collapse, {
    in: expanded
  }, React.createElement(Divider, {
    variant: "middle",
    className: classes.middle
  }), React.createElement(List, {
    className: clsx(classes.list, classes.listCollapse)
  }, clients && clients.map(function (item, index) {
    return React.createElement(ListItem, {
      button: true,
      key: index,
      classes: {
        root: clsx(classes.listItem, classes.listItemCollapse, classes.listItemAccordion),
        selected: classes.selectedListItem
      },
      disableTouchRipple: true,
      onClick: function onClick() {
        return onClientChange === null || onClientChange === void 0 ? void 0 : onClientChange(item);
      }
    }, React.createElement(ListItemIcon, {
      classes: {
        root: clsx(classes.listItemIcon)
      }
    }, React.createElement(LogoIcon, {
      logosrc: item.logosrc,
      name: item.name
    })), open && React.createElement(Typography$1, {
      className: classes.listItemLabel
    }, item.name));
  }), actions.map(function (item, index) {
    return React.createElement(ListItem, {
      button: true,
      key: index,
      classes: {
        root: clsx(classes.listItem, classes.listItemCollapse, classes.listItemAction, classes.listItemAccordion),
        selected: classes.selectedListItem
      },
      disableTouchRipple: true,
      onClick: item.onClick
    }, React.createElement(ListItemIcon, {
      classes: {
        root: clsx(classes.listItemIcon)
      }
    }, React.createElement(item.icon, {
      color: dark75
    })), open && React.createElement(Typography$1, {
      className: classes.listItemLabel
    }, item.label));
  }))));
};

var toKebabCase = function toKebabCase(str) {
  return str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g).map(function (x) {
    return x.toLowerCase();
  }).join('-');
};

var ListWithIcons = function ListWithIcons(props) {
  var items = props.items,
      stickToBottom = props.stickToBottom;
  var open = useNavigationMenu().expanded;
  var classes = useStyles$8({});
  var location = useLocation();
  var toolTipClasses = useStyleTooltip();

  var _a = useState(false),
      fullWidth = _a[0],
      setFullWidth = _a[1];

  useEffect(function () {
    setFullWidth(open);
  }, [open]);
  return React.createElement(List, {
    className: stickToBottom ? classes.bottomList : classes.list
  }, items.map(function (item, index) {
    var _a;

    var selected = location.pathname.startsWith(item.route);
    return React.createElement(ListItem, {
      id: "ca-go-to-" + toKebabCase(item.label),
      key: index,
      classes: {
        root: classes.listItem,
        selected: classes.selectedListItem
      },
      disableTouchRipple: true,
      selected: selected,
      // @ts-ignore
      component: Link$1,
      to: item.route
    }, React.createElement(Tooltip$1, {
      title: fullWidth ? '' : item.label,
      classes: toolTipClasses,
      placement: "right",
      arrow: true
    }, React.createElement(Badge, {
      variant: 'dot',
      badgeContent: (_a = item.badge) !== null && _a !== void 0 ? _a : 1,
      color: 'primary',
      classes: {
        root: classes.badge
      },
      invisible: fullWidth || !item.badge
    }, React.createElement(ListItemIcon, {
      classes: {
        root: clsx(classes.listItemIcon, !open && classes.listItemIconPaddingCollapsed, open && !item.subpage && classes.listItemIconPaddingPage, open && item.subpage && classes.listItemIconPaddingSubpage)
      }
    }, React.createElement(item.icon, {
      color: dark75
    })))), fullWidth && React.createElement(Typography$1, {
      className: classes.listItemLabel
    }, item.label), fullWidth && !!item.badge && React.createElement("div", {
      className: classes.indicatorContainer
    }, typeof item.badge === 'boolean' ? React.createElement("div", {
      className: classes.greenDot
    }) : React.createElement(CaseTypeLabel, {
      labelText: item.badge.toString(),
      color: 'green'
    })));
  }));
};

function useFormInput(initialValue, validations) {
  if (validations === void 0) {
    validations = [];
  }

  var _a = useState(initialValue),
      value = _a[0],
      setValue = _a[1];

  var _b = useState(false),
      toBeValidated = _b[0],
      setToBeValidated = _b[1];

  var _c = useState(''),
      error = _c[0],
      setError = _c[1];

  function handleChange(e) {
    setValue(e.target.value);
  }

  useEffect(function () {
    _validate(value); // eslint-disable-next-line

  }, [value, toBeValidated]);

  function setInvalid(message) {
    setError(message);
  }

  function setValid() {
    setError('');
  }

  function _validate(valueToValidate, dirty) {
    if (valueToValidate === void 0) {
      valueToValidate = value;
    }

    if (dirty === void 0) {
      dirty = toBeValidated;
    }

    if (!dirty) return true;
    var errors = validations.reverse().map(function (validation) {
      return validation.regex.test(valueToValidate) ? true : setError(validation.message);
    });
    var allValidationsMatch = errors.every(function (item) {
      return item;
    });
    if (!allValidationsMatch) return false;
    setError('');
    return true;
  }

  function changeValue(newValue) {
    setValue(newValue);
  }

  return {
    attrs: {
      value: value,
      error: Boolean(error),
      onChange: handleChange
    },
    validate: function validate() {
      setToBeValidated(true);
      return _validate(value, true);
    },
    changeValue: changeValue,
    setValid: setValid,
    setInvalid: setInvalid
  };
}

var useRadioButtonStyle = makeStyles$1(function (theme) {
  return {
    labelRoot: {
      borderRadius: 6,
      border: "1px solid " + dark10,
      marginBottom: 8,
      marginLeft: '0px!important',
      marginRight: '0px!important'
    },
    radioRoot: {
      margin: 8,
      '& > span > input[type="radio"] + label': {
        width: 20,
        height: 20,
        borderRadius: 10,
        backgroundColor: theme.palette.grey['300'],
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: "1px solid " + dark10
      },
      '& > span > input[type="radio"] + label:after': {
        content: "''",
        width: 0,
        height: 0,
        borderRadius: 6,
        backgroundColor: green
      },
      '& > span > input[type="radio"]:checked + label:after': {
        width: 12,
        height: 12
      }
    },
    label: {
      fontWeight: 600
    }
  };
});

function RadioButton(props) {
  var id = props.id,
      value = props.value,
      label = props.label,
      other = __rest(props, ["id", "value", "label"]);

  var classes = useRadioButtonStyle();
  return React.createElement(FormControlLabel, _assign({
    value: value
  }, other, {
    classes: {
      root: classes.labelRoot
    },
    control: React.createElement(Radio, {
      disableRipple: true,
      color: 'primary',
      classes: {
        root: classes.radioRoot
      },
      icon: React.createElement("label", {
        htmlFor: id
      }),
      checkedIcon: React.createElement("label", {
        htmlFor: id
      })
    }),
    label: React.createElement(Typography$1, {
      className: classes.label,
      variant: 'body2'
    }, label)
  }));
}

var useStyle$m = makeStyles$1({
  dropdown: {
    position: 'relative',
    marginBottom: 8,
    minWidth: 330,
    '& > .MuiOutlinedInput-root': {
      backgroundColor: 'white',
      maxHeight: 'unset',
      '&:hover': {
        '& > fieldset': {
          borderColor: dark10
        }
      },
      '&.Mui-focused': {
        '& > fieldset': {
          borderColor: dark10,
          borderWidth: 1
        }
      }
    },
    '& .MuiSvgIcon-root': {
      width: '20px',
      height: '20px',
      marginRight: 16
    }
  },
  labelSelected: {
    '& > .MuiOutlinedInput-root': {
      backgroundColor: dark5,
      '& > .MuiSelect-select': {
        backgroundColor: dark5
      }
    }
  },
  label: {
    marginLeft: 40,
    fontSize: 14,
    fontWeight: 600,
    color: dark75,
    '&.Mui-focused': {
      color: dark75
    }
  },
  mockRadio: {
    position: 'absolute',
    zIndex: 200,
    border: 'none',
    pointerEvents: 'none'
  },
  select: {
    '&:focus': {
      border: 'inherit',
      backgroundColor: 'white'
    }
  },
  paper: {
    boxShadow: '0px 0px 1px rgba(41, 50, 65, 0.25), 10px 10px 40px rgba(41, 50, 65, 0.15)',
    borderRadius: 6,
    marginTop: 30
  },
  list: {
    paddingTop: 0,
    paddingBottom: 0,
    minWidth: 330,
    '& > li': {
      fontSize: 14,
      fontWeight: 600,
      color: dark50,
      margin: 10,
      borderRadius: 6,
      height: 40,
      '&:hover': {
        backgroundColor: dark5,
        color: dark75
      }
    }
  }
}); // apparently this component isn't being used anywhere

function Dropdown(props) {
  var values = props.values,
      mockRadio = props.mockRadio,
      handleSelect = props.handleSelect,
      defaultValue = props.defaultValue,
      idSelect = props.idSelect;

  var _a = useState(''),
      reason = _a[0],
      setReason = _a[1];

  var classes = useStyle$m();

  var handleChange = function handleChange(e) {
    var newReason = e.target.value;
    setReason(newReason);
    handleSelect(newReason);
  };

  return React.createElement(FormControl, {
    variant: "outlined",
    className: classes.dropdown
  }, mockRadio && React.createElement(RadioButton, {
    id: mockRadio.id,
    value: reason,
    checked: mockRadio.checked,
    onClick: function onClick(e) {
      return e.preventDefault();
    },
    label: '',
    className: classes.mockRadio
  }), React.createElement(InputLabel, {
    htmlFor: idSelect,
    disableAnimation: true,
    shrink: false,
    classes: {
      root: classes.label
    },
    style: {
      marginLeft: mockRadio ? 40 : 10
    }
  }, reason === '' ? defaultValue.name : values.map(function (item) {
    return item.id === reason ? item.name : '';
  })), React.createElement(Select, {
    value: '',
    onChange: handleChange,
    inputProps: {
      id: idSelect
    },
    classes: {
      root: classes.select
    },
    MenuProps: {
      classes: {
        paper: classes.paper,
        list: classes.list
      }
    },
    IconComponent: function IconComponent() {
      return React.createElement(ChevronIcon, {
        direction: 'down',
        color: dark75
      });
    }
  }, values.map(function (item) {
    return React.createElement(MenuItem, {
      key: item.id,
      value: item.id
    }, item.name);
  })));
}

var useStyle$n = makeStyles({
  dropdown: {
    '& label + .MuiInput-formControl': {
      marginTop: 0,
      '&:before': {
        display: 'none'
      },
      '&:after': {
        display: 'none'
      }
    },
    '& .Mui-focused, &:focus': {
      outline: 'none',
      border: "1px solid " + dark10 + "!important"
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: 'none'
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      border: "1px solid " + dark10
    }
  },
  label: {
    color: dark50,
    fontSize: 14,
    transform: 'none',
    top: 10,
    fontWeight: 600,
    '&.Mui-focused': {
      color: dark50
    }
  },
  labelVariant: {
    top: 17,
    left: 20
  },
  selectReason: {
    width: 100,
    '&:focus': {
      backgroundColor: 'transparent'
    }
  },
  selectIcon: {
    width: 16,
    marginRight: 12
  },
  paper: {
    boxShadow: '0px 0px 1px rgba(41, 50, 65, 0.25), 10px 10px 40px rgba(41, 50, 65, 0.15)'
  },
  list: {
    padding: 10,
    '& li': {
      fontWeight: 600,
      fontSize: 14,
      color: dark50,
      borderRadius: 6,
      paddingLeft: 10,
      '&:hover, &:focus': {
        color: dark75
      }
    }
  }
});

function PopupSelect(props) {
  var _a;

  var label = props.label,
      defaultValue = props.defaultValue,
      values = props.values,
      variant = props.variant,
      noIcon = props.noIcon;
  var classes = useStyle$n();

  var _b = useState(''),
      selected = _b[0],
      setSelected = _b[1];

  useEffect(function () {
    if (defaultValue) setSelected(defaultValue.value);
  }, [defaultValue]);

  var onSelect = function onSelect(event) {
    var selection = event.target.value;
    setSelected(selection);
  };

  return React.createElement(FormControl, {
    variant: variant,
    className: classes.dropdown
  }, React.createElement(InputLabel, {
    htmlFor: "selection",
    disableAnimation: true,
    shrink: false,
    className: clsx(classes.label, variant ? classes.labelVariant : '')
  }, selected === '' ? label : (_a = values.find(function (o) {
    return o.value === selected;
  })) === null || _a === void 0 ? void 0 : _a.label), React.createElement(Select, {
    value: '',
    onChange: onSelect,
    inputProps: {
      name: 'select',
      id: 'selection'
    },
    classes: {
      root: classes.selectReason
    },
    MenuProps: {
      classes: {
        paper: classes.paper,
        list: classes.list
      }
    },
    IconComponent: function IconComponent() {
      if (noIcon) return null;
      return React.createElement(ChevronIcon, {
        direction: 'down',
        color: dark75,
        className: classes.selectIcon
      });
    }
  }, values.map(function (item, key) {
    return React.createElement(MenuItem, {
      key: key,
      value: item.value
    }, item.label);
  })));
}

var useStyle$o = makeStyles({
  selectIcon: {
    cursor: 'pointer'
  },
  paper: {
    boxShadow: '0px 0px 1px rgba(41, 50, 65, 0.25), 10px 10px 40px rgba(41, 50, 65, 0.15)'
  },
  list: {
    padding: 10,
    '& li': {
      fontWeight: 600,
      fontSize: 14,
      color: dark50,
      borderRadius: 6,
      paddingLeft: 10,
      '&:hover, &:focus': {
        color: dark75
      }
    }
  }
});
var MenuDropdown = React.forwardRef(function (_a, ref) {
  var direction = _a.direction,
      children = _a.children;
  var classes = useStyle$o();

  var _b = React.useState(null),
      anchorEl = _b[0],
      setAnchorEl = _b[1];

  var open = Boolean(anchorEl);

  var handleClick = function handleClick(event) {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  return React.createElement("div", {
    ref: ref
  }, React.createElement(Row, {
    className: classes.selectIcon,
    onClick: handleClick
  }, React.createElement(DotsIcon, {
    direction: direction || 'horizontal',
    color: dark75
  })), React.createElement(Menu, {
    id: "simple-menu",
    keepMounted: true,
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    classes: {
      paper: classes.paper,
      list: classes.list
    }
  }, Array.isArray(children) ? children.map(function (child, index) {
    return React.cloneElement(child, {
      key: index,
      closeMenu: handleClose
    });
  }) : React.cloneElement(children, {
    closeMenu: handleClose
  })));
});
MenuDropdown.displayName = 'MenuDropdown';
var useStyle$p = makeStyles$1({
  item: {
    '& p': {
      fontSize: 14,
      fontWeight: 600,
      color: dark50,
      display: 'flex',
      alignItems: 'center'
    },
    '& .MuiTouchRipple-root': {
      display: 'none'
    }
  },
  highlighted: {
    '& svg': {
      fill: red,
      height: 15,
      width: 15,
      marginRight: 10
    },
    '& p': {
      color: red
    },
    '&:hover': {
      backgroundColor: red10
    }
  },
  separated: {
    position: 'relative',
    marginTop: 20,
    overflow: 'visible',
    '&::before': {
      display: 'block',
      height: 1,
      width: 'calc(100% - 20px)',
      backgroundColor: dark10,
      content: '""',
      position: 'absolute',
      top: -10
    }
  }
});
var MenuDropdownItem = forwardRef(function (props, ref) {
  var children = props.children,
      separated = props.separated,
      highlighted = props.highlighted,
      onClick = props.onClick,
      closeMenu = props.closeMenu;
  var classes = useStyle$p();

  var handleClick = function handleClick(event) {
    event.stopPropagation();
    onClick === null || onClick === void 0 ? void 0 : onClick();
    closeMenu === null || closeMenu === void 0 ? void 0 : closeMenu();
  };

  return React.createElement(MenuItem, {
    ref: ref,
    onClick: handleClick,
    className: clsx(classes.item, highlighted ? classes.highlighted : '', separated ? classes.separated : '')
  }, Array.isArray(children) ? children.map(function (child, index) {
    return React.createElement(Fragment, {
      key: "nav-" + index
    }, child);
  }) : children);
});
MenuDropdownItem.displayName = 'MenuDropdownItem';

var SearchInput = function SearchInput(props) {
  return React.createElement(Input, _assign({
    inputProps: {
      startAdornment: React.createElement(InputAdornment, {
        position: "start",
        style: {
          marginTop: 0,
          marginRight: 0
        }
      }, React.createElement(SearchIcon, {
        color: props.disabled ? dark25 : dark75
      })),
      style: {
        paddingLeft: 8
      }
    }
  }, props));
};

var textLabelColors = {
  blue: {
    backgroundColor: blue10,
    color: blue
  },
  grey: {
    backgroundColor: dark10,
    color: dark75
  },
  red: {
    backgroundColor: red,
    color: '#fff'
  },
  green: {
    backgroundColor: green,
    color: '#fff'
  },
  white: {
    backgroundColor: '#fff',
    color: '#989F9D',
    border: '1px solid #E5E7E6'
  },
  yellow: {
    backgroundColor: 'rgba(248, 160, 28, 0.1)',
    color: '#F8A01C'
  },
  purple: {
    backgroundColor: purple,
    color: '#fff'
  }
}; // for white variants, the padding must always be 1px smaller because of border

var labelPadding = {
  small: {
    nonWhite: '3px 8px',
    white: '2px 7px'
  },
  medium: {
    nonWhite: '4px 12px',
    white: '3px 11px'
  },
  thick: {
    nonWhite: '10px 12px',
    white: '9px 11px'
  }
};
var useStyles$9 = makeStyles$1({
  label: {
    margin: '0px 5px',
    borderRadius: 6,
    fontWeight: 700,
    fontSize: function fontSize(_a) {
      var size = _a.size;
      return size === 'small' ? 10 : 14;
    },
    lineHeight: function lineHeight(_a) {
      var size = _a.size;
      return size === 'small' ? '14px' : '20px';
    },
    padding: function padding(_a) {
      var size = _a.size,
          color = _a.color;
      return color === 'white' ? labelPadding[size].white : labelPadding[size].nonWhite;
    },
    textTransform: function textTransform(_a) {
      var uppercase = _a.uppercase;
      return uppercase ? 'uppercase' : 'none';
    },
    cursor: function cursor(_a) {
      var onClick = _a.onClick;
      return onClick ? 'pointer' : 'inherit';
    }
  }
});

var TextLabel = function TextLabel(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 'medium' : _b,
      _c = _a.color,
      color = _c === void 0 ? 'grey' : _c,
      labelText = _a.labelText,
      uppercase = _a.uppercase,
      className = _a.className,
      onClick = _a.onClick;
  var classes = useStyles$9({
    size: size,
    uppercase: uppercase,
    color: color,
    onClick: onClick
  });
  return React.createElement(Typography$1, {
    onClick: onClick,
    className: clsx(classes.label, className),
    style: _assign({}, textLabelColors[color])
  }, labelText);
};

var caseTypeLabelColors = {
  blue: {
    backgroundColor: blue
  },
  purple: {
    backgroundColor: purple
  },
  grey: {
    backgroundColor: dark50
  },
  red: {
    backgroundColor: red
  },
  yellow: {
    backgroundColor: yellow
  },
  green: {
    backgroundColor: green
  },
  white: {
    backgroundColor: '#fff'
  }
};
var useStyles$a = makeStyles$1({
  chipContainer: {
    textTransform: 'uppercase',
    fontSize: 10,
    textAlign: 'center'
  },
  rightChip: {
    fontWeight: 700,
    color: 'white',
    lineHeight: '14px',
    borderRadius: '6px 0 0 6px',
    padding: '3px 8px'
  },
  leftChip: {
    width: 20,
    color: 'white',
    lineHeight: '14px',
    borderRadius: '0 6px 6px 0',
    padding: '3px 4px'
  },
  fullBorderRadius: {
    borderRadius: '6px',
    padding: '3px 8px'
  }
});

var CaseTypeLabel = function CaseTypeLabel(_a) {
  var _b = _a.color,
      color = _b === void 0 ? 'grey' : _b,
      labelText = _a.labelText,
      isSoftClaim = _a.isSoftClaim;
  var classes = useStyles$a();
  return React.createElement(Row, {
    className: classes.chipContainer
  }, React.createElement(Typography$1, {
    variant: "caption",
    className: clsx(classes.rightChip, !isSoftClaim && classes.fullBorderRadius),
    style: _assign({}, caseTypeLabelColors[color])
  }, labelText), isSoftClaim ? React.createElement(Typography$1, {
    variant: "caption",
    className: classes.leftChip,
    style: _assign({}, caseTypeLabelColors.yellow)
  }, "SC") : React.createElement(React.Fragment, null));
};

export { AccordionListWithLogo, BreadcrumbsBanner, CaseTypeLabel, Checkbox, Col, CopyrightAgentLoader, CustomSnackBar, DangerButton, DisplayFilterSelect, DisplayFilterSelects, DownloadCsv, Dropdown, DropdownSelect, ExtraActionButton, ExtraActionOffsetButton, FilterPopover, FilterSearch, index as Icons, ImageComponent, ImageLabel, InfiniteLoader, InfoIconWithTooltip, Input, InvisibleButton, ListItemCounter, ListRender, ListWithIcons, Logo$1 as Logo, LogoIcon, MenuDropdown, MenuDropdownItem, Modal, ModalSection, NavigationMenuBase, Page, PageBody, PageContainer, PageTitle, CustomPopover as Popover, PopupSelect, PrimaryButton, PrimaryOffsetButton, RadioButton, RightPlaceholder, Row, SearchBar, SearchInput, SecondaryButton, SelectTemplate, SlimPage, SlimPageBody, SlimPageTitle, SubMenu, SubmitButton, TextArea, TextLabel, ToggleButton, Typography, localButtonStyle$3 as dangerButtonStyle, localButtonStyle$5 as extraActionButtonStyle, localButtonStyle$7 as extraActionOffsetButtonStyle, localButtonStyle$6 as invisibleButtonStyle, localButtonStyle as primaryButtonStyle, localButtonStyle$1 as primaryOffsetButtonStyle, localButtonStyle$2 as secondaryButtonStyle, localButtonStyle$4 as submitButtonStyle, useFormInput, useNavigationMenu };